{
    "0": {
        "msgType": "0",
        "category": { "FIXMLFileName": "session", "section": "Session", "componentType": "Message", "name": "Session" },
        "added": "FIX.2.7",
        "name": "Heartbeat",
        "id": "1",
        "abbrName": "Heartbeat",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Session",
            "FIXMLFileName": "session",
            "displayOrder": "0",
            "description": "Session level messages to establish and control a FIX session"
        },
        "description": "The Heartbeat monitors the status of the communication link and identifies when the last of a string of messages was not received."
    },
    "1": {
        "msgType": "1",
        "category": { "FIXMLFileName": "session", "section": "Session", "componentType": "Message", "name": "Session" },
        "added": "FIX.2.7",
        "name": "TestRequest",
        "id": "2",
        "abbrName": "TestRequest",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "112",
                "added": "FIX.4.0",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "TestReqID",
                    "added": "FIX.3.0",
                    "name": "TestReqID",
                    "id": "112",
                    "description": "Identifier included in Test Request message to be returned in resulting Heartbeat"
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Session",
            "FIXMLFileName": "session",
            "displayOrder": "0",
            "description": "Session level messages to establish and control a FIX session"
        },
        "description": "The test request message forces a heartbeat from the opposing application. The test request message checks sequence numbers or verifies communication line status. The opposite application responds to the Test Request with a Heartbeat containing the TestReqID."
    },
    "2": {
        "msgType": "2",
        "category": { "FIXMLFileName": "session", "section": "Session", "componentType": "Message", "name": "Session" },
        "added": "FIX.2.7",
        "name": "ResendRequest",
        "id": "3",
        "abbrName": "ResendRequest",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "7",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "SeqNum",
                    "abbrName": "BeginSeqNo",
                    "added": "FIX.2.7",
                    "name": "BeginSeqNo",
                    "id": "7",
                    "description": "Message sequence number of first message in range to be resent"
                }
            },
            {
                "id": "16",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "SeqNum",
                    "abbrName": "EndSeqNo",
                    "added": "FIX.2.7",
                    "name": "EndSeqNo",
                    "id": "16",
                    "description": "Message sequence number of last message in range to be resent. If request is for a single message BeginSeqNo (7) = EndSeqNo. If request is for all messages subsequent to a particular message, EndSeqNo = \"0\" (representing infinity)."
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Session",
            "FIXMLFileName": "session",
            "displayOrder": "0",
            "description": "Session level messages to establish and control a FIX session"
        },
        "description": "The resend request is sent by the receiving application to initiate the retransmission of messages. This function is utilized if a sequence number gap is detected, if the receiving application lost a message, or as a function of the initialization process."
    },
    "3": {
        "msgType": "3",
        "category": { "FIXMLFileName": "session", "section": "Session", "componentType": "Message", "name": "Session" },
        "added": "FIX.2.7",
        "name": "Reject",
        "id": "4",
        "abbrName": "Reject",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "45",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "SeqNum",
                    "abbrName": "RefSeqNum",
                    "added": "FIX.2.7",
                    "name": "RefSeqNum",
                    "id": "45",
                    "description": "Reference message sequence number"
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Session",
            "FIXMLFileName": "session",
            "displayOrder": "0",
            "description": "Session level messages to establish and control a FIX session"
        },
        "description": "The reject message should be issued when a message is received but cannot be properly processed due to a session-level rule violation. An example of when a reject may be appropriate would be the receipt of a message with invalid basic data which successfully passes de-encryption, CheckSum and BodyLength checks."
    },
    "4": {
        "msgType": "4",
        "category": { "FIXMLFileName": "session", "section": "Session", "componentType": "Message", "name": "Session" },
        "added": "FIX.2.7",
        "name": "SequenceReset",
        "id": "5",
        "abbrName": "SequenceReset",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "36",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "SeqNum",
                    "abbrName": "NewSeqNo",
                    "added": "FIX.2.7",
                    "name": "NewSeqNo",
                    "id": "36",
                    "description": "New sequence number"
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Session",
            "FIXMLFileName": "session",
            "displayOrder": "0",
            "description": "Session level messages to establish and control a FIX session"
        },
        "description": "The sequence reset message is used by the sending application to reset the incoming sequence number on the opposing side."
    },
    "5": {
        "msgType": "5",
        "category": { "FIXMLFileName": "session", "section": "Session", "componentType": "Message", "name": "Session" },
        "added": "FIX.2.7",
        "name": "Logout",
        "id": "6",
        "abbrName": "Logout",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Session",
            "FIXMLFileName": "session",
            "displayOrder": "0",
            "description": "Session level messages to establish and control a FIX session"
        },
        "description": "The logout message initiates or confirms the termination of a FIX session. Disconnection without the exchange of logout messages should be interpreted as an abnormal condition."
    },
    "6": {
        "msgType": "6",
        "category": {
            "FIXMLFileName": "indications",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "Indication"
        },
        "added": "FIX.2.7",
        "name": "IOI",
        "id": "7",
        "abbrName": "IOI",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "23",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "Indication",
                    "added": "FIX.2.7",
                    "name": "IOIID",
                    "id": "23",
                    "abbrName": "IOIID",
                    "description": "Unique identifier of IOI message.\n\n(Prior to FIX 4.1 this field was of type int)"
                }
            },
            {
                "id": "27",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "IOIQtyCodeSet",
                    "unionDataType": "Qty",
                    "added": "FIX.2.7",
                    "name": "IOIQty",
                    "id": "27",
                    "abbrName": "Qty",
                    "description": "Quantity (e.g. number of shares) in numeric form or relative size."
                }
            },
            {
                "id": "28",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "IOITransTypeCodeSet",
                    "abbrName": "TransTyp",
                    "added": "FIX.2.7",
                    "name": "IOITransType",
                    "id": "28",
                    "description": "Identifies IOI message transaction type"
                }
            },
            {
                "id": "54",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "name": "Side",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "Indication of interest messages are used to market merchandise which the broker is buying or selling in either a proprietary or agency capacity. The indications can be time bound with a specific expiration value. Indications are distributed with the understanding that other firms may react to the message first and that the merchandise may no longer be available due to prior trade.\n\nIndication messages can be transmitted in various transaction types; NEW, CANCEL, and REPLACE. All message types other than NEW modify the state of the message identified in IOIRefID."
    },
    "7": {
        "msgType": "7",
        "category": {
            "FIXMLFileName": "indications",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "Indication"
        },
        "added": "FIX.2.7",
        "name": "Advertisement",
        "id": "8",
        "abbrName": "Adv",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "2",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "AdvId",
                    "added": "FIX.2.7",
                    "name": "AdvId",
                    "id": "2",
                    "description": "Unique identifier of advertisement message.\n\n(Prior to FIX 4.1 this field was of type int)"
                }
            },
            {
                "id": "4",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "AdvSideCodeSet",
                    "abbrName": "AdvSide",
                    "added": "FIX.2.7",
                    "name": "AdvSide",
                    "id": "4",
                    "description": "Broker's side of advertised trade"
                }
            },
            {
                "id": "5",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "AdvTransTypeCodeSet",
                    "abbrName": "AdvTransTyp",
                    "added": "FIX.2.7",
                    "name": "AdvTransType",
                    "id": "5",
                    "description": "Identifies advertisement message transaction type"
                }
            },
            {
                "id": "53",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "Qty",
                    "abbrName": "Qty",
                    "added": "FIX.2.7",
                    "name": "Quantity",
                    "id": "53",
                    "description": "Overall/total quantity (e.g. number of shares)\n\n(Prior to FIX 4.2 this field was of type int)"
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "Advertisement messages are used to announce completed transactions. The advertisement message can be transmitted in various transaction types; NEW, CANCEL and REPLACE. All message types other than NEW modify the state of a previously transmitted advertisement identified in AdvRefID."
    },
    "8": {
        "msgType": "8",
        "category": {
            "FIXMLFileName": "order",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "SingleGeneralOrderHandling"
        },
        "added": "FIX.2.7",
        "name": "ExecutionReport",
        "id": "9",
        "abbrName": "ExecRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "14",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "Qty",
                    "abbrName": "CumQty",
                    "added": "FIX.2.7",
                    "name": "CumQty",
                    "id": "14",
                    "description": "Total quantity (e.g. number of shares) filled.\n\n(Prior to FIX 4.2 this field was of type int)"
                }
            },
            {
                "updatedEP": "188",
                "updated": "FIX.5.0SP2",
                "id": "17",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "String",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "95",
                    "added": "FIX.2.7",
                    "name": "ExecID",
                    "id": "17",
                    "abbrName": "ExecID",
                    "description": "Unique identifier of execution message as assigned by sell-side (broker, exchange, ECN) (will be 0 (zero) for ExecType (150)=I (Order Status)).\n\nUniqueness must be guaranteed within a single trading day or the life of a multi-day order. Firms which accept multi-day orders should consider embedding a date within the ExecID field to assure uniqueness across days.\n\n(Prior to FIX 4.1 this field was of type int)."
                }
            },
            {
                "id": "37",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "OrdID",
                    "added": "FIX.2.7",
                    "name": "OrderID",
                    "id": "37",
                    "description": "Unique identifier for Order as assigned by sell-side (broker, exchange, ECN). Uniqueness must be guaranteed within a single trading day. Firms which accept multi-day orders should consider embedding a date within the OrderID field to assure uniqueness across days."
                }
            },
            {
                "id": "39",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "OrdStatusCodeSet",
                    "baseCategoryAbbrName": "Stat",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "added": "FIX.2.7",
                    "name": "OrdStatus",
                    "id": "39",
                    "abbrName": "OrdStat",
                    "description": "Identifies current status of order. *** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" *** (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "54",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "name": "Side",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "150",
                "added": "FIX.4.1",
                "presence": "required",
                "data": {
                    "type": "ExecTypeCodeSet",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "131",
                    "added": "FIX.4.1",
                    "name": "ExecType",
                    "id": "150",
                    "abbrName": "ExecTyp",
                    "description": "Describes the specific ExecutionRpt (e.g. Pending Cancel) while OrdStatus(39) will always identify the current order status (e.g. Partially Filled)."
                }
            },
            {
                "updatedEP": "188",
                "updated": "FIX.5.0SP2",
                "id": "151",
                "added": "FIX.4.1",
                "presence": "required",
                "data": {
                    "type": "Qty",
                    "abbrName": "LeavesQty",
                    "added": "FIX.4.1",
                    "name": "LeavesQty",
                    "id": "151",
                    "description": "Quantity open for further execution. If the OrdStatus (39) is Canceled, DoneForTheDay, Expired, Calculated, or Rejected (in which case the order is no longer active) then LeavesQty could be 0, otherwise LeavesQty = OrderQty (38) - CumQty (14).\n\n(Prior to FIX 4.2 this field was of type int)"
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "updatedEP": "188",
                "updated": "FIX.5.0SP2",
                "id": "1003",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The execution report message is used to:\n\n1. confirm the receipt of an order\n\n2. confirm changes to an existing order (i.e. accept cancel and replace requests)\n\n3. relay order status information\n\n4. relay fill information on working orders\n\n5. relay fill information on tradeable or restricted tradeable quotes\n\n6. reject orders\n\n7. report post-trade fees calculations associated with a trade"
    },
    "9": {
        "msgType": "9",
        "category": {
            "FIXMLFileName": "order",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "SingleGeneralOrderHandling"
        },
        "added": "FIX.2.7",
        "name": "OrderCancelReject",
        "id": "10",
        "abbrName": "OrdCxlRej",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "11",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "String",
                    "updated": "FIX.Latest",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "updatedEP": "282",
                    "added": "FIX.2.7",
                    "name": "ClOrdID",
                    "id": "11",
                    "abbrName": "ClOrdID",
                    "description": "Unique identifier for Order as assigned by the buy-side (institution, broker, intermediary etc.) (identified by SenderCompID(49) or OnBehalfOfCompID(115) as appropriate). Uniqueness must be guaranteed within a single trading day. Firms, particularly those which electronically submit multi-day orders, trade globally or throughout market close periods, should ensure uniqueness across days, for example by embedding a date within the ClOrdID(11) field."
                }
            },
            {
                "id": "37",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "OrdID",
                    "added": "FIX.2.7",
                    "name": "OrderID",
                    "id": "37",
                    "description": "Unique identifier for Order as assigned by sell-side (broker, exchange, ECN). Uniqueness must be guaranteed within a single trading day. Firms which accept multi-day orders should consider embedding a date within the OrderID field to assure uniqueness across days."
                }
            },
            {
                "id": "39",
                "added": "FIX.4.1",
                "presence": "required",
                "data": {
                    "type": "OrdStatusCodeSet",
                    "baseCategoryAbbrName": "Stat",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "added": "FIX.2.7",
                    "name": "OrdStatus",
                    "id": "39",
                    "abbrName": "OrdStat",
                    "description": "Identifies current status of order. *** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" *** (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "434",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "CxlRejResponseToCodeSet",
                    "abbrName": "CxlRejRspTo",
                    "added": "FIX.4.2",
                    "name": "CxlRejResponseTo",
                    "id": "434",
                    "description": "Identifies the type of request that a Cancel Reject is in response to."
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The order cancel reject message is issued by the broker upon receipt of a cancel request or cancel/replace request message which cannot be honored."
    },
    "A": {
        "msgType": "A",
        "category": { "FIXMLFileName": "session", "section": "Session", "componentType": "Message", "name": "Session" },
        "added": "FIX.2.7",
        "name": "Logon",
        "id": "11",
        "abbrName": "Logon",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "98",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "EncryptMethodCodeSet",
                    "abbrName": "EncryptMethod",
                    "added": "FIX.2.7",
                    "name": "EncryptMethod",
                    "id": "98",
                    "description": "Method of encryption."
                }
            },
            {
                "id": "108",
                "added": "FIX.3.0",
                "presence": "required",
                "data": {
                    "type": "int",
                    "abbrName": "HeartBtInt",
                    "added": "FIX.3.0",
                    "name": "HeartBtInt",
                    "id": "108",
                    "description": "Heartbeat interval (seconds)"
                }
            },
            {
                "id": "1137",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "ApplVerIDCodeSet",
                    "addedEP": "16",
                    "added": "FIX.4.4",
                    "name": "DefaultApplVerID",
                    "id": "1137",
                    "abbrName": "DefApplVerID",
                    "description": "Specifies the service pack release being applied, by default, to message at the session level. Enumerated field with values assigned at time of service pack release. Uses same values as ApplVerID"
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Session",
            "FIXMLFileName": "session",
            "displayOrder": "0",
            "description": "Session level messages to establish and control a FIX session"
        },
        "description": "The logon message authenticates a user establishing a connection to a remote system. The logon message must be the first message sent by the application requesting to initiate a FIX session."
    },
    "B": {
        "msgType": "B",
        "category": {
            "FIXMLFileName": "newsevents",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "EventCommunication"
        },
        "added": "FIX.2.7",
        "name": "News",
        "id": "12",
        "abbrName": "News",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "148",
                "added": "FIX.4.1",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "Headline",
                    "added": "FIX.4.1",
                    "name": "Headline",
                    "id": "148",
                    "description": "The headline of a News message"
                }
            },
            {
                "id": "2029",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "Common",
                    "added": "FIX.4.4",
                    "name": "LinesOfTextGrp",
                    "id": "2029",
                    "abbrName": "TxtLn",
                    "numInGroup": { "id": "33", "added": "FIX.4.4" },
                    "fieldRef": [
                        {
                            "id": "58",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Repeating field, number of instances defined in LinesOfText",
                            "name": "Text"
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The news message is a general free format message between the broker and institution. The message contains flags to identify the news item's urgency and to allow sorting by subject company (symbol). The News message can be originated at either the broker or institution side, or exchanges and other marketplace venues."
    },
    "C": {
        "msgType": "C",
        "category": {
            "FIXMLFileName": "newsevents",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "EventCommunication"
        },
        "added": "FIX.2.7",
        "name": "Email",
        "id": "13",
        "abbrName": "Email",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "94",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "EmailTypeCodeSet",
                    "abbrName": "EmailTyp",
                    "added": "FIX.2.7",
                    "name": "EmailType",
                    "id": "94",
                    "description": "Email message type."
                }
            },
            {
                "id": "147",
                "added": "FIX.4.1",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "Subject",
                    "added": "FIX.4.1",
                    "name": "Subject",
                    "id": "147",
                    "description": "The subject of an Email message"
                }
            },
            {
                "id": "164",
                "added": "FIX.4.1",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "EmailThreadID",
                    "added": "FIX.4.1",
                    "name": "EmailThreadID",
                    "id": "164",
                    "description": "Unique identifier for an email thread (new and chain of replies)"
                }
            },
            {
                "id": "2029",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "Common",
                    "added": "FIX.4.4",
                    "name": "LinesOfTextGrp",
                    "id": "2029",
                    "abbrName": "TxtLn",
                    "numInGroup": { "id": "33", "added": "FIX.4.4" },
                    "fieldRef": [
                        {
                            "id": "58",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Repeating field, number of instances defined in LinesOfText",
                            "name": "Text"
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The email message is similar to the format and purpose of the News message, however, it is intended for private use between two parties."
    },
    "D": {
        "msgType": "D",
        "category": {
            "FIXMLFileName": "order",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "SingleGeneralOrderHandling"
        },
        "added": "FIX.2.7",
        "name": "NewOrderSingle",
        "id": "14",
        "abbrName": "Order",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "11",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "String",
                    "updated": "FIX.Latest",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "updatedEP": "282",
                    "added": "FIX.2.7",
                    "name": "ClOrdID",
                    "id": "11",
                    "abbrName": "ClOrdID",
                    "description": "Unique identifier for Order as assigned by the buy-side (institution, broker, intermediary etc.) (identified by SenderCompID(49) or OnBehalfOfCompID(115) as appropriate). Uniqueness must be guaranteed within a single trading day. Firms, particularly those which electronically submit multi-day orders, trade globally or throughout market close periods, should ensure uniqueness across days, for example by embedding a date within the ClOrdID(11) field."
                }
            },
            {
                "id": "40",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "OrdTypeCodeSet",
                    "baseCategoryAbbrName": "Typ",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "added": "FIX.2.7",
                    "name": "OrdType",
                    "id": "40",
                    "abbrName": "OrdTyp",
                    "description": "Order type. *** SOME VALUES ARE NO LONGER USED - See \"Deprecated (Phased-out) Features and Supported Approach\" *** (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "54",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "name": "Side",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "60",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            },
            {
                "updatedEP": "221",
                "updated": "FIX.5.0SP2",
                "id": "1011",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "OrderQtyData",
                    "id": "1011",
                    "abbrName": "OrdQty",
                    "description": "The OrderQtyData component block contains the fields commonly used for indicating the amount or quantity of an order. Note that when this component block is marked as \"required\" in a message either one of these three fields must be used to identify the amount: OrderQty, CashOrderQty or OrderPercent (in the case of CIV).\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The new order message type is used by institutions wishing to electronically submit securities and forex orders to a broker for execution.\n\nThe New Order message type may also be used by institutions or retail intermediaries wishing to electronically submit Collective Investment Vehicle (CIV) orders to a broker or fund manager for execution."
    },
    "E": {
        "msgType": "E",
        "category": {
            "FIXMLFileName": "listorders",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "ProgramTrading"
        },
        "added": "FIX.2.7",
        "name": "NewOrderList",
        "id": "15",
        "abbrName": "NewOrdList",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "66",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "ProgramTrading",
                    "added": "FIX.2.7",
                    "name": "ListID",
                    "id": "66",
                    "abbrName": "ListID",
                    "description": "Unique identifier for list as assigned by institution, used to associate multiple individual orders. Uniqueness must be guaranteed within a single trading day. Firms which generate multi-day orders should consider embedding a date within the ListID field to assure uniqueness across days."
                }
            },
            {
                "id": "68",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "int",
                    "abbrName": "TotNoOrds",
                    "added": "FIX.2.7",
                    "name": "TotNoOrders",
                    "id": "68",
                    "description": "Total number of list order entries across all messages. Should be the sum of all NoOrders (73) in each message that has repeating list order entries related to the same ListID (66). Used to support fragmentation.\n\n(Prior to FIX 4.2 this field was named \"ListNoOrds\")"
                }
            },
            {
                "id": "394",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "BidTypeCodeSet",
                    "abbrName": "BidTyp",
                    "added": "FIX.4.2",
                    "name": "BidType",
                    "id": "394",
                    "description": "Code to identify the type of Bid Request."
                }
            },
            {
                "id": "2030",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "ProgramTrading",
                    "added": "FIX.4.4",
                    "name": "ListOrdGrp",
                    "id": "2030",
                    "abbrName": "Ord",
                    "numInGroup": { "id": "73", "added": "FIX.4.4" },
                    "fieldRef": [
                        {
                            "id": "11",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Must be the first field in the repeating group.",
                            "name": "ClOrdID"
                        },
                        {
                            "id": "67",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Order number within the list",
                            "name": "ListSeqNo"
                        },
                        {
                            "id": "54",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Note: to indicate the side of SideValue1 or SideValue2, specify Side=Undisclosed and SideValueInd=either the SideValue1 or SideValue2 indicator.",
                            "name": "Side"
                        }
                    ],
                    "componentRef": [
                        {
                            "id": "1003",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Insert here the set of \"Instrument\" (symbology) fields defined in \"Common Components of Application Messages\""
                        },
                        {
                            "id": "1011",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Insert here the set of \"OrderQtyData\" fields defined in \"Common Components of Application Messages\""
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The NewOrderList Message can be used in one of two ways depending on which market conventions are being followed."
    },
    "F": {
        "msgType": "F",
        "category": {
            "FIXMLFileName": "order",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "SingleGeneralOrderHandling"
        },
        "added": "FIX.2.7",
        "name": "OrderCancelRequest",
        "id": "16",
        "abbrName": "OrdCxlReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "11",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "String",
                    "updated": "FIX.Latest",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "updatedEP": "282",
                    "added": "FIX.2.7",
                    "name": "ClOrdID",
                    "id": "11",
                    "abbrName": "ClOrdID",
                    "description": "Unique identifier for Order as assigned by the buy-side (institution, broker, intermediary etc.) (identified by SenderCompID(49) or OnBehalfOfCompID(115) as appropriate). Uniqueness must be guaranteed within a single trading day. Firms, particularly those which electronically submit multi-day orders, trade globally or throughout market close periods, should ensure uniqueness across days, for example by embedding a date within the ClOrdID(11) field."
                }
            },
            {
                "id": "54",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "name": "Side",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "60",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The order cancel request message requests the cancellation of all of the remaining quantity of an existing order. Note that the Order Cancel/Replace Request should be used to partially cancel (reduce) an order)."
    },
    "G": {
        "msgType": "G",
        "category": {
            "FIXMLFileName": "order",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "SingleGeneralOrderHandling"
        },
        "added": "FIX.2.7",
        "name": "OrderCancelReplaceRequest",
        "id": "17",
        "abbrName": "OrdCxlRplcReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updatedEP": "282",
                "updated": "FIX.Latest",
                "id": "11",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "String",
                    "updated": "FIX.Latest",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "updatedEP": "282",
                    "added": "FIX.2.7",
                    "name": "ClOrdID",
                    "id": "11",
                    "abbrName": "ClOrdID",
                    "description": "Unique identifier for Order as assigned by the buy-side (institution, broker, intermediary etc.) (identified by SenderCompID(49) or OnBehalfOfCompID(115) as appropriate). Uniqueness must be guaranteed within a single trading day. Firms, particularly those which electronically submit multi-day orders, trade globally or throughout market close periods, should ensure uniqueness across days, for example by embedding a date within the ClOrdID(11) field."
                }
            },
            {
                "id": "40",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "OrdTypeCodeSet",
                    "baseCategoryAbbrName": "Typ",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "added": "FIX.2.7",
                    "name": "OrdType",
                    "id": "40",
                    "abbrName": "OrdTyp",
                    "description": "Order type. *** SOME VALUES ARE NO LONGER USED - See \"Deprecated (Phased-out) Features and Supported Approach\" *** (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "54",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "name": "Side",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "60",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            },
            {
                "updatedEP": "221",
                "updated": "FIX.5.0SP2",
                "id": "1011",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "OrderQtyData",
                    "id": "1011",
                    "abbrName": "OrdQty",
                    "description": "The OrderQtyData component block contains the fields commonly used for indicating the amount or quantity of an order. Note that when this component block is marked as \"required\" in a message either one of these three fields must be used to identify the amount: OrderQty, CashOrderQty or OrderPercent (in the case of CIV).\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The order cancel/replace request is used to change the parameters of an existing order.\n\nDo not use this message to cancel the remaining quantity of an outstanding order, use the Order Cancel Request message for this purpose."
    },
    "H": {
        "msgType": "H",
        "category": {
            "FIXMLFileName": "order",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "SingleGeneralOrderHandling"
        },
        "added": "FIX.2.7",
        "name": "OrderStatusRequest",
        "id": "18",
        "abbrName": "OrdStatReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "54",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "name": "Side",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The order status request message is used by the institution to generate an order status message back from the broker."
    },
    "J": {
        "updated": "FIX.Latest",
        "msgType": "J",
        "updatedEP": "291",
        "category": {
            "FIXMLFileName": "allocation",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "Allocation"
        },
        "added": "FIX.2.7",
        "name": "AllocationInstruction",
        "id": "19",
        "abbrName": "AllocInstrctn",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "53",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "Qty",
                    "abbrName": "Qty",
                    "added": "FIX.2.7",
                    "name": "Quantity",
                    "id": "53",
                    "description": "Overall/total quantity (e.g. number of shares)\n\n(Prior to FIX 4.2 this field was of type int)"
                }
            },
            {
                "id": "54",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "name": "Side",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "70",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "Allocation",
                    "added": "FIX.2.7",
                    "name": "AllocID",
                    "id": "70",
                    "abbrName": "AllocID",
                    "description": "Unique identifier for allocation message.\n\n(Prior to FIX 4.1 this field was of type int)"
                }
            },
            {
                "updatedEP": "285",
                "updated": "FIX.Latest",
                "id": "71",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "AllocTransTypeCodeSet",
                    "abbrName": "TransTyp",
                    "added": "FIX.2.7",
                    "name": "AllocTransType",
                    "id": "71",
                    "description": "Identifies allocation transaction type *** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" ***"
                }
            },
            {
                "id": "75",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "190",
                    "added": "FIX.2.7",
                    "name": "TradeDate",
                    "id": "75",
                    "abbrName": "TrdDt",
                    "description": "Indicates date of trading day. Absence of this field indicates current day (expressed in local time at place of trade)."
                }
            },
            {
                "id": "626",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "AllocTypeCodeSet",
                    "baseCategoryAbbrName": "Typ",
                    "baseCategory": "Allocation",
                    "added": "FIX.4.3",
                    "name": "AllocType",
                    "id": "626",
                    "abbrName": "AllocType",
                    "description": "Describes the specific type or purpose of an Allocation message (i.e. \"Buyside Calculated\")\n\n(see Volume : \"Glossary\" for value definitions)\n\n*** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" ***"
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "updatedEP": "82",
                "updated": "FIX.5.0SP1",
                "id": "1003",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The AllocationInstruction(35=J) message provides the ability to specify how an order or set of orders should be subdivided amongst one or more accounts.\n\nIn versions of FIX prior to version 4.4, this same message was known as the Allocation(35=J) message. Note in versions of the FIX Protocol prior to version 4.4, the Allocation(35=J) message was also used to communicate fee and expense details from the sell-side to the buy-side. This role has since been removed from the AllocationInstruction(35=J) message and is performed by the new (to version 4.4) AllocationReport(35=AS) and Confirmation(35=AK) messages. The AllocationReport(35=AS) message should be used for the sell-side initiated allocation role as defined in previous versions of the FIX Protocol."
    },
    "K": {
        "msgType": "K",
        "category": {
            "FIXMLFileName": "listorders",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "ProgramTrading"
        },
        "added": "FIX.2.7",
        "name": "ListCancelRequest",
        "id": "20",
        "abbrName": "ListCxlReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "60",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "66",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "ProgramTrading",
                    "added": "FIX.2.7",
                    "name": "ListID",
                    "id": "66",
                    "abbrName": "ListID",
                    "description": "Unique identifier for list as assigned by institution, used to associate multiple individual orders. Uniqueness must be guaranteed within a single trading day. Firms which generate multi-day orders should consider embedding a date within the ListID field to assure uniqueness across days."
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The List Cancel Request message type is used by institutions wishing to cancel previously submitted lists either before or during execution."
    },
    "L": {
        "msgType": "L",
        "category": {
            "FIXMLFileName": "listorders",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "ProgramTrading"
        },
        "added": "FIX.2.7",
        "name": "ListExecute",
        "id": "21",
        "abbrName": "ListExct",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "60",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "66",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "ProgramTrading",
                    "added": "FIX.2.7",
                    "name": "ListID",
                    "id": "66",
                    "abbrName": "ListID",
                    "description": "Unique identifier for list as assigned by institution, used to associate multiple individual orders. Uniqueness must be guaranteed within a single trading day. Firms which generate multi-day orders should consider embedding a date within the ListID field to assure uniqueness across days."
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The List Execute message type is used by institutions to instruct the broker to begin execution of a previously submitted list. This message may or may not be used, as it may be mirroring a phone conversation."
    },
    "M": {
        "msgType": "M",
        "category": {
            "FIXMLFileName": "listorders",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "ProgramTrading"
        },
        "added": "FIX.2.7",
        "name": "ListStatusRequest",
        "id": "22",
        "abbrName": "ListStatReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "66",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "ProgramTrading",
                    "added": "FIX.2.7",
                    "name": "ListID",
                    "id": "66",
                    "abbrName": "ListID",
                    "description": "Unique identifier for list as assigned by institution, used to associate multiple individual orders. Uniqueness must be guaranteed within a single trading day. Firms which generate multi-day orders should consider embedding a date within the ListID field to assure uniqueness across days."
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The list status request message type is used by institutions to instruct the broker to generate status messages for a list."
    },
    "N": {
        "msgType": "N",
        "category": {
            "FIXMLFileName": "listorders",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "ProgramTrading"
        },
        "added": "FIX.2.7",
        "name": "ListStatus",
        "id": "23",
        "abbrName": "ListStat",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "66",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "ProgramTrading",
                    "added": "FIX.2.7",
                    "name": "ListID",
                    "id": "66",
                    "abbrName": "ListID",
                    "description": "Unique identifier for list as assigned by institution, used to associate multiple individual orders. Uniqueness must be guaranteed within a single trading day. Firms which generate multi-day orders should consider embedding a date within the ListID field to assure uniqueness across days."
                }
            },
            {
                "id": "68",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "int",
                    "abbrName": "TotNoOrds",
                    "added": "FIX.2.7",
                    "name": "TotNoOrders",
                    "id": "68",
                    "description": "Total number of list order entries across all messages. Should be the sum of all NoOrders (73) in each message that has repeating list order entries related to the same ListID (66). Used to support fragmentation.\n\n(Prior to FIX 4.2 this field was named \"ListNoOrds\")"
                }
            },
            {
                "id": "82",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "int",
                    "abbrName": "NoRpts",
                    "added": "FIX.2.7",
                    "name": "NoRpts",
                    "id": "82",
                    "description": "Total number of reports within series."
                }
            },
            {
                "id": "83",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "int",
                    "abbrName": "RptSeq",
                    "added": "FIX.2.7",
                    "name": "RptSeq",
                    "id": "83",
                    "description": "Sequence number of message within report series. Used to carry reporting sequence number of the fill as represented on the Trade Report Side."
                }
            },
            {
                "id": "429",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "ListStatusTypeCodeSet",
                    "abbrName": "ListStatTyp",
                    "added": "FIX.4.2",
                    "name": "ListStatusType",
                    "id": "429",
                    "description": "Code to represent the status type."
                }
            },
            {
                "id": "431",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "ListOrderStatusCodeSet",
                    "abbrName": "ListOrdStat",
                    "added": "FIX.4.2",
                    "name": "ListOrderStatus",
                    "id": "431",
                    "description": "Code to represent the status of a list order."
                }
            },
            {
                "id": "2037",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "ProgramTrading",
                    "added": "FIX.4.4",
                    "name": "OrdListStatGrp",
                    "id": "2037",
                    "abbrName": "ListStat",
                    "numInGroup": { "id": "73", "added": "FIX.4.4" },
                    "fieldRef": [
                        { "id": "14", "added": "FIX.4.4", "presence": "required", "description": "", "name": "CumQty" },
                        {
                            "id": "39",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "",
                            "name": "OrdStatus"
                        },
                        {
                            "id": "151",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Quantity open for further execution. LeavesQty = OrderQty - CumQty.",
                            "name": "LeavesQty"
                        },
                        { "id": "84", "added": "FIX.4.4", "presence": "required", "description": "", "name": "CxlQty" },
                        { "id": "6", "added": "FIX.4.4", "presence": "required", "description": "", "name": "AvgPx" }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The list status message is issued as the response to a List Status Request message sent in an unsolicited fashion by the sell-side. It indicates the current state of the orders within the list as they exist at the broker's site. This message may also be used to respond to the List Cancel Request."
    },
    "P": {
        "msgType": "P",
        "category": {
            "FIXMLFileName": "allocation",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "Allocation"
        },
        "added": "FIX.2.7",
        "name": "AllocationInstructionAck",
        "id": "24",
        "abbrName": "AllocInstrctnAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "70",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "Allocation",
                    "added": "FIX.2.7",
                    "name": "AllocID",
                    "id": "70",
                    "abbrName": "AllocID",
                    "description": "Unique identifier for allocation message.\n\n(Prior to FIX 4.1 this field was of type int)"
                }
            },
            {
                "id": "87",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "AllocStatusCodeSet",
                    "baseCategoryAbbrName": "Stat",
                    "baseCategory": "Allocation",
                    "added": "FIX.2.7",
                    "name": "AllocStatus",
                    "id": "87",
                    "abbrName": "Stat",
                    "description": "Identifies status of allocation."
                }
            },
            {
                "id": "1025",
                "added": "FIX.2.7",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "In versions of FIX prior to version 4.4, this message was known as the Allocation ACK message.\n\nThe Allocation Instruction Ack message is used to acknowledge the receipt of and provide status for an Allocation Instruction message."
    },
    "Q": {
        "msgType": "Q",
        "category": {
            "FIXMLFileName": "order",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "SingleGeneralOrderHandling"
        },
        "added": "FIX.4.0",
        "name": "DontKnowTrade",
        "id": "25",
        "abbrName": "DkTrd",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.0",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "17",
                "added": "FIX.4.0",
                "presence": "required",
                "data": {
                    "type": "String",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "95",
                    "added": "FIX.2.7",
                    "name": "ExecID",
                    "id": "17",
                    "abbrName": "ExecID",
                    "description": "Unique identifier of execution message as assigned by sell-side (broker, exchange, ECN) (will be 0 (zero) for ExecType (150)=I (Order Status)).\n\nUniqueness must be guaranteed within a single trading day or the life of a multi-day order. Firms which accept multi-day orders should consider embedding a date within the ExecID field to assure uniqueness across days.\n\n(Prior to FIX 4.1 this field was of type int)."
                }
            },
            {
                "id": "37",
                "added": "FIX.4.0",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "OrdID",
                    "added": "FIX.2.7",
                    "name": "OrderID",
                    "id": "37",
                    "description": "Unique identifier for Order as assigned by sell-side (broker, exchange, ECN). Uniqueness must be guaranteed within a single trading day. Firms which accept multi-day orders should consider embedding a date within the OrderID field to assure uniqueness across days."
                }
            },
            {
                "id": "54",
                "added": "FIX.4.0",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "name": "Side",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "127",
                "added": "FIX.4.0",
                "presence": "required",
                "data": {
                    "type": "DKReasonCodeSet",
                    "abbrName": "DkRsn",
                    "added": "FIX.4.0",
                    "name": "DKReason",
                    "id": "127",
                    "description": "Reason for execution rejection."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.0",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            },
            {
                "id": "1011",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "OrderQtyData",
                    "id": "1011",
                    "abbrName": "OrdQty",
                    "description": "The OrderQtyData component block contains the fields commonly used for indicating the amount or quantity of an order. Note that when this component block is marked as \"required\" in a message either one of these three fields must be used to identify the amount: OrderQty, CashOrderQty or OrderPercent (in the case of CIV).\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The Don’t Know Trade (DK) message notifies a trading partner that an electronically received execution has been rejected. This message can be thought of as an execution reject message."
    },
    "R": {
        "msgType": "R",
        "category": {
            "FIXMLFileName": "quotation",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "QuotationNegotiation"
        },
        "added": "FIX.4.0",
        "name": "QuoteRequest",
        "id": "26",
        "abbrName": "QuotReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.0",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "131",
                "added": "FIX.4.0",
                "presence": "required",
                "data": {
                    "type": "String",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "143",
                    "added": "FIX.4.0",
                    "name": "QuoteReqID",
                    "id": "131",
                    "abbrName": "ReqID",
                    "description": "Unique identifier for a QuoteRequest(35=R)."
                }
            },
            {
                "id": "2045",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "QuotationNegotiation",
                    "added": "FIX.4.4",
                    "name": "QuotReqGrp",
                    "id": "2045",
                    "abbrName": "QuotReq",
                    "numInGroup": { "id": "146", "added": "FIX.4.4" },
                    "componentRef": [
                        {
                            "id": "1003",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Insert here the set of \"Instrument\" (symbology) fields defined in \"Common Components of Application Messages\""
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.0",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "In some markets it is the practice to request quotes from brokers prior to placement of an order. The quote request message is used for this purpose. This message is commonly referred to as an Request For Quote (RFQ)"
    },
    "S": {
        "msgType": "S",
        "category": {
            "FIXMLFileName": "quotation",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "QuotationNegotiation"
        },
        "added": "FIX.4.0",
        "name": "Quote",
        "id": "27",
        "abbrName": "Quot",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.0",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "117",
                "added": "FIX.4.0",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "QID",
                    "added": "FIX.4.0",
                    "name": "QuoteID",
                    "id": "117",
                    "description": "Unique identifier for quote"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.0",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "updatedEP": "144",
                "updated": "FIX.5.0SP2",
                "id": "1003",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Quote message is used as the response to a Quote Request or a Quote Response message in both indicative, tradeable, and restricted tradeable quoting markets."
    },
    "T": {
        "msgType": "T",
        "category": {
            "FIXMLFileName": "settlement",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "SettlementInstruction"
        },
        "added": "FIX.4.1",
        "name": "SettlementInstructions",
        "id": "28",
        "abbrName": "SettlInstrctns",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "60",
                "added": "FIX.4.1",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "160",
                "added": "FIX.4.1",
                "presence": "required",
                "data": {
                    "type": "SettlInstModeCodeSet",
                    "abbrName": "SettlInstMode",
                    "added": "FIX.4.1",
                    "name": "SettlInstMode",
                    "id": "160",
                    "description": "Indicates mode used for Settlement Instructions message. *** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" ***"
                }
            },
            {
                "id": "777",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "SettlInstMsgID",
                    "added": "FIX.4.4",
                    "name": "SettlInstMsgID",
                    "id": "777",
                    "description": "Unique identifier for Settlement Instruction message."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Settlement Instructions message provides the broker’s, the institution’s, or the intermediary’s instructions for trade settlement. This message has been designed so that it can be sent from the broker to the institution, from the institution to the broker, or from either to an independent \"standing instructions\" database or matching system or, for CIV, from an intermediary to a fund manager."
    },
    "V": {
        "updated": "FIX.5.0SP2",
        "msgType": "V",
        "updatedEP": "190",
        "category": {
            "FIXMLFileName": "marketdata",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "MarketData"
        },
        "added": "FIX.4.2",
        "name": "MarketDataRequest",
        "id": "29",
        "abbrName": "MktDataReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updatedEP": "190",
                "updated": "FIX.5.0SP2",
                "id": "262",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "ReqID",
                    "added": "FIX.4.2",
                    "name": "MDReqID",
                    "id": "262",
                    "description": "Unique identifier for Market Data Request"
                }
            },
            {
                "updatedEP": "190",
                "updated": "FIX.5.0SP2",
                "id": "263",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "SubscriptionRequestTypeCodeSet",
                    "abbrName": "SubReqTyp",
                    "added": "FIX.4.2",
                    "name": "SubscriptionRequestType",
                    "id": "263",
                    "description": "Subscription Request Type"
                }
            },
            {
                "id": "264",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "int",
                    "abbrName": "MktDepth",
                    "added": "FIX.4.2",
                    "name": "MarketDepth",
                    "id": "264",
                    "description": "Depth of market for Book Snapshot / Incremental updates\n\n0 - full book depth\n\n1 - top of book\n\n2 and above - book depth (number of levels)"
                }
            },
            {
                "updatedEP": "190",
                "updated": "FIX.5.0SP2",
                "id": "2022",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "Common",
                    "added": "FIX.4.4",
                    "name": "InstrmtMDReqGrp",
                    "id": "2022",
                    "abbrName": "InstReq",
                    "numInGroup": { "id": "146", "added": "FIX.4.4" },
                    "componentRef": [
                        {
                            "id": "1003",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Insert here the set of \"Instrument\" (symbology) fields defined in \"Common Components of Application Messages\""
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "updatedEP": "190",
                "updated": "FIX.5.0SP2",
                "id": "2033",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "MarketData",
                    "added": "FIX.4.4",
                    "name": "MDReqGrp",
                    "id": "2033",
                    "abbrName": "Req",
                    "numInGroup": { "id": "267", "added": "FIX.4.4" },
                    "fieldRef": [
                        {
                            "id": "269",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Must be the first field in this repeating group. This is a list of all the types of Market Data Entries that the firm requesting the Market Data is interested in receiving.",
                            "name": "MDEntryType"
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "Some systems allow the transmission of real-time quote, order, trade, trade volume, open interest, and/or other price information on a subscription basis. A MarketDataRequest(35=V) is a general request for market data on specific securities or forex quotes. The values in the fields provided within the request will serve as further filter criteria for the result set."
    },
    "W": {
        "msgType": "W",
        "category": {
            "FIXMLFileName": "marketdata",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "MarketData"
        },
        "added": "FIX.4.2",
        "name": "MarketDataSnapshotFullRefresh",
        "id": "30",
        "abbrName": "MktDataFull",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "779",
                "added": "FIX.5.0SP2",
                "addedEP": "190",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "abbrName": "LastUpdateTm",
                    "added": "FIX.4.4",
                    "name": "LastUpdateTime",
                    "id": "779",
                    "description": "Timestamp of last update to data item (or creation if no updates made since creation)."
                }
            },
            {
                "updatedEP": "190",
                "updated": "FIX.5.0SP2",
                "id": "2031",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "MarketData",
                    "added": "FIX.4.4",
                    "name": "MDFullGrp",
                    "id": "2031",
                    "abbrName": "Full",
                    "numInGroup": { "id": "268", "added": "FIX.4.4" },
                    "fieldRef": [
                        {
                            "updatedEP": "190",
                            "updated": "FIX.5.0SP2",
                            "id": "269",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Required if NoMDEntries(268) > 0.",
                            "name": "MDEntryType"
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "updatedEP": "190",
                "updated": "FIX.5.0SP2",
                "id": "1003",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Market Data messages are used as the response to a Market Data Request message. In all cases, one Market Data message refers only to one Market Data Request. It can be used to transmit a 2-sided book of orders or list of quotes, a list of trades, index values, opening, closing, settlement, high, low, or VWAP prices, the trade volume or open interest for a security, or any combination of these."
    },
    "X": {
        "msgType": "X",
        "category": {
            "FIXMLFileName": "marketdata",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "MarketData"
        },
        "added": "FIX.4.2",
        "name": "MarketDataIncrementalRefresh",
        "id": "31",
        "abbrName": "MktDataInc",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "2032",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "MarketData",
                    "added": "FIX.4.4",
                    "name": "MDIncGrp",
                    "id": "2032",
                    "abbrName": "Inc",
                    "numInGroup": { "id": "268", "added": "FIX.4.4" },
                    "fieldRef": [
                        {
                            "updatedEP": "289",
                            "updated": "FIX.Latest",
                            "id": "279",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Required if NoMDEntries(268) > 0.",
                            "name": "MDUpdateAction"
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Market Data message for incremental updates may contain any combination of new, changed, or deleted Market Data Entries, for any combination of instruments, with any combination of trades, imbalances, quotes, index values, open, close, settlement, high, low, and VWAP prices, trade volume and open interest so long as the maximum FIX message size is not exceeded. All of these types of Market Data Entries can be changed and deleted."
    },
    "Y": {
        "msgType": "Y",
        "category": {
            "FIXMLFileName": "marketdata",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "MarketData"
        },
        "added": "FIX.4.2",
        "name": "MarketDataRequestReject",
        "id": "32",
        "abbrName": "MktDataReqRej",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "262",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "ReqID",
                    "added": "FIX.4.2",
                    "name": "MDReqID",
                    "id": "262",
                    "description": "Unique identifier for Market Data Request"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Market Data Request Reject is used when the broker cannot honor the Market Data Request, due to business or technical reasons. Brokers may choose to limit various parameters, such as the size of requests, whether just the top of book or the entire book may be displayed, and whether Full or Incremental updates must be used."
    },
    "Z": {
        "msgType": "Z",
        "category": {
            "FIXMLFileName": "quotation",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "QuotationNegotiation"
        },
        "added": "FIX.4.2",
        "name": "QuoteCancel",
        "id": "33",
        "abbrName": "QuotCxl",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "298",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "QuoteCancelTypeCodeSet",
                    "updated": "FIX.5.0SP1",
                    "unionDataType": "Reserved100Plus",
                    "updatedEP": "85",
                    "added": "FIX.4.2",
                    "name": "QuoteCancelType",
                    "id": "298",
                    "abbrName": "CxlTyp",
                    "description": "Identifies the type of quote cancel."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Quote Cancel message is used by an originator of quotes to cancel quotes.\n\nThe Quote Cancel message supports cancellation of:\n\n• All quotes\n\n• Quotes for a specific symbol or security ID\n\n• All quotes for a security type\n\n• All quotes for an underlying"
    },
    "a": {
        "msgType": "a",
        "category": {
            "FIXMLFileName": "quotation",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "QuotationNegotiation"
        },
        "added": "FIX.4.2",
        "name": "QuoteStatusRequest",
        "id": "34",
        "abbrName": "QuotStatReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The quote status request message is used for the following purposes in markets that employ tradeable or restricted tradeable quotes:\n\n• For the issuer of a quote in a market to query the status of that quote (using the QuoteID to specify the target quote).\n\n• To subscribe and unsubscribe for Quote Status Report messages for one or more securities."
    },
    "b": {
        "updated": "FIX.5.0SP2",
        "msgType": "b",
        "updatedEP": "143",
        "category": {
            "FIXMLFileName": "quotation",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "QuotationNegotiation"
        },
        "added": "FIX.4.2",
        "name": "MassQuoteAck",
        "id": "35",
        "abbrName": "MassQuotAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "297",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "QuoteStatusCodeSet",
                    "abbrName": "Stat",
                    "added": "FIX.4.2",
                    "name": "QuoteStatus",
                    "id": "297",
                    "description": "Identifies the status of the quote acknowledgement."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "Mass Quote Acknowledgement is used as the application level response to a Mass Quote message."
    },
    "c": {
        "updated": "FIX.5.0SP2",
        "msgType": "c",
        "updatedEP": "195",
        "category": {
            "FIXMLFileName": "securitiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "added": "FIX.4.2",
        "name": "SecurityDefinitionRequest",
        "id": "36",
        "abbrName": "SecDefReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "320",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "ReqID",
                    "added": "FIX.4.2",
                    "name": "SecurityReqID",
                    "id": "320",
                    "description": "Unique ID of a Security Definition Request."
                }
            },
            {
                "id": "321",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "SecurityRequestTypeCodeSet",
                    "abbrName": "ReqTyp",
                    "added": "FIX.4.2",
                    "name": "SecurityRequestType",
                    "id": "321",
                    "description": "Type of Security Definition Request."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The SecurityDefinitionRequest(35=c) message is used for the following:\n\n1. Request a specific security to be traded with the second party. The requested security can be defined as a multileg security made up of one or more instrument legs.\n\n2. Request a set of individual securities for a single market segment.\n\n3. Request all securities, independent of market segment."
    },
    "d": {
        "updated": "FIX.5.0SP2",
        "msgType": "d",
        "updatedEP": "195",
        "category": {
            "FIXMLFileName": "securitiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "added": "FIX.4.2",
        "name": "SecurityDefinition",
        "id": "37",
        "abbrName": "SecDef",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The SecurityDefinition(35=d) message is used for the following:\n\n1. Accept the security defined in a SecurityDefinition(35=d) message.\n\n2. Accept the security defined in a SecurityDefinition(35=d) message with changes to the definition and/or identity of the security.\n\n3. Reject the security requested in a SecurityDefinition(35=d) message.\n\n4. Respond to a request for securities within a specified market segment.\n\n5. Convey comprehensive security definition for all market segments that the security participates in.\n\n6. Convey the security's trading rules that differ from default rules for the market segment."
    },
    "e": {
        "updated": "FIX.5.0SP1",
        "msgType": "e",
        "updatedEP": "97",
        "category": {
            "FIXMLFileName": "securitiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "added": "FIX.4.2",
        "name": "SecurityStatusRequest",
        "id": "38",
        "abbrName": "SecStatReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updatedEP": "95",
                "updated": "FIX.5.0SP1",
                "id": "263",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "SubscriptionRequestTypeCodeSet",
                    "abbrName": "SubReqTyp",
                    "added": "FIX.4.2",
                    "name": "SubscriptionRequestType",
                    "id": "263",
                    "description": "Subscription Request Type"
                }
            },
            {
                "id": "324",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "String",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "106",
                    "added": "FIX.4.2",
                    "name": "SecurityStatusReqID",
                    "id": "324",
                    "abbrName": "StatReqID",
                    "description": "Unique ID of a Security Status Request or a Security Mass Status Request message."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Security Status Request message provides for the ability to request the status of a security. One or more Security Status messages are returned as a result of a Security Status Request message."
    },
    "f": {
        "updated": "FIX.5.0SP1",
        "msgType": "f",
        "updatedEP": "97",
        "category": {
            "FIXMLFileName": "securitiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "added": "FIX.4.2",
        "name": "SecurityStatus",
        "id": "39",
        "abbrName": "SecStat",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "updatedEP": "195",
                "updated": "FIX.5.0SP2",
                "id": "1003",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Security Status message provides for the ability to report changes in status to a security. The Security Status message contains fields to indicate trading status, corporate actions, financial status of the company. The Security Status message is used by one trading entity (for instance an exchange) to report changes in the state of a security."
    },
    "g": {
        "updated": "FIX.5.0SP1",
        "msgType": "g",
        "updatedEP": "97",
        "category": {
            "FIXMLFileName": "marketstructure",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "MarketStructureReferenceData"
        },
        "added": "FIX.4.2",
        "name": "TradingSessionStatusRequest",
        "id": "40",
        "abbrName": "TrdgSesStatReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "263",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "SubscriptionRequestTypeCodeSet",
                    "abbrName": "SubReqTyp",
                    "added": "FIX.4.2",
                    "name": "SubscriptionRequestType",
                    "id": "263",
                    "description": "Subscription Request Type"
                }
            },
            {
                "id": "335",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "ReqID",
                    "added": "FIX.4.2",
                    "name": "TradSesReqID",
                    "id": "335",
                    "description": "Unique ID of a Trading Session Status message."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Trading Session Status Request is used to request information on the status of a market. With the move to multiple sessions occurring for a given trading party (morning and evening sessions for instance) there is a need to be able to provide information on what product is trading on what market."
    },
    "h": {
        "updated": "FIX.5.0SP1",
        "msgType": "h",
        "updatedEP": "97",
        "category": {
            "FIXMLFileName": "marketstructure",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "MarketStructureReferenceData"
        },
        "added": "FIX.4.2",
        "name": "TradingSessionStatus",
        "id": "41",
        "abbrName": "TrdgSesStat",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updatedEP": "190",
                "updated": "FIX.5.0SP2",
                "id": "336",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "TradingSessionIDCodeSet",
                    "updated": "FIX.5.0SP2",
                    "unionDataType": "Reserved100Plus",
                    "updatedEP": "190",
                    "added": "FIX.4.2",
                    "name": "TradingSessionID",
                    "id": "336",
                    "abbrName": "SesID",
                    "description": "Identifier for a trading session.\n\nA trading session spans an extended period of time that can also be expressed informally in terms of the trading day. Usage is determined by market or counterparties.\n\nTo specify good for session where session spans more than one calendar day, use TimeInForce = 0 (Day) in conjunction with TradingSessionID(336).\n\nBilaterally agreed values of data type \"String\" that start with a character can be used for backward compatibility."
                }
            },
            {
                "updatedEP": "190",
                "updated": "FIX.5.0SP2",
                "id": "340",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "TradSesStatusCodeSet",
                    "unionDataType": "Reserved100Plus",
                    "added": "FIX.4.2",
                    "name": "TradSesStatus",
                    "id": "340",
                    "abbrName": "Stat",
                    "description": "State of the trading session."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Trading Session Status provides information on the status of a market. For markets multiple trading sessions on multiple-markets occurring (morning and evening sessions for instance), this message is able to provide information on what products are trading on what market during what trading session."
    },
    "i": {
        "msgType": "i",
        "category": {
            "FIXMLFileName": "quotation",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "QuotationNegotiation"
        },
        "added": "FIX.4.2",
        "name": "MassQuote",
        "id": "42",
        "abbrName": "MassQuot",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "117",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "QID",
                    "added": "FIX.4.0",
                    "name": "QuoteID",
                    "id": "117",
                    "description": "Unique identifier for quote"
                }
            },
            {
                "id": "2049",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "QuotationNegotiation",
                    "added": "FIX.4.4",
                    "name": "QuotSetGrp",
                    "id": "2049",
                    "abbrName": "QuotSet",
                    "numInGroup": { "id": "296", "added": "FIX.4.4" },
                    "fieldRef": [
                        {
                            "id": "302",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Sequential number for the Quote Set. For a given QuoteID - assumed to start at 1.\n\nMust be the first field in the repeating group.",
                            "name": "QuoteSetID"
                        },
                        {
                            "id": "304",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Total number of quotes for the quote set across all messages. Should be the sum of all NoQuoteEntries in each message that has repeating quotes that are part of the same quote set.",
                            "name": "TotNoQuoteEntries"
                        }
                    ],
                    "groupRef": [{ "id": "2043", "added": "FIX.4.4", "presence": "required", "description": "" }],
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Mass Quote message can contain quotes for multiple securities to support applications that allow for the mass quoting of an option series. Two levels of repeating groups have been provided to minimize the amount of data required to submit a set of quotes for a class of options (e.g. all option series for IBM)."
    },
    "j": {
        "msgType": "j",
        "category": {
            "FIXMLFileName": "businessreject",
            "section": "Infrastructure",
            "includeFile": "components",
            "componentType": "Message",
            "name": "BusinessReject"
        },
        "added": "FIX.4.2",
        "name": "BusinessMessageReject",
        "id": "43",
        "abbrName": "BizMsgRej",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "372",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "MsgTypeCodeSet",
                    "abbrName": "RefMsgTyp",
                    "added": "FIX.4.2",
                    "name": "RefMsgType",
                    "id": "372",
                    "description": "The MsgType (35) of the FIX message being referenced."
                }
            },
            {
                "id": "380",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "BusinessRejectReasonCodeSet",
                    "abbrName": "BizRejRsn",
                    "added": "FIX.4.2",
                    "name": "BusinessRejectReason",
                    "id": "380",
                    "description": "Code to identify reason for a Business Message Reject message."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Infrastructure",
            "FIXMLFileName": "infrastructure",
            "displayOrder": "4",
            "description": "Infrastructure messages for application sequencing, business reject, network and user management"
        },
        "description": "The Business Message Reject message can reject an application-level message which fulfills session-level rules and cannot be rejected via any other means. Note if the message fails a session-level rule (e.g. body length is incorrect), a session-level Reject message should be issued."
    },
    "k": {
        "msgType": "k",
        "category": {
            "FIXMLFileName": "listorders",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "ProgramTrading"
        },
        "added": "FIX.4.2",
        "name": "BidRequest",
        "id": "44",
        "abbrName": "BidReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "374",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "BidRequestTransTypeCodeSet",
                    "abbrName": "BidReqTransTyp",
                    "added": "FIX.4.2",
                    "name": "BidRequestTransType",
                    "id": "374",
                    "description": "Identifies the Bid Request message type."
                }
            },
            {
                "id": "391",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "ClBidID",
                    "added": "FIX.4.2",
                    "name": "ClientBidID",
                    "id": "391",
                    "description": "Unique identifier for a Bid Request as assigned by institution. Uniqueness must be guaranteed within a single trading day."
                }
            },
            {
                "id": "393",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "int",
                    "abbrName": "TotNoReltdSym",
                    "added": "FIX.4.2",
                    "name": "TotNoRelatedSym",
                    "id": "393",
                    "description": "Total number of securities.\n\n(Prior to FIX 4.4 this field was named TotalNumSecurities)"
                }
            },
            {
                "id": "394",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "BidTypeCodeSet",
                    "abbrName": "BidTyp",
                    "added": "FIX.4.2",
                    "name": "BidType",
                    "id": "394",
                    "description": "Code to identify the type of Bid Request."
                }
            },
            {
                "id": "418",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "BidTradeTypeCodeSet",
                    "abbrName": "BidTrdTyp",
                    "added": "FIX.4.2",
                    "name": "BidTradeType",
                    "id": "418",
                    "description": "Code to represent the type of trade.\n\n(Prior to FIX 4.4 this field was named \"TradeType\")"
                }
            },
            {
                "id": "419",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "BasisPxTypeCodeSet",
                    "abbrName": "BasisPxTyp",
                    "added": "FIX.4.2",
                    "name": "BasisPxType",
                    "id": "419",
                    "description": "Code to represent the basis price type."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The BidRequest Message can be used in one of two ways depending on which market conventions are being followed.\n\nIn the \"Non disclosed\" convention (e.g. US/European model) the BidRequest message can be used to request a bid based on the sector, country, index and liquidity information contained within the message itself. In the \"Non disclosed\" convention the entry repeating group is used to define liquidity of the program. See \" Program/Basket/List Trading\" for an example.\n\nIn the \"Disclosed\" convention (e.g. Japanese model) the BidRequest message can be used to request bids based on the ListOrderDetail messages sent in advance of BidRequest message. In the \"Disclosed\" convention the list repeating group is used to define which ListOrderDetail messages a bid is being sort for and the directions of the required bids."
    },
    "l": {
        "msgType": "l",
        "category": {
            "FIXMLFileName": "listorders",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "ProgramTrading"
        },
        "added": "FIX.4.2",
        "name": "BidResponse",
        "id": "45",
        "abbrName": "BidRsp",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "2005",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "ProgramTrading",
                    "added": "FIX.4.4",
                    "name": "BidCompRspGrp",
                    "id": "2005",
                    "abbrName": "CompRsp",
                    "numInGroup": { "id": "420", "added": "FIX.4.4" },
                    "componentRef": [
                        {
                            "updatedEP": "95",
                            "updated": "FIX.5.0SP1",
                            "id": "1000",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "First element Commission required if NoBidComponents > 0."
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The Bid Response message can be used in one of two ways depending on which market conventions are being followed.\n\nIn the \"Non disclosed\" convention the Bid Response message can be used to supply a bid based on the sector, country, index and liquidity information contained within the corresponding bid request message. See \"Program/Basket/List Trading\" for an example.\n\nIn the \"Disclosed\" convention the Bid Response message can be used to supply bids based on the List Order Detail messages sent in advance of the corresponding Bid Request message."
    },
    "m": {
        "msgType": "m",
        "category": {
            "FIXMLFileName": "listorders",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "ProgramTrading"
        },
        "added": "FIX.4.2",
        "name": "ListStrikePrice",
        "id": "46",
        "abbrName": "ListStrkPx",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "66",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "ProgramTrading",
                    "added": "FIX.2.7",
                    "name": "ListID",
                    "id": "66",
                    "abbrName": "ListID",
                    "description": "Unique identifier for list as assigned by institution, used to associate multiple individual orders. Uniqueness must be guaranteed within a single trading day. Firms which generate multi-day orders should consider embedding a date within the ListID field to assure uniqueness across days."
                }
            },
            {
                "id": "422",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "int",
                    "abbrName": "TotNoStrks",
                    "added": "FIX.4.2",
                    "name": "TotNoStrikes",
                    "id": "422",
                    "description": "Total number of strike price entries across all messages. Should be the sum of all NoStrikes (428) in each message that has repeating strike price entries related to the same ListID (66). Used to support fragmentation."
                }
            },
            {
                "id": "2023",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "ProgramTrading",
                    "added": "FIX.4.4",
                    "name": "InstrmtStrkPxGrp",
                    "id": "2023",
                    "abbrName": "StrkPX",
                    "numInGroup": { "id": "428", "added": "FIX.4.4" },
                    "componentRef": [
                        {
                            "id": "1003",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Insert here the set of \"Instrument\" (symbology) fields defined in \"Common Components of Application Messages\"\n\nRequired if NoStrikes > 0. Must be first field in repeating group."
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.2",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The strike price message is used to exchange strike price information for principal trades. It can also be used to exchange reference prices for agency trades."
    },
    "n": {
        "msgType": "n",
        "category": { "FIXMLFileName": "session", "section": "Session", "componentType": "Message", "name": "Session" },
        "added": "FIX.4.3",
        "name": "XMLnonFIX",
        "id": "47",
        "abbrName": "XMLnonFIX",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Session",
            "FIXMLFileName": "session",
            "displayOrder": "0",
            "description": "Session level messages to establish and control a FIX session"
        },
        "description": ""
    },
    "o": {
        "msgType": "o",
        "category": {
            "FIXMLFileName": "registration",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "RegistrationInstruction"
        },
        "added": "FIX.4.3",
        "name": "RegistrationInstructions",
        "id": "48",
        "abbrName": "RgstInstrctns",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "508",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "updated": "FIX.Latest",
                    "baseCategoryAbbrName": "RefID",
                    "baseCategory": "RegistrationInstruction",
                    "updatedEP": "282",
                    "added": "FIX.4.3",
                    "name": "RegistRefID",
                    "id": "508",
                    "abbrName": "RefID",
                    "description": "Reference identifier for the RegistID(513) with Cancel and Replace RegistTransType(514) transaction types."
                }
            },
            {
                "id": "513",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "RegistrationInstruction",
                    "added": "FIX.4.3",
                    "name": "RegistID",
                    "id": "513",
                    "abbrName": "RegistID",
                    "description": "Unique identifier of the registration details as assigned by institution or intermediary."
                }
            },
            {
                "id": "514",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "RegistTransTypeCodeSet",
                    "abbrName": "TransTyp",
                    "added": "FIX.4.3",
                    "name": "RegistTransType",
                    "id": "514",
                    "description": "Identifies Registration Instructions transaction type"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Registration Instructions message type may be used by institutions or retail intermediaries wishing to electronically submit registration information to a broker or fund manager (for CIV) for an order or for an allocation."
    },
    "p": {
        "msgType": "p",
        "category": {
            "FIXMLFileName": "registration",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "RegistrationInstruction"
        },
        "added": "FIX.4.3",
        "name": "RegistrationInstructionsResponse",
        "id": "49",
        "abbrName": "RgstInstrctnsRsp",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "506",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "RegistStatusCodeSet",
                    "abbrName": "RegStat",
                    "added": "FIX.4.3",
                    "name": "RegistStatus",
                    "id": "506",
                    "description": "Registration status as returned by the broker or (for CIV) the fund manager:"
                }
            },
            {
                "id": "508",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "updated": "FIX.Latest",
                    "baseCategoryAbbrName": "RefID",
                    "baseCategory": "RegistrationInstruction",
                    "updatedEP": "282",
                    "added": "FIX.4.3",
                    "name": "RegistRefID",
                    "id": "508",
                    "abbrName": "RefID",
                    "description": "Reference identifier for the RegistID(513) with Cancel and Replace RegistTransType(514) transaction types."
                }
            },
            {
                "id": "513",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "RegistrationInstruction",
                    "added": "FIX.4.3",
                    "name": "RegistID",
                    "id": "513",
                    "abbrName": "RegistID",
                    "description": "Unique identifier of the registration details as assigned by institution or intermediary."
                }
            },
            {
                "id": "514",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "RegistTransTypeCodeSet",
                    "abbrName": "TransTyp",
                    "added": "FIX.4.3",
                    "name": "RegistTransType",
                    "id": "514",
                    "description": "Identifies Registration Instructions transaction type"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Registration Instructions Response message type may be used by broker or fund manager (for CIV) in response to a Registration Instructions message submitted by an institution or retail intermediary for an order or for an allocation."
    },
    "q": {
        "msgType": "q",
        "category": {
            "FIXMLFileName": "ordermasshandling",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "OrderMassHandling"
        },
        "added": "FIX.4.3",
        "name": "OrderMassCancelRequest",
        "id": "50",
        "abbrName": "OrdMassCxlReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "11",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "updated": "FIX.Latest",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "updatedEP": "282",
                    "added": "FIX.2.7",
                    "name": "ClOrdID",
                    "id": "11",
                    "abbrName": "ClOrdID",
                    "description": "Unique identifier for Order as assigned by the buy-side (institution, broker, intermediary etc.) (identified by SenderCompID(49) or OnBehalfOfCompID(115) as appropriate). Uniqueness must be guaranteed within a single trading day. Firms, particularly those which electronically submit multi-day orders, trade globally or throughout market close periods, should ensure uniqueness across days, for example by embedding a date within the ClOrdID(11) field."
                }
            },
            {
                "id": "60",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "530",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "MassCancelRequestTypeCodeSet",
                    "baseCategoryAbbrName": "ReqTyp",
                    "baseCategory": "OrderMassHandling",
                    "added": "FIX.4.3",
                    "name": "MassCancelRequestType",
                    "id": "530",
                    "abbrName": "MassCxlReqTyp",
                    "description": "Specifies scope of Order Mass Cancel Request."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The order mass cancel request message requests the cancellation of all of the remaining quantity of a group of orders matching criteria specified within the request. NOTE: This message can only be used to cancel order messages (reduce the full quantity)."
    },
    "r": {
        "msgType": "r",
        "category": {
            "FIXMLFileName": "ordermasshandling",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "OrderMassHandling"
        },
        "added": "FIX.4.3",
        "name": "OrderMassCancelReport",
        "id": "51",
        "abbrName": "OrdMassCxlRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "deprecated": "FIX.5.0SP1",
                "id": "37",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "OrdID",
                    "added": "FIX.2.7",
                    "name": "OrderID",
                    "id": "37",
                    "description": "Unique identifier for Order as assigned by sell-side (broker, exchange, ECN). Uniqueness must be guaranteed within a single trading day. Firms which accept multi-day orders should consider embedding a date within the OrderID field to assure uniqueness across days."
                }
            },
            {
                "id": "530",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "MassCancelRequestTypeCodeSet",
                    "baseCategoryAbbrName": "ReqTyp",
                    "baseCategory": "OrderMassHandling",
                    "added": "FIX.4.3",
                    "name": "MassCancelRequestType",
                    "id": "530",
                    "abbrName": "MassCxlReqTyp",
                    "description": "Specifies scope of Order Mass Cancel Request."
                }
            },
            {
                "id": "531",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "MassCancelResponseCodeSet",
                    "baseCategoryAbbrName": "Rsp",
                    "baseCategory": "OrderMassHandling",
                    "added": "FIX.4.3",
                    "name": "MassCancelResponse",
                    "id": "531",
                    "abbrName": "MassCxlRsp",
                    "description": "Specifies the action taken by counterparty order handling system as a result of the Order Mass Cancel Request"
                }
            },
            {
                "id": "1369",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "58",
                    "added": "FIX.5.0",
                    "name": "MassActionReportID",
                    "id": "1369",
                    "abbrName": "MassActionReportID",
                    "description": "Unique identifier of Order Mass Cancel Report or Order Mass Action Report message as assigned by sell-side (broker, exchange, ECN)"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The Order Mass Cancel Report is used to acknowledge an Order Mass Cancel Request. Note that each affected order that is canceled is acknowledged with a separate Execution Report or Order Cancel Reject message."
    },
    "s": {
        "msgType": "s",
        "category": {
            "FIXMLFileName": "crossorders",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "CrossOrders"
        },
        "added": "FIX.4.3",
        "name": "NewOrderCross",
        "id": "52",
        "abbrName": "NewOrdCrss",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "40",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "OrdTypeCodeSet",
                    "baseCategoryAbbrName": "Typ",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "added": "FIX.2.7",
                    "name": "OrdType",
                    "id": "40",
                    "abbrName": "OrdTyp",
                    "description": "Order type. *** SOME VALUES ARE NO LONGER USED - See \"Deprecated (Phased-out) Features and Supported Approach\" *** (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "60",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "548",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "CrossOrders",
                    "added": "FIX.4.3",
                    "name": "CrossID",
                    "id": "548",
                    "abbrName": "CrssID",
                    "description": "Identifier for a cross order. Must be unique during a given trading day. Recommend that firms use the order date as part of the CrossID for Good Till Cancel (GT) orders."
                }
            },
            {
                "id": "549",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "CrossTypeCodeSet",
                    "baseCategoryAbbrName": "Typ",
                    "baseCategory": "CrossOrders",
                    "added": "FIX.4.3",
                    "name": "CrossType",
                    "id": "549",
                    "abbrName": "CrssTyp",
                    "description": "Type of cross being submitted to a market"
                }
            },
            {
                "id": "550",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "CrossPrioritizationCodeSet",
                    "baseCategoryAbbrName": "Priorty",
                    "baseCategory": "CrossOrders",
                    "added": "FIX.4.3",
                    "name": "CrossPrioritization",
                    "id": "550",
                    "abbrName": "CrssPriortstn",
                    "description": "Indicates if one side or the other of a cross order should be prioritized.\n\nThe definition of prioritization is left to the market. In some markets prioritization means which side of the cross order is applied to the market first. In other markets - prioritization may mean that the prioritized side is fully executed (sometimes referred to as the side being protected)."
                }
            },
            {
                "id": "2059",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "CrossOrders",
                    "added": "FIX.4.4",
                    "name": "SideCrossOrdModGrp",
                    "id": "2059",
                    "abbrName": "SideCrossMod",
                    "numInGroup": { "id": "552", "added": "FIX.4.4", "updated": "FIX.5.0SP2", "updatedEP": "131" },
                    "fieldRef": [
                        {
                            "updatedEP": "131",
                            "updated": "FIX.5.0SP2",
                            "id": "54",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Required if NoSides(552) > 0.",
                            "name": "Side"
                        },
                        {
                            "id": "11",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Unique identifier of the order as assigned by institution or by the intermediary with closest association with the investor.",
                            "name": "ClOrdID"
                        }
                    ],
                    "componentRef": [
                        {
                            "updatedEP": "131",
                            "updated": "FIX.5.0SP2",
                            "id": "1011",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": ""
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "Used to submit a cross order into a market. The cross order contains two order sides (a buy and a sell). The cross order is identified by its CrossID."
    },
    "t": {
        "msgType": "t",
        "category": {
            "FIXMLFileName": "crossorders",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "CrossOrders"
        },
        "added": "FIX.4.3",
        "name": "CrossOrderCancelReplaceRequest",
        "id": "53",
        "abbrName": "CrssOrdCxlRplcReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "40",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "OrdTypeCodeSet",
                    "baseCategoryAbbrName": "Typ",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "added": "FIX.2.7",
                    "name": "OrdType",
                    "id": "40",
                    "abbrName": "OrdTyp",
                    "description": "Order type. *** SOME VALUES ARE NO LONGER USED - See \"Deprecated (Phased-out) Features and Supported Approach\" *** (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "60",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "548",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "CrossOrders",
                    "added": "FIX.4.3",
                    "name": "CrossID",
                    "id": "548",
                    "abbrName": "CrssID",
                    "description": "Identifier for a cross order. Must be unique during a given trading day. Recommend that firms use the order date as part of the CrossID for Good Till Cancel (GT) orders."
                }
            },
            {
                "id": "549",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "CrossTypeCodeSet",
                    "baseCategoryAbbrName": "Typ",
                    "baseCategory": "CrossOrders",
                    "added": "FIX.4.3",
                    "name": "CrossType",
                    "id": "549",
                    "abbrName": "CrssTyp",
                    "description": "Type of cross being submitted to a market"
                }
            },
            {
                "id": "550",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "CrossPrioritizationCodeSet",
                    "baseCategoryAbbrName": "Priorty",
                    "baseCategory": "CrossOrders",
                    "added": "FIX.4.3",
                    "name": "CrossPrioritization",
                    "id": "550",
                    "abbrName": "CrssPriortstn",
                    "description": "Indicates if one side or the other of a cross order should be prioritized.\n\nThe definition of prioritization is left to the market. In some markets prioritization means which side of the cross order is applied to the market first. In other markets - prioritization may mean that the prioritized side is fully executed (sometimes referred to as the side being protected)."
                }
            },
            {
                "id": "551",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategoryAbbrName": "OrigID",
                    "baseCategory": "CrossOrders",
                    "added": "FIX.4.3",
                    "name": "OrigCrossID",
                    "id": "551",
                    "abbrName": "OrigCrssID",
                    "description": "CrossID of the previous cross order (NOT the initial cross order of the day) as assigned by the institution, used to identify the previous cross order in Cross Cancel and Cross Cancel/Replace Requests."
                }
            },
            {
                "id": "2059",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "CrossOrders",
                    "added": "FIX.4.4",
                    "name": "SideCrossOrdModGrp",
                    "id": "2059",
                    "abbrName": "SideCrossMod",
                    "numInGroup": { "id": "552", "added": "FIX.4.4", "updated": "FIX.5.0SP2", "updatedEP": "131" },
                    "fieldRef": [
                        {
                            "updatedEP": "131",
                            "updated": "FIX.5.0SP2",
                            "id": "54",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Required if NoSides(552) > 0.",
                            "name": "Side"
                        },
                        {
                            "id": "11",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Unique identifier of the order as assigned by institution or by the intermediary with closest association with the investor.",
                            "name": "ClOrdID"
                        }
                    ],
                    "componentRef": [
                        {
                            "updatedEP": "131",
                            "updated": "FIX.5.0SP2",
                            "id": "1011",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": ""
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "Used to modify a cross order previously submitted using the New Order - Cross message. See Order Cancel Replace Request for details concerning message usage."
    },
    "u": {
        "msgType": "u",
        "category": {
            "FIXMLFileName": "crossorders",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "CrossOrders"
        },
        "added": "FIX.4.3",
        "name": "CrossOrderCancelRequest",
        "id": "54",
        "abbrName": "CrssOrdCxlReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "60",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "548",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "CrossOrders",
                    "added": "FIX.4.3",
                    "name": "CrossID",
                    "id": "548",
                    "abbrName": "CrssID",
                    "description": "Identifier for a cross order. Must be unique during a given trading day. Recommend that firms use the order date as part of the CrossID for Good Till Cancel (GT) orders."
                }
            },
            {
                "id": "549",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "CrossTypeCodeSet",
                    "baseCategoryAbbrName": "Typ",
                    "baseCategory": "CrossOrders",
                    "added": "FIX.4.3",
                    "name": "CrossType",
                    "id": "549",
                    "abbrName": "CrssTyp",
                    "description": "Type of cross being submitted to a market"
                }
            },
            {
                "id": "550",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "CrossPrioritizationCodeSet",
                    "baseCategoryAbbrName": "Priorty",
                    "baseCategory": "CrossOrders",
                    "added": "FIX.4.3",
                    "name": "CrossPrioritization",
                    "id": "550",
                    "abbrName": "CrssPriortstn",
                    "description": "Indicates if one side or the other of a cross order should be prioritized.\n\nThe definition of prioritization is left to the market. In some markets prioritization means which side of the cross order is applied to the market first. In other markets - prioritization may mean that the prioritized side is fully executed (sometimes referred to as the side being protected)."
                }
            },
            {
                "id": "551",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategoryAbbrName": "OrigID",
                    "baseCategory": "CrossOrders",
                    "added": "FIX.4.3",
                    "name": "OrigCrossID",
                    "id": "551",
                    "abbrName": "OrigCrssID",
                    "description": "CrossID of the previous cross order (NOT the initial cross order of the day) as assigned by the institution, used to identify the previous cross order in Cross Cancel and Cross Cancel/Replace Requests."
                }
            },
            {
                "id": "2058",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "CrossOrders",
                    "added": "FIX.4.4",
                    "name": "SideCrossOrdCxlGrp",
                    "id": "2058",
                    "abbrName": "SideCrossCxl",
                    "numInGroup": { "id": "552", "added": "FIX.4.4" },
                    "fieldRef": [
                        { "id": "54", "added": "FIX.4.4", "presence": "required", "description": "", "name": "Side" },
                        {
                            "id": "11",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Unique identifier of the order as assigned by institution or by the intermediary with closest association with the investor.",
                            "name": "ClOrdID"
                        }
                    ],
                    "componentRef": [
                        {
                            "updatedEP": "221",
                            "updated": "FIX.5.0SP2",
                            "id": "1011",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": ""
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "Used to fully cancel the remaining open quantity of a cross order."
    },
    "v": {
        "updated": "FIX.5.0SP1",
        "msgType": "v",
        "updatedEP": "97",
        "category": {
            "FIXMLFileName": "securitiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "added": "FIX.4.3",
        "name": "SecurityTypeRequest",
        "id": "55",
        "abbrName": "SecTypReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "320",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "ReqID",
                    "added": "FIX.4.2",
                    "name": "SecurityReqID",
                    "id": "320",
                    "description": "Unique ID of a Security Definition Request."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Security Type Request message is used to return a list of security types available from a counterparty or market."
    },
    "w": {
        "updated": "FIX.5.0SP1",
        "msgType": "w",
        "updatedEP": "97",
        "category": {
            "FIXMLFileName": "securitiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "added": "FIX.4.3",
        "name": "SecurityTypes",
        "id": "56",
        "abbrName": "SecTyps",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "320",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "ReqID",
                    "added": "FIX.4.2",
                    "name": "SecurityReqID",
                    "id": "320",
                    "description": "Unique ID of a Security Definition Request."
                }
            },
            {
                "id": "322",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "RspID",
                    "added": "FIX.4.2",
                    "name": "SecurityResponseID",
                    "id": "322",
                    "description": "Unique ID of a Security Definition message."
                }
            },
            {
                "id": "323",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "SecurityResponseTypeCodeSet",
                    "abbrName": "RspTyp",
                    "added": "FIX.4.2",
                    "name": "SecurityResponseType",
                    "id": "323",
                    "description": "Type of Security Definition message response."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Security Type Request message is used to return a list of security types available from a counterparty or market."
    },
    "x": {
        "updated": "FIX.5.0SP1",
        "msgType": "x",
        "updatedEP": "97",
        "category": {
            "FIXMLFileName": "securitiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "added": "FIX.4.3",
        "name": "SecurityListRequest",
        "id": "57",
        "abbrName": "SecListReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "320",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "ReqID",
                    "added": "FIX.4.2",
                    "name": "SecurityReqID",
                    "id": "320",
                    "description": "Unique ID of a Security Definition Request."
                }
            },
            {
                "id": "559",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "SecurityListRequestTypeCodeSet",
                    "abbrName": "ListReqTyp",
                    "added": "FIX.4.3",
                    "name": "SecurityListRequestType",
                    "id": "559",
                    "description": "Identifies the type/criteria of Security List Request"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Security List Request message is used to return a list of securities from the counterparty that match criteria provided on the request"
    },
    "y": {
        "updated": "FIX.5.0SP1",
        "msgType": "y",
        "updatedEP": "97",
        "category": {
            "FIXMLFileName": "securitiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "added": "FIX.4.3",
        "name": "SecurityList",
        "id": "58",
        "abbrName": "SecList",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Security List message is used to return a list of securities that matches the criteria specified in a Security List Request."
    },
    "z": {
        "updated": "FIX.5.0SP1",
        "msgType": "z",
        "updatedEP": "97",
        "category": {
            "FIXMLFileName": "securitiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "added": "FIX.4.3",
        "name": "DerivativeSecurityListRequest",
        "id": "59",
        "abbrName": "DerivSecListReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "320",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "ReqID",
                    "added": "FIX.4.2",
                    "name": "SecurityReqID",
                    "id": "320",
                    "description": "Unique ID of a Security Definition Request."
                }
            },
            {
                "id": "559",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "SecurityListRequestTypeCodeSet",
                    "abbrName": "ListReqTyp",
                    "added": "FIX.4.3",
                    "name": "SecurityListRequestType",
                    "id": "559",
                    "description": "Identifies the type/criteria of Security List Request"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Derivative Security List Request message is used to return a list of securities from the counterparty that match criteria provided on the request"
    },
    "AA": {
        "updated": "FIX.5.0SP1",
        "msgType": "AA",
        "updatedEP": "97",
        "category": {
            "FIXMLFileName": "securitiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "added": "FIX.4.3",
        "name": "DerivativeSecurityList",
        "id": "60",
        "abbrName": "DerivSecList",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Derivative Security List message is used to return a list of securities that matches the criteria specified in a Derivative Security List Request."
    },
    "AB": {
        "msgType": "AB",
        "category": {
            "FIXMLFileName": "multilegorders",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "MultilegOrders"
        },
        "added": "FIX.4.3",
        "name": "NewOrderMultileg",
        "id": "61",
        "abbrName": "NewOrdMleg",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "11",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "updated": "FIX.Latest",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "updatedEP": "282",
                    "added": "FIX.2.7",
                    "name": "ClOrdID",
                    "id": "11",
                    "abbrName": "ClOrdID",
                    "description": "Unique identifier for Order as assigned by the buy-side (institution, broker, intermediary etc.) (identified by SenderCompID(49) or OnBehalfOfCompID(115) as appropriate). Uniqueness must be guaranteed within a single trading day. Firms, particularly those which electronically submit multi-day orders, trade globally or throughout market close periods, should ensure uniqueness across days, for example by embedding a date within the ClOrdID(11) field."
                }
            },
            {
                "id": "40",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "OrdTypeCodeSet",
                    "baseCategoryAbbrName": "Typ",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "added": "FIX.2.7",
                    "name": "OrdType",
                    "id": "40",
                    "abbrName": "OrdTyp",
                    "description": "Order type. *** SOME VALUES ARE NO LONGER USED - See \"Deprecated (Phased-out) Features and Supported Approach\" *** (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "54",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "name": "Side",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "60",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The New Order - Multileg is provided to submit orders for securities that are made up of multiple securities, known as legs."
    },
    "AC": {
        "msgType": "AC",
        "category": {
            "FIXMLFileName": "multilegorders",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "MultilegOrders"
        },
        "added": "FIX.4.3",
        "name": "MultilegOrderCancelReplace",
        "id": "62",
        "abbrName": "MlegOrdCxlRplc",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "40",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "OrdTypeCodeSet",
                    "baseCategoryAbbrName": "Typ",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "added": "FIX.2.7",
                    "name": "OrdType",
                    "id": "40",
                    "abbrName": "OrdTyp",
                    "description": "Order type. *** SOME VALUES ARE NO LONGER USED - See \"Deprecated (Phased-out) Features and Supported Approach\" *** (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "54",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "name": "Side",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "60",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "Used to modify a multileg order previously submitted using the New Order - Multileg message. See Order Cancel Replace Request for details concerning message usage."
    },
    "AD": {
        "msgType": "AD",
        "category": {
            "FIXMLFileName": "tradecapture",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "TradeCapture"
        },
        "added": "FIX.4.3",
        "name": "TradeCaptureReportRequest",
        "id": "63",
        "abbrName": "TrdCaptRptReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updatedEP": "141",
                "updated": "FIX.5.0SP2",
                "id": "568",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "ReqID",
                    "added": "FIX.4.3",
                    "name": "TradeRequestID",
                    "id": "568",
                    "description": "Trade Capture Report Request ID"
                }
            },
            {
                "id": "569",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "TradeRequestTypeCodeSet",
                    "abbrName": "ReqTyp",
                    "added": "FIX.4.3",
                    "name": "TradeRequestType",
                    "id": "569",
                    "description": "Type of Trade Capture Report."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Trade Capture Report Request can be used to:\n\n• Request one or more trade capture reports based upon selection criteria provided on the trade capture report request\n\n• Subscribe for trade capture reports based upon selection criteria provided on the trade capture report request."
    },
    "AE": {
        "updated": "FIX.5.0SP2",
        "msgType": "AE",
        "updatedEP": "192",
        "category": {
            "FIXMLFileName": "tradecapture",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "TradeCapture"
        },
        "added": "FIX.4.3",
        "name": "TradeCaptureReport",
        "id": "64",
        "abbrName": "TrdCaptRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updatedEP": "141",
                "updated": "FIX.5.0SP2",
                "id": "2061",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "TradeCapture",
                    "added": "FIX.4.4",
                    "name": "TrdCapRptSideGrp",
                    "id": "2061",
                    "abbrName": "RptSide",
                    "numInGroup": { "id": "552", "added": "FIX.4.4", "updated": "FIX.5.0SP2", "updatedEP": "141" },
                    "fieldRef": [
                        {
                            "updatedEP": "141",
                            "updated": "FIX.5.0SP2",
                            "id": "54",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Required when NoSides(552) > 0.",
                            "name": "Side"
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "updatedEP": "167",
                "updated": "FIX.5.0SP2",
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "updatedEP": "141",
                "updated": "FIX.5.0SP2",
                "id": "1003",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Trade Capture Report message can be:\n\n- Used to report trades between counterparties.\n\n- Used to report trades to a trade matching system.\n\n- Sent unsolicited between counterparties.\n\n- Sent as a reply to a Trade Capture Report Request.\n\n- Used to report unmatched and matched trades."
    },
    "AF": {
        "msgType": "AF",
        "category": {
            "FIXMLFileName": "ordermasshandling",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "OrderMassHandling"
        },
        "added": "FIX.4.3",
        "name": "OrderMassStatusRequest",
        "id": "65",
        "abbrName": "OrdMassStatReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "584",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategoryAbbrName": "ReqID",
                    "baseCategory": "OrderMassHandling",
                    "added": "FIX.4.3",
                    "name": "MassStatusReqID",
                    "id": "584",
                    "abbrName": "MassStatReqID",
                    "description": "Value assigned by issuer of Mass Status Request to uniquely identify the request"
                }
            },
            {
                "updatedEP": "271",
                "updated": "FIX.Latest",
                "id": "585",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "MassStatusReqTypeCodeSet",
                    "updated": "FIX.Latest",
                    "baseCategoryAbbrName": "ReqTyp",
                    "baseCategory": "OrderMassHandling",
                    "unionDataType": "Reserved100Plus",
                    "updatedEP": "271",
                    "added": "FIX.4.3",
                    "name": "MassStatusReqType",
                    "id": "585",
                    "abbrName": "MassStatReqTyp",
                    "description": "Specifies the type or scope of the mass order status request."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The order mass status request message requests the status for orders matching criteria specified within the request."
    },
    "AG": {
        "msgType": "AG",
        "category": {
            "FIXMLFileName": "quotation",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "QuotationNegotiation"
        },
        "added": "FIX.4.3",
        "name": "QuoteRequestReject",
        "id": "66",
        "abbrName": "QuotReqRej",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "131",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "143",
                    "added": "FIX.4.0",
                    "name": "QuoteReqID",
                    "id": "131",
                    "abbrName": "ReqID",
                    "description": "Unique identifier for a QuoteRequest(35=R)."
                }
            },
            {
                "id": "658",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "QuoteRequestRejectReasonCodeSet",
                    "unionDataType": "Reserved100Plus",
                    "added": "FIX.4.3",
                    "name": "QuoteRequestRejectReason",
                    "id": "658",
                    "abbrName": "ReqRejRsn",
                    "description": "Reason Quote was rejected:"
                }
            },
            {
                "id": "2047",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "QuotationNegotiation",
                    "added": "FIX.4.4",
                    "name": "QuotReqRjctGrp",
                    "id": "2047",
                    "abbrName": "QuotReqRej",
                    "numInGroup": { "id": "146", "added": "FIX.4.4" },
                    "componentRef": [
                        {
                            "id": "1003",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Insert here the set of \"Instrument\" (symbology) fields defined in \"Common Components of Application Messages\""
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Quote Request Reject message is used to reject Quote Request messages for all quoting models."
    },
    "AH": {
        "msgType": "AH",
        "category": {
            "FIXMLFileName": "quotation",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "QuotationNegotiation"
        },
        "added": "FIX.4.3",
        "name": "RFQRequest",
        "id": "67",
        "abbrName": "RFQReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "644",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "RFQReqID",
                    "added": "FIX.4.3",
                    "name": "RFQReqID",
                    "id": "644",
                    "description": "RFQ Request ID - used to identify an RFQ Request."
                }
            },
            {
                "id": "2051",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "QuotationNegotiation",
                    "added": "FIX.4.4",
                    "name": "RFQReqGrp",
                    "id": "2051",
                    "abbrName": "RFQReq",
                    "numInGroup": { "id": "146", "added": "FIX.4.4" },
                    "componentRef": [
                        {
                            "id": "1003",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Insert here the set of \"Instrument\" (symbology) fields defined in \"Common Components of Application Messages\""
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "In tradeable and restricted tradeable quoting markets – Quote Requests are issued by counterparties interested in ascertaining the market for an instrument. Quote Requests are then distributed by the market to liquidity providers who make markets in the instrument. The RFQ Request is used by liquidity providers to indicate to the market for which instruments they are interested in receiving Quote Requests. It can be used to register interest in receiving quote requests for a single instrument or for multiple instruments"
    },
    "AI": {
        "msgType": "AI",
        "category": {
            "FIXMLFileName": "quotation",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "QuotationNegotiation"
        },
        "added": "FIX.4.3",
        "name": "QuoteStatusReport",
        "id": "68",
        "abbrName": "QuotStatRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.3",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The quote status report message is used:\n\n• as the response to a Quote Status Request message\n\n• as a response to a Quote Cancel message\n\n• as a response to a Quote Response message in a negotiation dialog (see Volume 7 – PRODUCT: FIXED INCOME and USER GROUP: EXCHANGES AND MARKETS)"
    },
    "AJ": {
        "updated": "FIX.5.0SP2",
        "msgType": "AJ",
        "updatedEP": "143",
        "category": {
            "FIXMLFileName": "quotation",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "QuotationNegotiation"
        },
        "added": "FIX.4.4",
        "name": "QuoteResponse",
        "id": "69",
        "abbrName": "QuotRsp",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "693",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "RspID",
                    "added": "FIX.4.4",
                    "name": "QuoteRespID",
                    "id": "693",
                    "description": "Message reference for Quote Response"
                }
            },
            {
                "updatedEP": "143",
                "updated": "FIX.5.0SP2",
                "id": "694",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "QuoteRespTypeCodeSet",
                    "abbrName": "RspTyp",
                    "added": "FIX.4.4",
                    "name": "QuoteRespType",
                    "id": "694",
                    "description": "Identifies the type of Quote Response."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The QuoteResponse(35=AJ) message is used for the following purposes:\n\n1. Respond to an IOI(35=6) message\n\n2. Respond to a Quote(35=S) message\n\n3. Counter a Quote\n\n4. End a negotiation dialog\n\n5. Follow-up or end a QuoteRequest(35=R) dialog that did not receive a response.\n\nFor usage of this message in a negotiation or counter quote dialog for fixed income and exchanges/marketplace see Volume 7, Fixed Income and Exchanges and Markets sections respectively."
    },
    "AK": {
        "msgType": "AK",
        "category": {
            "FIXMLFileName": "confirmation",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "Confirmation"
        },
        "added": "FIX.4.4",
        "name": "Confirmation",
        "id": "70",
        "abbrName": "Cnfm",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "6",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "Price",
                    "abbrName": "AvgPx",
                    "added": "FIX.2.7",
                    "name": "AvgPx",
                    "id": "6",
                    "description": "Calculated average price of all fills on this order.\n\nFor Fixed Income trades AvgPx is always expressed as percent-of-par, regardless of the PriceType (423) of LastPx (31). I.e., AvgPx will contain an average of percent-of-par values (see LastParPx (669)) for issues traded in Yield, Spread or Discount."
                }
            },
            {
                "id": "54",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "name": "Side",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "60",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "75",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "190",
                    "added": "FIX.2.7",
                    "name": "TradeDate",
                    "id": "75",
                    "abbrName": "TrdDt",
                    "description": "Indicates date of trading day. Absence of this field indicates current day (expressed in local time at place of trade)."
                }
            },
            {
                "id": "79",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "Acct",
                    "added": "FIX.2.7",
                    "name": "AllocAccount",
                    "id": "79",
                    "description": "Sub-account mnemonic"
                }
            },
            {
                "id": "80",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "Qty",
                    "abbrName": "Qty",
                    "added": "FIX.2.7",
                    "name": "AllocQty",
                    "id": "80",
                    "description": "Quantity to be allocated to specific sub-account\n\n(Prior to FIX 4.2 this field was of type int)"
                }
            },
            {
                "id": "118",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "Amt",
                    "abbrName": "NetMny",
                    "added": "FIX.4.0",
                    "name": "NetMoney",
                    "id": "118",
                    "description": "Total amount due as the result of the transaction (e.g. for Buy order - principal + commission + fees) reported in currency of execution."
                }
            },
            {
                "updatedEP": "258",
                "updated": "FIX.5.0SP2",
                "id": "381",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "Amt",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "258",
                    "added": "FIX.4.2",
                    "name": "GrossTradeAmt",
                    "id": "381",
                    "abbrName": "GrossTrdAmt",
                    "description": "Total amount traded expressed in units of currency - usually quantity * price. For FX Futures this is used to express the notional value of a fill when quantity fields are expressed in terms of contract size (i.e. quantity * price * contract size)."
                }
            },
            {
                "id": "664",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "CnfmID",
                    "added": "FIX.4.4",
                    "name": "ConfirmID",
                    "id": "664",
                    "description": "Message reference for Confirmation"
                }
            },
            {
                "id": "665",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "ConfirmStatusCodeSet",
                    "abbrName": "CnfmStat",
                    "added": "FIX.4.4",
                    "name": "ConfirmStatus",
                    "id": "665",
                    "description": "Identifies the status of the Confirmation."
                }
            },
            {
                "id": "666",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "ConfirmTransTypeCodeSet",
                    "abbrName": "CnfmTransTyp",
                    "added": "FIX.4.4",
                    "name": "ConfirmTransType",
                    "id": "666",
                    "description": "Identifies the Confirmation transaction type."
                }
            },
            {
                "id": "773",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "ConfirmTypeCodeSet",
                    "abbrName": "CnfmTyp",
                    "added": "FIX.4.4",
                    "name": "ConfirmType",
                    "id": "773",
                    "description": "Identifies the type of Confirmation message being sent."
                }
            },
            {
                "updatedEP": "95",
                "updated": "FIX.5.0SP1",
                "id": "2013",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "97",
                    "category": "Confirmation",
                    "added": "FIX.4.4",
                    "name": "CpctyConfGrp",
                    "id": "2013",
                    "abbrName": "Cpcty",
                    "numInGroup": { "id": "862", "added": "FIX.4.4", "updated": "FIX.5.0SP1", "updatedEP": "95" },
                    "fieldRef": [
                        {
                            "id": "528",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "Specifies the capacity of the firm executing the order(s)",
                            "name": "OrderCapacity"
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Confirmation messages are used to provide individual trade level confirmations from the sell side to the buy side. In versions of FIX prior to version 4.4, this role was performed by the allocation message. Unlike the allocation message, the confirmation message operates at an allocation account (trade) level rather than block level, allowing for the affirmation or rejection of individual confirmations."
    },
    "AL": {
        "msgType": "AL",
        "category": {
            "FIXMLFileName": "positions",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "PositionMaintenance"
        },
        "added": "FIX.4.4",
        "name": "PositionMaintenanceRequest",
        "id": "71",
        "abbrName": "PosMntReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "709",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "PosTransTypeCodeSet",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "199",
                    "added": "FIX.4.4",
                    "name": "PosTransType",
                    "id": "709",
                    "abbrName": "TxnTyp",
                    "description": "Identifies the type of position transaction."
                }
            },
            {
                "id": "712",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "PosMaintActionCodeSet",
                    "abbrName": "Actn",
                    "added": "FIX.4.4",
                    "name": "PosMaintAction",
                    "id": "712",
                    "description": "Maintenance Action to be performed."
                }
            },
            {
                "id": "715",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "150",
                    "added": "FIX.4.4",
                    "name": "ClearingBusinessDate",
                    "id": "715",
                    "abbrName": "BizDt",
                    "description": "The business date for which the trade is expected to be cleared."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            },
            {
                "id": "1012",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Parties",
                    "id": "1012",
                    "abbrName": "Pty",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "id": "1015",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "Common",
                    "added": "FIX.4.4",
                    "name": "PositionQty",
                    "id": "1015",
                    "abbrName": "Qty",
                    "numInGroup": { "id": "702", "added": "FIX.4.4" },
                    "description": "The PositionQty component block specifies the various types of position quantity in the position life-cycle including start-of-day, intraday, trade, adjustments, and end-of-day position quantities. Quantities are expressed in terms of long and short quantities.\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Position Maintenance Request message allows the position owner to submit requests to the holder of a position which will result in a specific action being taken which will affect the position. Generally, the holder of the position is a central counter party or clearing organization but can also be a party providing investment services."
    },
    "AM": {
        "updated": "FIX.Latest",
        "msgType": "AM",
        "updatedEP": "271",
        "category": {
            "FIXMLFileName": "positions",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "PositionMaintenance"
        },
        "added": "FIX.4.4",
        "name": "PositionMaintenanceReport",
        "id": "72",
        "abbrName": "PosMntRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "709",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "PosTransTypeCodeSet",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "199",
                    "added": "FIX.4.4",
                    "name": "PosTransType",
                    "id": "709",
                    "abbrName": "TxnTyp",
                    "description": "Identifies the type of position transaction."
                }
            },
            {
                "id": "712",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "PosMaintActionCodeSet",
                    "abbrName": "Actn",
                    "added": "FIX.4.4",
                    "name": "PosMaintAction",
                    "id": "712",
                    "description": "Maintenance Action to be performed."
                }
            },
            {
                "id": "715",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "150",
                    "added": "FIX.4.4",
                    "name": "ClearingBusinessDate",
                    "id": "715",
                    "abbrName": "BizDt",
                    "description": "The business date for which the trade is expected to be cleared."
                }
            },
            {
                "id": "721",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "RptID",
                    "added": "FIX.4.4",
                    "name": "PosMaintRptID",
                    "id": "721",
                    "description": "Unique identifier for this position report"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Position Maintenance Report message is sent by the holder of a position in response to a Position Maintenance Request and is used to confirm that a request has been successfully processed or rejected."
    },
    "AN": {
        "msgType": "AN",
        "category": {
            "FIXMLFileName": "positions",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "PositionMaintenance"
        },
        "added": "FIX.4.4",
        "name": "RequestForPositions",
        "id": "73",
        "abbrName": "ReqForPoss",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "60",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "710",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "ReqID",
                    "added": "FIX.4.4",
                    "name": "PosReqID",
                    "id": "710",
                    "description": "Unique identifier for the position maintenance request as assigned by the submitter"
                }
            },
            {
                "id": "715",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "150",
                    "added": "FIX.4.4",
                    "name": "ClearingBusinessDate",
                    "id": "715",
                    "abbrName": "BizDt",
                    "description": "The business date for which the trade is expected to be cleared."
                }
            },
            {
                "id": "724",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "PosReqTypeCodeSet",
                    "abbrName": "ReqTyp",
                    "added": "FIX.4.4",
                    "name": "PosReqType",
                    "id": "724",
                    "description": "Used to specify the type of position request being made."
                }
            },
            {
                "id": "1012",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Parties",
                    "id": "1012",
                    "abbrName": "Pty",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Request For Positions message is used by the owner of a position to request a Position Report from the holder of the position, usually the central counter party or clearing organization. The request can be made at several levels of granularity."
    },
    "AO": {
        "msgType": "AO",
        "category": {
            "FIXMLFileName": "positions",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "PositionMaintenance"
        },
        "added": "FIX.4.4",
        "name": "RequestForPositionsAck",
        "id": "74",
        "abbrName": "ReqForPossAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "721",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "RptID",
                    "added": "FIX.4.4",
                    "name": "PosMaintRptID",
                    "id": "721",
                    "description": "Unique identifier for this position report"
                }
            },
            {
                "id": "728",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "PosReqResultCodeSet",
                    "updated": "FIX.5.0SP2",
                    "unionDataType": "Reserved100Plus",
                    "updatedEP": "204",
                    "added": "FIX.4.4",
                    "name": "PosReqResult",
                    "id": "728",
                    "abbrName": "Rslt",
                    "description": "Result of Request for Positions."
                }
            },
            {
                "id": "729",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "PosReqStatusCodeSet",
                    "abbrName": "Stat",
                    "added": "FIX.4.4",
                    "name": "PosReqStatus",
                    "id": "729",
                    "description": "Status of Request for Positions"
                }
            },
            {
                "id": "1012",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Parties",
                    "id": "1012",
                    "abbrName": "Pty",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Request for Positions Ack message is returned by the holder of the position in response to a Request for Positions message. The purpose of the message is to acknowledge that a request has been received and is being processed."
    },
    "AP": {
        "msgType": "AP",
        "category": {
            "FIXMLFileName": "positions",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "PositionMaintenance"
        },
        "added": "FIX.4.4",
        "name": "PositionReport",
        "id": "75",
        "abbrName": "PosRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "715",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "150",
                    "added": "FIX.4.4",
                    "name": "ClearingBusinessDate",
                    "id": "715",
                    "abbrName": "BizDt",
                    "description": "The business date for which the trade is expected to be cleared."
                }
            },
            {
                "id": "721",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "RptID",
                    "added": "FIX.4.4",
                    "name": "PosMaintRptID",
                    "id": "721",
                    "description": "Unique identifier for this position report"
                }
            },
            {
                "id": "1012",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Parties",
                    "id": "1012",
                    "abbrName": "Pty",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Position Report message is returned by the holder of a position in response to a Request for Position message. The purpose of the message is to report all aspects of a position and may be provided on a standing basis to report end of day positions to an owner."
    },
    "AQ": {
        "updated": "FIX.5.0SP2",
        "msgType": "AQ",
        "updatedEP": "192",
        "category": {
            "FIXMLFileName": "tradecapture",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "TradeCapture"
        },
        "added": "FIX.4.4",
        "name": "TradeCaptureReportRequestAck",
        "id": "76",
        "abbrName": "TrdCaptRptReqAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "568",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "ReqID",
                    "added": "FIX.4.3",
                    "name": "TradeRequestID",
                    "id": "568",
                    "description": "Trade Capture Report Request ID"
                }
            },
            {
                "id": "569",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "TradeRequestTypeCodeSet",
                    "abbrName": "ReqTyp",
                    "added": "FIX.4.3",
                    "name": "TradeRequestType",
                    "id": "569",
                    "description": "Type of Trade Capture Report."
                }
            },
            {
                "id": "749",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "TradeRequestResultCodeSet",
                    "unionDataType": "Reserved100Plus",
                    "added": "FIX.4.4",
                    "name": "TradeRequestResult",
                    "id": "749",
                    "abbrName": "ReqRslt",
                    "description": "Result of Trade Request"
                }
            },
            {
                "id": "750",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "TradeRequestStatusCodeSet",
                    "abbrName": "ReqStat",
                    "added": "FIX.4.4",
                    "name": "TradeRequestStatus",
                    "id": "750",
                    "description": "Status of Trade Request."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Trade Capture Request Ack message is used to:\n\n- Provide an acknowledgement to a Trade Capture Report Request in the case where the Trade Capture Report Request is used to specify a subscription or delivery of reports via an out-of-band ResponseTransmissionMethod.\n\n- Provide an acknowledgement to a Trade Capture Report Request in the case when the return of the Trade Capture Reports matching that request will be delayed or delivered asynchronously. This is useful in distributed trading system environments.\n\n- Indicate that no trades were found that matched the selection criteria specified on the Trade Capture Report Request or the Trade Capture Request was invalid for some business reason, such as request is not authorized, invalid or unknown instrument, party, trading session, etc."
    },
    "AR": {
        "updated": "FIX.5.0SP2",
        "msgType": "AR",
        "updatedEP": "192",
        "category": {
            "FIXMLFileName": "tradecapture",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "TradeCapture"
        },
        "added": "FIX.4.4",
        "name": "TradeCaptureReportAck",
        "id": "77",
        "abbrName": "TrdCaptRptAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "updatedEP": "141",
                "updated": "FIX.5.0SP2",
                "id": "1003",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Trade Capture Report Ack message can be:\n\n- Used to acknowledge trade capture reports received from a counterparty.\n\n- Used to reject a trade capture report received from a counterparty."
    },
    "AS": {
        "updated": "FIX.Latest",
        "msgType": "AS",
        "updatedEP": "291",
        "category": {
            "FIXMLFileName": "allocation",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "Allocation"
        },
        "added": "FIX.4.4",
        "name": "AllocationReport",
        "id": "78",
        "abbrName": "AllocRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updatedEP": "82",
                "updated": "FIX.5.0SP1",
                "id": "6",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "Price",
                    "abbrName": "AvgPx",
                    "added": "FIX.2.7",
                    "name": "AvgPx",
                    "id": "6",
                    "description": "Calculated average price of all fills on this order.\n\nFor Fixed Income trades AvgPx is always expressed as percent-of-par, regardless of the PriceType (423) of LastPx (31). I.e., AvgPx will contain an average of percent-of-par values (see LastParPx (669)) for issues traded in Yield, Spread or Discount."
                }
            },
            {
                "id": "53",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "Qty",
                    "abbrName": "Qty",
                    "added": "FIX.2.7",
                    "name": "Quantity",
                    "id": "53",
                    "description": "Overall/total quantity (e.g. number of shares)\n\n(Prior to FIX 4.2 this field was of type int)"
                }
            },
            {
                "id": "54",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "name": "Side",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "updatedEP": "285",
                "updated": "FIX.Latest",
                "id": "71",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "AllocTransTypeCodeSet",
                    "abbrName": "TransTyp",
                    "added": "FIX.2.7",
                    "name": "AllocTransType",
                    "id": "71",
                    "description": "Identifies allocation transaction type *** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" ***"
                }
            },
            {
                "id": "75",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "190",
                    "added": "FIX.2.7",
                    "name": "TradeDate",
                    "id": "75",
                    "abbrName": "TrdDt",
                    "description": "Indicates date of trading day. Absence of this field indicates current day (expressed in local time at place of trade)."
                }
            },
            {
                "id": "87",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "AllocStatusCodeSet",
                    "baseCategoryAbbrName": "Stat",
                    "baseCategory": "Allocation",
                    "added": "FIX.2.7",
                    "name": "AllocStatus",
                    "id": "87",
                    "abbrName": "Stat",
                    "description": "Identifies status of allocation."
                }
            },
            {
                "id": "755",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "RptID",
                    "added": "FIX.4.4",
                    "name": "AllocReportID",
                    "id": "755",
                    "description": "Unique identifier for Allocation Report message."
                }
            },
            {
                "id": "794",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "AllocReportTypeCodeSet",
                    "abbrName": "RptTyp",
                    "added": "FIX.4.4",
                    "name": "AllocReportType",
                    "id": "794",
                    "description": "Describes the specific type or purpose of an Allocation Report message"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "updatedEP": "282",
                "updated": "FIX.Latest",
                "id": "1003",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "Sent from sell-side to buy-side, sell-side to 3rd-party or 3rd-party to buy-side, the AllocationReport(35=AS) message (Claim) provides account breakdown of an order or set of orders plus any additional follow-up front-office information developed post-trade during the trade allocation, matching and calculation phase.\n\nIn versions of the FIX Protocol prior to version 4.4, this functionality was provided through the Allocation(35=J) message. Depending on the needs of the market and the timing of confirmed status, the role of AllocationReport(35=AS) can be taken over in whole or in part by the Confirmation(35=AK) message."
    },
    "AT": {
        "msgType": "AT",
        "category": {
            "FIXMLFileName": "allocation",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "Allocation"
        },
        "added": "FIX.4.4",
        "name": "AllocationReportAck",
        "id": "79",
        "abbrName": "AllocRptAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "755",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "RptID",
                    "added": "FIX.4.4",
                    "name": "AllocReportID",
                    "id": "755",
                    "description": "Unique identifier for Allocation Report message."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Allocation Report Ack message is used to acknowledge the receipt of and provide status for an Allocation Report message."
    },
    "AU": {
        "msgType": "AU",
        "category": {
            "FIXMLFileName": "confirmation",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "Confirmation"
        },
        "added": "FIX.4.4",
        "name": "ConfirmationAck",
        "id": "80",
        "abbrName": "CnfmAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "60",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "75",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "190",
                    "added": "FIX.2.7",
                    "name": "TradeDate",
                    "id": "75",
                    "abbrName": "TrdDt",
                    "description": "Indicates date of trading day. Absence of this field indicates current day (expressed in local time at place of trade)."
                }
            },
            {
                "id": "664",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "CnfmID",
                    "added": "FIX.4.4",
                    "name": "ConfirmID",
                    "id": "664",
                    "description": "Message reference for Confirmation"
                }
            },
            {
                "id": "940",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "AffirmStatusCodeSet",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "215",
                    "added": "FIX.4.4",
                    "name": "AffirmStatus",
                    "id": "940",
                    "abbrName": "AffirmStat",
                    "description": "Specifies the affirmation status of the confirmation."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Confirmation Ack (aka Affirmation) message is used to respond to a Confirmation message."
    },
    "AV": {
        "msgType": "AV",
        "category": {
            "FIXMLFileName": "settlement",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "SettlementInstruction"
        },
        "added": "FIX.4.4",
        "name": "SettlementInstructionRequest",
        "id": "81",
        "abbrName": "SettlInstrctnReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "60",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "791",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "SettlInstReqID",
                    "added": "FIX.4.4",
                    "name": "SettlInstReqID",
                    "id": "791",
                    "description": "Unique ID of settlement instruction request message"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Settlement Instruction Request message is used to request standing settlement instructions from another party."
    },
    "AW": {
        "msgType": "AW",
        "category": {
            "FIXMLFileName": "positions",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "PositionMaintenance"
        },
        "added": "FIX.4.4",
        "name": "AssignmentReport",
        "id": "82",
        "abbrName": "AsgnRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "715",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "150",
                    "added": "FIX.4.4",
                    "name": "ClearingBusinessDate",
                    "id": "715",
                    "abbrName": "BizDt",
                    "description": "The business date for which the trade is expected to be cleared."
                }
            },
            {
                "id": "833",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "RptID",
                    "added": "FIX.4.4",
                    "name": "AsgnRptID",
                    "id": "833",
                    "description": "Unique identifier for the Assignment Report"
                }
            },
            {
                "id": "1012",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Parties",
                    "id": "1012",
                    "abbrName": "Pty",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "Assignment Reports are sent from a clearing house to counterparties, such as a clearing firm as a result of the assignment process."
    },
    "AX": {
        "msgType": "AX",
        "category": {
            "FIXMLFileName": "collateral",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "CollateralManagement"
        },
        "added": "FIX.4.4",
        "name": "CollateralRequest",
        "id": "83",
        "abbrName": "CollReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "60",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "894",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "ReqID",
                    "added": "FIX.4.4",
                    "name": "CollReqID",
                    "id": "894",
                    "description": "Collateral Request Identifier"
                }
            },
            {
                "id": "895",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "CollAsgnReasonCodeSet",
                    "abbrName": "AsgnRsn",
                    "added": "FIX.4.4",
                    "name": "CollAsgnReason",
                    "id": "895",
                    "description": "Reason for Collateral Assignment"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "An initiator that requires collateral from a respondent sends a Collateral Request. The initiator can be either counterparty to a trade in a two party model or an intermediary such as an ATS or clearinghouse in a three party model. A Collateral Assignment is expected as a response to a request for collateral."
    },
    "AY": {
        "msgType": "AY",
        "category": {
            "FIXMLFileName": "collateral",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "CollateralManagement"
        },
        "added": "FIX.4.4",
        "name": "CollateralAssignment",
        "id": "84",
        "abbrName": "CollAsgn",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "60",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "895",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "CollAsgnReasonCodeSet",
                    "abbrName": "AsgnRsn",
                    "added": "FIX.4.4",
                    "name": "CollAsgnReason",
                    "id": "895",
                    "description": "Reason for Collateral Assignment"
                }
            },
            {
                "id": "902",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "ID",
                    "added": "FIX.4.4",
                    "name": "CollAsgnID",
                    "id": "902",
                    "description": "Collateral Assignment Identifier"
                }
            },
            {
                "id": "903",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "CollAsgnTransTypeCodeSet",
                    "abbrName": "TransTyp",
                    "added": "FIX.4.4",
                    "name": "CollAsgnTransType",
                    "id": "903",
                    "description": "Collateral Assignment Transaction Type"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "Used to assign collateral to cover a trading position. This message can be sent unsolicited or in reply to a Collateral Request message."
    },
    "AZ": {
        "msgType": "AZ",
        "category": {
            "FIXMLFileName": "collateral",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "CollateralManagement"
        },
        "added": "FIX.4.4",
        "name": "CollateralResponse",
        "id": "85",
        "abbrName": "CollRsp",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "60",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "904",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "RespID",
                    "added": "FIX.4.4",
                    "name": "CollRespID",
                    "id": "904",
                    "description": "Collateral Response Identifier"
                }
            },
            {
                "id": "905",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "CollAsgnRespTypeCodeSet",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "192",
                    "added": "FIX.4.4",
                    "name": "CollAsgnRespType",
                    "id": "905",
                    "abbrName": "RespTyp",
                    "description": "Type of collateral assignment response."
                }
            },
            {
                "updatedEP": "193",
                "updated": "FIX.5.0SP2",
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "Used to respond to a Collateral Assignment message."
    },
    "BA": {
        "msgType": "BA",
        "category": {
            "FIXMLFileName": "collateral",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "CollateralManagement"
        },
        "added": "FIX.4.4",
        "name": "CollateralReport",
        "id": "86",
        "abbrName": "CollRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "908",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "RptID",
                    "added": "FIX.4.4",
                    "name": "CollRptID",
                    "id": "908",
                    "description": "Collateral Report Identifier"
                }
            },
            {
                "id": "910",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "CollStatusCodeSet",
                    "abbrName": "Stat",
                    "added": "FIX.4.4",
                    "name": "CollStatus",
                    "id": "910",
                    "description": "Collateral Status"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "Used to report collateral status when responding to a Collateral Inquiry message."
    },
    "BB": {
        "msgType": "BB",
        "category": {
            "FIXMLFileName": "collateral",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "CollateralManagement"
        },
        "added": "FIX.4.4",
        "name": "CollateralInquiry",
        "id": "87",
        "abbrName": "CollInq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updatedEP": "95",
                "updated": "FIX.5.0SP1",
                "id": "909",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "ID",
                    "added": "FIX.4.4",
                    "name": "CollInquiryID",
                    "id": "909",
                    "description": "Collateral Inquiry Identifier"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "Used to inquire for collateral status."
    },
    "BC": {
        "msgType": "BC",
        "category": {
            "FIXMLFileName": "network",
            "section": "Infrastructure",
            "includeFile": "components",
            "componentType": "Message",
            "name": "Network"
        },
        "added": "FIX.4.4",
        "name": "NetworkCounterpartySystemStatusRequest",
        "id": "88",
        "abbrName": "NtwkSysStatReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "933",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "NtwkReqID",
                    "added": "FIX.4.4",
                    "name": "NetworkRequestID",
                    "id": "933",
                    "description": "Unique identifier for a network resquest."
                }
            },
            {
                "id": "935",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "NetworkRequestTypeCodeSet",
                    "abbrName": "NtwkReqTyp",
                    "added": "FIX.4.4",
                    "name": "NetworkRequestType",
                    "id": "935",
                    "description": "Indicates the type and level of details required for a Network Status Request Message\n\nBoolean logic applies EG If you want to subscribe for changes to certain id's then UserRequestType =0 (8+2), Snapshot for certain ID's = 9 (8+1)"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Infrastructure",
            "FIXMLFileName": "infrastructure",
            "displayOrder": "4",
            "description": "Infrastructure messages for application sequencing, business reject, network and user management"
        },
        "description": "This message is send either immediately after logging on to inform a network (counterparty system) of the type of updates required or to at any other time in the FIX conversation to change the nature of the types of status updates required. It can also be used with a NetworkRequestType of Snapshot to request a one-off report of the status of a network (or counterparty) system. Finally this message can also be used to cancel a request to receive updates into the status of the counterparties on a network by sending a NetworkRequestStatusMessage with a NetworkRequestType of StopSubscribing."
    },
    "BD": {
        "msgType": "BD",
        "category": {
            "FIXMLFileName": "network",
            "section": "Infrastructure",
            "includeFile": "components",
            "componentType": "Message",
            "name": "Network"
        },
        "added": "FIX.4.4",
        "name": "NetworkCounterpartySystemStatusResponse",
        "id": "89",
        "abbrName": "NtwkSysStatRsp",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "932",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "NtwkRspID",
                    "added": "FIX.4.4",
                    "name": "NetworkResponseID",
                    "id": "932",
                    "description": "Unique identifier for a network response."
                }
            },
            {
                "id": "937",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "NetworkStatusResponseTypeCodeSet",
                    "abbrName": "NtwkStatRspTyp",
                    "added": "FIX.4.4",
                    "name": "NetworkStatusResponseType",
                    "id": "937",
                    "description": "Indicates the type of Network Response Message."
                }
            },
            {
                "id": "2010",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "Common",
                    "added": "FIX.4.4",
                    "name": "CompIDStatGrp",
                    "id": "2010",
                    "abbrName": "CIDStat",
                    "numInGroup": { "id": "936", "added": "FIX.4.4" },
                    "fieldRef": [
                        {
                            "id": "930",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "CompID that status is being report for. Required if NoCompIDs > 0,",
                            "name": "RefCompID"
                        },
                        {
                            "id": "928",
                            "added": "FIX.4.4",
                            "presence": "required",
                            "description": "",
                            "name": "StatusValue"
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Infrastructure",
            "FIXMLFileName": "infrastructure",
            "displayOrder": "4",
            "description": "Infrastructure messages for application sequencing, business reject, network and user management"
        },
        "description": "This message is sent in response to a Network (Counterparty System) Status Request Message."
    },
    "BE": {
        "msgType": "BE",
        "category": {
            "FIXMLFileName": "usermanagement",
            "section": "Infrastructure",
            "includeFile": "components",
            "componentType": "Message",
            "name": "UserManagement"
        },
        "added": "FIX.4.4",
        "name": "UserRequest",
        "id": "90",
        "abbrName": "UserReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "553",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "Username",
                    "added": "FIX.4.3",
                    "name": "Username",
                    "id": "553",
                    "description": "Userid or username."
                }
            },
            {
                "id": "923",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "UserReqID",
                    "added": "FIX.4.4",
                    "name": "UserRequestID",
                    "id": "923",
                    "description": "Unique identifier for a User Request."
                }
            },
            {
                "id": "924",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "UserRequestTypeCodeSet",
                    "abbrName": "UserReqTyp",
                    "added": "FIX.4.4",
                    "name": "UserRequestType",
                    "id": "924",
                    "description": "Indicates the action required by a User Request Message"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Infrastructure",
            "FIXMLFileName": "infrastructure",
            "displayOrder": "4",
            "description": "Infrastructure messages for application sequencing, business reject, network and user management"
        },
        "description": "This message is used to initiate a user action, logon, logout or password change. It can also be used to request a report on a user's status."
    },
    "BF": {
        "msgType": "BF",
        "category": {
            "FIXMLFileName": "usermanagement",
            "section": "Infrastructure",
            "includeFile": "components",
            "componentType": "Message",
            "name": "UserManagement"
        },
        "added": "FIX.4.4",
        "name": "UserResponse",
        "id": "91",
        "abbrName": "UserRsp",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "553",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "Username",
                    "added": "FIX.4.3",
                    "name": "Username",
                    "id": "553",
                    "description": "Userid or username."
                }
            },
            {
                "id": "923",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "UserReqID",
                    "added": "FIX.4.4",
                    "name": "UserRequestID",
                    "id": "923",
                    "description": "Unique identifier for a User Request."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Infrastructure",
            "FIXMLFileName": "infrastructure",
            "displayOrder": "4",
            "description": "Infrastructure messages for application sequencing, business reject, network and user management"
        },
        "description": "This message is used to respond to a user request message, it reports the status of the user after the completion of any action requested in the user request message."
    },
    "BG": {
        "msgType": "BG",
        "category": {
            "FIXMLFileName": "collateral",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "CollateralManagement"
        },
        "added": "FIX.4.4",
        "name": "CollateralInquiryAck",
        "id": "92",
        "abbrName": "CollInqAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "909",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "ID",
                    "added": "FIX.4.4",
                    "name": "CollInquiryID",
                    "id": "909",
                    "description": "Collateral Inquiry Identifier"
                }
            },
            {
                "id": "945",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "CollInquiryStatusCodeSet",
                    "abbrName": "Stat",
                    "added": "FIX.4.4",
                    "name": "CollInquiryStatus",
                    "id": "945",
                    "description": "Status of Collateral Inquiry"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "Used to respond to a Collateral Inquiry in the following situations:\n\n• When the CollateralInquiry will result in an out of band response (such as a file transfer).\n\n• When the inquiry is otherwise valid but no collateral is found to match the criteria specified on the Collateral Inquiry message.\n\n• When the Collateral Inquiry is invalid based upon the business rules of the counterparty."
    },
    "BH": {
        "msgType": "BH",
        "category": {
            "FIXMLFileName": "confirmation",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "Confirmation"
        },
        "added": "FIX.4.4",
        "name": "ConfirmationRequest",
        "id": "93",
        "abbrName": "CnfmReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "60",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "773",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "ConfirmTypeCodeSet",
                    "abbrName": "CnfmTyp",
                    "added": "FIX.4.4",
                    "name": "ConfirmType",
                    "id": "773",
                    "description": "Identifies the type of Confirmation message being sent."
                }
            },
            {
                "id": "859",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "CnfmReqID",
                    "added": "FIX.4.4",
                    "name": "ConfirmReqID",
                    "id": "859",
                    "description": "Unique identifier for a Confirmation Request message"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Confirmation Request message is used to request a Confirmation message."
    },
    "BO": {
        "msgType": "BO",
        "addedEP": "-1",
        "category": {
            "FIXMLFileName": "positions",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "PositionMaintenance"
        },
        "added": "FIX.4.4",
        "name": "ContraryIntentionReport",
        "id": "94",
        "abbrName": "ContIntRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "715",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "150",
                    "added": "FIX.4.4",
                    "name": "ClearingBusinessDate",
                    "id": "715",
                    "abbrName": "BizDt",
                    "description": "The business date for which the trade is expected to be cleared."
                }
            },
            {
                "id": "977",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "4",
                    "added": "FIX.4.4",
                    "name": "ContIntRptID",
                    "id": "977",
                    "abbrName": "RptID",
                    "description": "Unique identifier for the Contrary Intention report"
                }
            },
            {
                "id": "1027",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "group",
                    "updated": "FIX.5.0SP1",
                    "addedEP": "-1",
                    "updatedEP": "97",
                    "category": "PositionMaintenance",
                    "added": "FIX.4.4",
                    "name": "ExpirationQty",
                    "id": "1027",
                    "abbrName": "Qty",
                    "numInGroup": { "id": "981", "added": "FIX.4.4", "addedEP": "-1" },
                    "description": "The ExpirationQty component block identified the expiration quantities and type of expiration.\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            },
            {
                "id": "1012",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Parties",
                    "id": "1012",
                    "abbrName": "Pty",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Contrary Intention Report is used for reporting of contrary expiration quantities for Saturday expiring options. This information is required by options exchanges for regulatory purposes."
    },
    "BP": {
        "updated": "FIX.5.0SP2",
        "msgType": "BP",
        "addedEP": "-1",
        "updatedEP": "195",
        "category": {
            "FIXMLFileName": "securitiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "added": "FIX.4.4",
        "name": "SecurityDefinitionUpdateReport",
        "id": "95",
        "abbrName": "SecDefUpd",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "This message is used for reporting updates to a product security master file. Updates could be the result of corporate actions or other business events. Updates may include additions, modifications or deletions."
    },
    "BK": {
        "updated": "FIX.5.0SP1",
        "msgType": "BK",
        "addedEP": "-1",
        "updatedEP": "97",
        "category": {
            "FIXMLFileName": "securitiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "added": "FIX.4.4",
        "name": "SecurityListUpdateReport",
        "id": "96",
        "abbrName": "SecListUpd",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Security List Update Report is used for reporting updates to a Contract Security Masterfile. Updates could be due to Corporate Actions or other business events. Update may include additions, modifications and deletions."
    },
    "BL": {
        "msgType": "BL",
        "addedEP": "-1",
        "category": {
            "FIXMLFileName": "positions",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "PositionMaintenance"
        },
        "added": "FIX.4.4",
        "name": "AdjustedPositionReport",
        "id": "97",
        "abbrName": "AdjPosRep",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "715",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "150",
                    "added": "FIX.4.4",
                    "name": "ClearingBusinessDate",
                    "id": "715",
                    "abbrName": "BizDt",
                    "description": "The business date for which the trade is expected to be cleared."
                }
            },
            {
                "id": "721",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "RptID",
                    "added": "FIX.4.4",
                    "name": "PosMaintRptID",
                    "id": "721",
                    "description": "Unique identifier for this position report"
                }
            },
            {
                "id": "1012",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Parties",
                    "id": "1012",
                    "abbrName": "Pty",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "id": "1015",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "Common",
                    "added": "FIX.4.4",
                    "name": "PositionQty",
                    "id": "1015",
                    "abbrName": "Qty",
                    "numInGroup": { "id": "702", "added": "FIX.4.4" },
                    "description": "The PositionQty component block specifies the various types of position quantity in the position life-cycle including start-of-day, intraday, trade, adjustments, and end-of-day position quantities. Quantities are expressed in terms of long and short quantities.\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "Used to report changes in position, primarily in equity options, due to modifications to the underlying due to corporate actions"
    },
    "BM": {
        "updated": "FIX.Latest",
        "msgType": "BM",
        "addedEP": "-1",
        "updatedEP": "285",
        "category": {
            "FIXMLFileName": "allocation",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "Allocation"
        },
        "added": "FIX.4.4",
        "name": "AllocationInstructionAlert",
        "id": "98",
        "abbrName": "AllocInstrAlert",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "54",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "name": "Side",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "70",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "String",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "Allocation",
                    "added": "FIX.2.7",
                    "name": "AllocID",
                    "id": "70",
                    "abbrName": "AllocID",
                    "description": "Unique identifier for allocation message.\n\n(Prior to FIX 4.1 this field was of type int)"
                }
            },
            {
                "updated": "FIX.Latest",
                "addedEP": "-1",
                "updatedEP": "285",
                "added": "FIX.4.4",
                "id": "71",
                "presence": "required",
                "data": {
                    "type": "AllocTransTypeCodeSet",
                    "abbrName": "TransTyp",
                    "added": "FIX.2.7",
                    "name": "AllocTransType",
                    "id": "71",
                    "description": "Identifies allocation transaction type *** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" ***"
                }
            },
            {
                "id": "75",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "190",
                    "added": "FIX.2.7",
                    "name": "TradeDate",
                    "id": "75",
                    "abbrName": "TrdDt",
                    "description": "Indicates date of trading day. Absence of this field indicates current day (expressed in local time at place of trade)."
                }
            },
            {
                "id": "626",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "AllocTypeCodeSet",
                    "baseCategoryAbbrName": "Typ",
                    "baseCategory": "Allocation",
                    "added": "FIX.4.3",
                    "name": "AllocType",
                    "id": "626",
                    "abbrName": "AllocType",
                    "description": "Describes the specific type or purpose of an Allocation message (i.e. \"Buyside Calculated\")\n\n(see Volume : \"Glossary\" for value definitions)\n\n*** SOME VALUES HAVE BEEN REPLACED - See \"Replaced Features and Supported Approach\" ***"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "This message is used in a 3-party allocation model (buy-side and sell-side using a central clearing entity) where notification of group creation and group updates to counterparties is needed. The message will also carry trade information that comprised the group to the counterparties."
    },
    "BN": {
        "updated": "FIX.5.0SP2",
        "msgType": "BN",
        "addedEP": "-1",
        "updatedEP": "143",
        "category": {
            "FIXMLFileName": "order",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "SingleGeneralOrderHandling"
        },
        "added": "FIX.4.4",
        "name": "ExecutionAck",
        "id": "99",
        "abbrName": "ExecAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "17",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "String",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "95",
                    "added": "FIX.2.7",
                    "name": "ExecID",
                    "id": "17",
                    "abbrName": "ExecID",
                    "description": "Unique identifier of execution message as assigned by sell-side (broker, exchange, ECN) (will be 0 (zero) for ExecType (150)=I (Order Status)).\n\nUniqueness must be guaranteed within a single trading day or the life of a multi-day order. Firms which accept multi-day orders should consider embedding a date within the ExecID field to assure uniqueness across days.\n\n(Prior to FIX 4.1 this field was of type int)."
                }
            },
            {
                "id": "37",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "OrdID",
                    "added": "FIX.2.7",
                    "name": "OrderID",
                    "id": "37",
                    "description": "Unique identifier for Order as assigned by sell-side (broker, exchange, ECN). Uniqueness must be guaranteed within a single trading day. Firms which accept multi-day orders should consider embedding a date within the OrderID field to assure uniqueness across days."
                }
            },
            {
                "id": "54",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "name": "Side",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "1036",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "ExecAckStatusCodeSet",
                    "addedEP": "10",
                    "added": "FIX.4.4",
                    "name": "ExecAckStatus",
                    "id": "1036",
                    "abbrName": "ExecAckStat",
                    "description": "The status of this execution acknowledgement message."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The Execution Report Acknowledgement message is an optional message that provides dual functionality to notify a trading partner that an electronically received execution has either been accepted or rejected (DK'd)."
    },
    "BJ": {
        "updated": "FIX.5.0SP1",
        "msgType": "BJ",
        "addedEP": "-1",
        "updatedEP": "97",
        "category": {
            "FIXMLFileName": "marketstructure",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "MarketStructureReferenceData"
        },
        "added": "FIX.4.4",
        "name": "TradingSessionList",
        "id": "100",
        "abbrName": "TradSessList",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "2099",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "group",
                    "addedEP": "-1",
                    "category": "Common",
                    "added": "FIX.4.4",
                    "name": "TrdSessLstGrp",
                    "id": "2099",
                    "abbrName": "TrdSessLstGrp",
                    "numInGroup": { "id": "386", "added": "FIX.4.4", "addedEP": "-1" },
                    "fieldRef": [
                        {
                            "id": "336",
                            "added": "FIX.4.4",
                            "addedEP": "-1",
                            "presence": "required",
                            "description": "Identifier for Trading Session",
                            "name": "TradingSessionID"
                        },
                        {
                            "id": "340",
                            "added": "FIX.4.4",
                            "addedEP": "-1",
                            "presence": "required",
                            "description": "State of trading session.",
                            "name": "TradSesStatus"
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Trading Session List message is sent as a response to a Trading Session List Request. The Trading Session List should contain the characteristics of the trading session and the current state of the trading session."
    },
    "BI": {
        "updated": "FIX.5.0SP1",
        "msgType": "BI",
        "addedEP": "-1",
        "updatedEP": "97",
        "category": {
            "FIXMLFileName": "marketstructure",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "MarketStructureReferenceData"
        },
        "added": "FIX.4.4",
        "name": "TradingSessionListRequest",
        "id": "101",
        "abbrName": "TradSessListReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "263",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "SubscriptionRequestTypeCodeSet",
                    "abbrName": "SubReqTyp",
                    "added": "FIX.4.2",
                    "name": "SubscriptionRequestType",
                    "id": "263",
                    "description": "Subscription Request Type"
                }
            },
            {
                "id": "335",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "ReqID",
                    "added": "FIX.4.2",
                    "name": "TradSesReqID",
                    "id": "335",
                    "description": "Unique ID of a Trading Session Status message."
                }
            },
            {
                "id": "1025",
                "added": "FIX.4.4",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Trading Session List Request is used to request a list of trading sessions available in a market place and the state of those trading sessions. A successful request will result in a response from the counterparty of a Trading Session List (MsgType=BJ) message that contains a list of zero or more trading sessions."
    },
    "BQ": {
        "msgType": "BQ",
        "addedEP": "-1",
        "category": {
            "FIXMLFileName": "settlement",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "SettlementInstruction"
        },
        "added": "FIX.5.0",
        "name": "SettlementObligationReport",
        "id": "102",
        "abbrName": "SettlObligation",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1159",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "SettlObligModeCodeSet",
                    "addedEP": "44",
                    "added": "FIX.5.0",
                    "name": "SettlObligMode",
                    "id": "1159",
                    "abbrName": "SettlMode",
                    "description": "Used to identify the reporting mode of the settlement obligation which is either preliminary or final"
                }
            },
            {
                "id": "1160",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "44",
                    "added": "FIX.5.0",
                    "name": "SettlObligMsgID",
                    "id": "1160",
                    "abbrName": "SettlMsgID",
                    "description": "Message identifier for Settlement Obligation Report"
                }
            },
            {
                "id": "2101",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "group",
                    "addedEP": "-1",
                    "category": "SettlementInstruction",
                    "added": "FIX.5.0",
                    "name": "SettlObligationInstructions",
                    "id": "2101",
                    "abbrName": "SettlObligInst",
                    "numInGroup": { "id": "1165", "added": "FIX.5.0", "addedEP": "-1" },
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Settlement Obligation Report message provides a central counterparty, institution, or individual counterparty with a capacity for reporting the final details of a currency settlement obligation."
    },
    "BR": {
        "updated": "FIX.5.0SP1",
        "msgType": "BR",
        "addedEP": "-1",
        "updatedEP": "97",
        "category": {
            "FIXMLFileName": "securitiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "added": "FIX.5.0",
        "name": "DerivativeSecurityListUpdateReport",
        "id": "103",
        "abbrName": "DerivSecListUpd",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Derivative Security List Update Report message is used to send updates to an option family or the strikes that comprise an option family."
    },
    "BS": {
        "updated": "FIX.5.0SP1",
        "msgType": "BS",
        "addedEP": "-1",
        "updatedEP": "97",
        "category": {
            "FIXMLFileName": "marketstructure",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "MarketStructureReferenceData"
        },
        "added": "FIX.5.0",
        "name": "TradingSessionListUpdateReport",
        "id": "104",
        "abbrName": "TrdgSesListUpd",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "2099",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "group",
                    "addedEP": "-1",
                    "category": "Common",
                    "added": "FIX.4.4",
                    "name": "TrdSessLstGrp",
                    "id": "2099",
                    "abbrName": "TrdSessLstGrp",
                    "numInGroup": { "id": "386", "added": "FIX.4.4", "addedEP": "-1" },
                    "fieldRef": [
                        {
                            "id": "336",
                            "added": "FIX.4.4",
                            "addedEP": "-1",
                            "presence": "required",
                            "description": "Identifier for Trading Session",
                            "name": "TradingSessionID"
                        },
                        {
                            "id": "340",
                            "added": "FIX.4.4",
                            "addedEP": "-1",
                            "presence": "required",
                            "description": "State of trading session.",
                            "name": "TradSesStatus"
                        }
                    ],
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Trading Session List Update Report is used by marketplaces to provide intra-day updates of trading sessions when there are changes to one or more trading sessions."
    },
    "BT": {
        "updated": "FIX.5.0SP1",
        "msgType": "BT",
        "addedEP": "-1",
        "updatedEP": "97",
        "category": {
            "FIXMLFileName": "marketstructure",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "MarketStructureReferenceData"
        },
        "added": "FIX.5.0",
        "name": "MarketDefinitionRequest",
        "id": "105",
        "abbrName": "MktDefReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "263",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "SubscriptionRequestTypeCodeSet",
                    "abbrName": "SubReqTyp",
                    "added": "FIX.4.2",
                    "name": "SubscriptionRequestType",
                    "id": "263",
                    "description": "Subscription Request Type"
                }
            },
            {
                "id": "1393",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "53",
                    "added": "FIX.5.0",
                    "name": "MarketReqID",
                    "id": "1393",
                    "abbrName": "MktReqID",
                    "description": "Unique ID of a Market Definition Request message."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The Market Definition Request message is used to request for market structure information from the Respondent that receives this request."
    },
    "BU": {
        "updated": "FIX.5.0SP2",
        "msgType": "BU",
        "addedEP": "-1",
        "updatedEP": "195",
        "category": {
            "FIXMLFileName": "marketstructure",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "MarketStructureReferenceData"
        },
        "added": "FIX.5.0",
        "name": "MarketDefinition",
        "id": "106",
        "abbrName": "MktDef",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1301",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "Exchange",
                    "updated": "FIX.5.0SP2",
                    "addedEP": "52",
                    "updatedEP": "190",
                    "added": "FIX.5.0",
                    "name": "MarketID",
                    "id": "1301",
                    "abbrName": "MktID",
                    "description": "Identifies the market"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "addedEP": "-1",
                "updatedEP": "195",
                "added": "FIX.5.0",
                "id": "1394",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "53",
                    "added": "FIX.5.0",
                    "name": "MarketReportID",
                    "id": "1394",
                    "abbrName": "MktRptID",
                    "description": "Market Definition message identifier."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The MarketDefinition(35=BU) message is used to respond to MarketDefinitionRequest(35=BT). In a subscription, it will be used to provide the initial snapshot of the information requested. Subsequent updates are provided by the MarketDefinitionUpdateReport(35=BV)."
    },
    "BV": {
        "updated": "FIX.5.0SP2",
        "msgType": "BV",
        "addedEP": "-1",
        "updatedEP": "195",
        "category": {
            "FIXMLFileName": "marketstructure",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "MarketStructureReferenceData"
        },
        "added": "FIX.5.0",
        "name": "MarketDefinitionUpdateReport",
        "id": "107",
        "abbrName": "MktDefUpd",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1301",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "Exchange",
                    "updated": "FIX.5.0SP2",
                    "addedEP": "52",
                    "updatedEP": "190",
                    "added": "FIX.5.0",
                    "name": "MarketID",
                    "id": "1301",
                    "abbrName": "MktID",
                    "description": "Identifies the market"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "addedEP": "-1",
                "updatedEP": "195",
                "added": "FIX.5.0",
                "id": "1394",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "53",
                    "added": "FIX.5.0",
                    "name": "MarketReportID",
                    "id": "1394",
                    "abbrName": "MktRptID",
                    "description": "Market Definition message identifier."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "In a subscription for market structure information, this message is used once the initial snapshot of the information has been sent using the MarketDefinition(35=BU) message."
    },
    "CB": {
        "msgType": "CB",
        "addedEP": "-1",
        "category": {
            "FIXMLFileName": "usermanagement",
            "section": "Infrastructure",
            "includeFile": "components",
            "componentType": "Message",
            "name": "UserManagement"
        },
        "added": "FIX.5.0",
        "name": "UserNotification",
        "id": "113",
        "abbrName": "UserNotifctn",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "926",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "UserStatusCodeSet",
                    "abbrName": "UserStat",
                    "added": "FIX.4.4",
                    "name": "UserStatus",
                    "id": "926",
                    "description": "Indicates the status of a user"
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Infrastructure",
            "FIXMLFileName": "infrastructure",
            "displayOrder": "4",
            "description": "Infrastructure messages for application sequencing, business reject, network and user management"
        },
        "description": "The User Notification message is used to notify one or more users of an event or information from the sender of the message. This message is usually sent unsolicited from a marketplace (e.g. Exchange, ECN) to a market participant."
    },
    "BZ": {
        "msgType": "BZ",
        "addedEP": "-1",
        "category": {
            "FIXMLFileName": "ordermasshandling",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "OrderMassHandling"
        },
        "added": "FIX.5.0",
        "name": "OrderMassActionReport",
        "id": "111",
        "abbrName": "OrdMassActRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1369",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "58",
                    "added": "FIX.5.0",
                    "name": "MassActionReportID",
                    "id": "1369",
                    "abbrName": "MassActionReportID",
                    "description": "Unique identifier of Order Mass Cancel Report or Order Mass Action Report message as assigned by sell-side (broker, exchange, ECN)"
                }
            },
            {
                "id": "1373",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "MassActionTypeCodeSet",
                    "addedEP": "58",
                    "added": "FIX.5.0",
                    "name": "MassActionType",
                    "id": "1373",
                    "abbrName": "MassActionType",
                    "description": "Specifies the type of action requested"
                }
            },
            {
                "id": "1374",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "MassActionScopeCodeSet",
                    "updated": "FIX.5.0SP1",
                    "unionDataType": "Reserved100Plus",
                    "addedEP": "58",
                    "updatedEP": "85",
                    "added": "FIX.5.0",
                    "name": "MassActionScope",
                    "id": "1374",
                    "abbrName": "MassActionScope",
                    "description": "Specifies scope of Order Mass Action Request."
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "addedEP": "-1",
                "updatedEP": "223",
                "added": "FIX.5.0",
                "id": "1375",
                "presence": "required",
                "data": {
                    "type": "MassActionResponseCodeSet",
                    "addedEP": "58",
                    "added": "FIX.5.0",
                    "name": "MassActionResponse",
                    "id": "1375",
                    "abbrName": "MassActionResponse",
                    "description": "Specifies the action taken by counterparty order handling system as a result of the action type indicated in MassActionType of the Order Mass Action Request."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The Order Mass Action Report is used to acknowledge an Order Mass Action Request. Note that each affected order that is suspended or released or canceled is acknowledged with a separate Execution Report for each order."
    },
    "CA": {
        "msgType": "CA",
        "addedEP": "-1",
        "category": {
            "FIXMLFileName": "ordermasshandling",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "OrderMassHandling"
        },
        "added": "FIX.5.0",
        "name": "OrderMassActionRequest",
        "id": "112",
        "abbrName": "OrdMassActReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "11",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "String",
                    "updated": "FIX.Latest",
                    "baseCategoryAbbrName": "ID",
                    "baseCategory": "SingleGeneralOrderHandling",
                    "updatedEP": "282",
                    "added": "FIX.2.7",
                    "name": "ClOrdID",
                    "id": "11",
                    "abbrName": "ClOrdID",
                    "description": "Unique identifier for Order as assigned by the buy-side (institution, broker, intermediary etc.) (identified by SenderCompID(49) or OnBehalfOfCompID(115) as appropriate). Uniqueness must be guaranteed within a single trading day. Firms, particularly those which electronically submit multi-day orders, trade globally or throughout market close periods, should ensure uniqueness across days, for example by embedding a date within the ClOrdID(11) field."
                }
            },
            {
                "id": "60",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "1373",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "MassActionTypeCodeSet",
                    "addedEP": "58",
                    "added": "FIX.5.0",
                    "name": "MassActionType",
                    "id": "1373",
                    "abbrName": "MassActionType",
                    "description": "Specifies the type of action requested"
                }
            },
            {
                "id": "1374",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "MassActionScopeCodeSet",
                    "updated": "FIX.5.0SP1",
                    "unionDataType": "Reserved100Plus",
                    "addedEP": "58",
                    "updatedEP": "85",
                    "added": "FIX.5.0",
                    "name": "MassActionScope",
                    "id": "1374",
                    "abbrName": "MassActionScope",
                    "description": "Specifies scope of Order Mass Action Request."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The Order Mass Action Request message can be used to request the suspension or release of a group of orders that match the criteria specified within the request. This is equivalent to individual Order Cancel Replace Requests for each order with or without adding \"S\" to the ExecInst values. It can also be used for mass order cancellation."
    },
    "BW": {
        "msgType": "BW",
        "addedEP": "-1",
        "category": {
            "FIXMLFileName": "application",
            "section": "Infrastructure",
            "includeFile": "components",
            "componentType": "Message",
            "name": "Application"
        },
        "added": "FIX.5.0",
        "name": "ApplicationMessageRequest",
        "id": "108",
        "abbrName": "ApplMsgReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1346",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "63",
                    "added": "FIX.5.0",
                    "name": "ApplReqID",
                    "id": "1346",
                    "abbrName": "ApplReqID",
                    "description": "Unique identifier for request"
                }
            },
            {
                "id": "1347",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "ApplReqTypeCodeSet",
                    "addedEP": "63",
                    "added": "FIX.5.0",
                    "name": "ApplReqType",
                    "id": "1347",
                    "abbrName": "ApplReqTyp",
                    "description": "Type of Application Message Request being made."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Infrastructure",
            "FIXMLFileName": "infrastructure",
            "displayOrder": "4",
            "description": "Infrastructure messages for application sequencing, business reject, network and user management"
        },
        "description": "This message is used to request a retransmission of a set of one or more messages generated by the application specified in RefApplID (1355)."
    },
    "BX": {
        "msgType": "BX",
        "addedEP": "-1",
        "category": {
            "FIXMLFileName": "application",
            "section": "Infrastructure",
            "includeFile": "components",
            "componentType": "Message",
            "name": "Application"
        },
        "added": "FIX.5.0",
        "name": "ApplicationMessageRequestAck",
        "id": "109",
        "abbrName": "ApplMsgReqAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1353",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "63",
                    "added": "FIX.5.0",
                    "name": "ApplResponseID",
                    "id": "1353",
                    "abbrName": "ApplRespID",
                    "description": "Identifier for the Applicaton Message Request Ack"
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Infrastructure",
            "FIXMLFileName": "infrastructure",
            "displayOrder": "4",
            "description": "Infrastructure messages for application sequencing, business reject, network and user management"
        },
        "description": "This message is used to acknowledge an Application Message Request providing a status on the request (i.e. whether successful or not). This message does not provide the actual content of the messages to be resent."
    },
    "BY": {
        "msgType": "BY",
        "addedEP": "-1",
        "category": {
            "FIXMLFileName": "application",
            "section": "Infrastructure",
            "includeFile": "components",
            "componentType": "Message",
            "name": "Application"
        },
        "added": "FIX.5.0",
        "name": "ApplicationMessageReport",
        "id": "110",
        "abbrName": "ApplMsgRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1356",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "63",
                    "added": "FIX.5.0",
                    "name": "ApplReportID",
                    "id": "1356",
                    "abbrName": "ApplRptID",
                    "description": "Identifier for the Application Sequence Reset"
                }
            },
            {
                "id": "1426",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "ApplReportTypeCodeSet",
                    "abbrName": "ApplRptTyp",
                    "added": "FIX.5.0SP2",
                    "name": "ApplReportType",
                    "id": "1426",
                    "description": "Type of report"
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0",
                "addedEP": "-1",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Infrastructure",
            "FIXMLFileName": "infrastructure",
            "displayOrder": "4",
            "description": "Infrastructure messages for application sequencing, business reject, network and user management"
        },
        "description": "This message is used for three difference purposes: to reset the ApplSeqNum (1181) of a specified ApplID (1180). to indicate that the last message has been sent for a particular ApplID, or as a keep-alive mechanism for ApplIDs with infrequent message traffic."
    },
    "CC": {
        "msgType": "CC",
        "addedEP": "93",
        "category": {
            "FIXMLFileName": "marketdata",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "MarketData"
        },
        "added": "FIX.5.0SP1",
        "name": "StreamAssignmentRequest",
        "id": "114",
        "abbrName": "StrmAsgnReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1497",
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "93",
                    "added": "FIX.5.0SP1",
                    "name": "StreamAsgnReqID",
                    "id": "1497",
                    "abbrName": "ReqID",
                    "description": "Unique identifier for the stream assignment request provided by the requester."
                }
            },
            {
                "id": "1498",
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "presence": "required",
                "data": {
                    "type": "StreamAsgnReqTypeCodeSet",
                    "addedEP": "93",
                    "added": "FIX.5.0SP1",
                    "name": "StreamAsgnReqType",
                    "id": "1498",
                    "abbrName": "AsgnReqTyp",
                    "description": "Type of stream assignment request."
                }
            },
            {
                "id": "2148",
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "presence": "required",
                "data": {
                    "type": "group",
                    "addedEP": "93",
                    "category": "MarketData",
                    "added": "FIX.5.0SP1",
                    "name": "StrmAsgnReqGrp",
                    "id": "2148",
                    "abbrName": "Reqs",
                    "numInGroup": { "id": "1499", "added": "FIX.5.0SP1", "addedEP": "93" },
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "In certain markets where market data aggregators fan out to end clients the pricing streams provided by the price makers, the price maker may assign the clients to certain pricing streams that the price maker publishes via the aggregator. An example of this use is in the FX markets where clients may be assigned to different pricing streams based on volume bands and currency pairs."
    },
    "CD": {
        "msgType": "CD",
        "addedEP": "93",
        "category": {
            "FIXMLFileName": "marketdata",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "MarketData"
        },
        "added": "FIX.5.0SP1",
        "name": "StreamAssignmentReport",
        "id": "115",
        "abbrName": "StrmAsgnRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1501",
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "93",
                    "added": "FIX.5.0SP1",
                    "name": "StreamAsgnRptID",
                    "id": "1501",
                    "abbrName": "RptID",
                    "description": "Unique identifier of the stream assignment report provided by the respondent."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "he StreamAssignmentReport message is in response to the StreamAssignmentRequest message. It provides information back to the aggregator as to which clients to assign to receive which price stream based on requested CCY pair. This message can be sent unsolicited to the Aggregator from the Price Maker."
    },
    "CE": {
        "msgType": "CE",
        "addedEP": "93",
        "category": {
            "FIXMLFileName": "marketdata",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "MarketData"
        },
        "added": "FIX.5.0SP1",
        "name": "StreamAssignmentReportACK",
        "id": "116",
        "abbrName": "StrmAsgnRptACK",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1501",
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "93",
                    "added": "FIX.5.0SP1",
                    "name": "StreamAsgnRptID",
                    "id": "1501",
                    "abbrName": "RptID",
                    "description": "Unique identifier of the stream assignment report provided by the respondent."
                }
            },
            {
                "id": "1503",
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "presence": "required",
                "data": {
                    "type": "StreamAsgnAckTypeCodeSet",
                    "addedEP": "93",
                    "added": "FIX.5.0SP1",
                    "name": "StreamAsgnAckType",
                    "id": "1503",
                    "abbrName": "ActTyp",
                    "description": "Type of acknowledgement."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP1",
                "addedEP": "93",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "This message is used to respond to the Stream Assignment Report, to either accept or reject an unsolicited assingment."
    },
    "CH": {
        "msgType": "CH",
        "addedEP": "102",
        "category": {
            "FIXMLFileName": "marginrequirement",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "102",
            "section": "PostTrade",
            "added": "FIX.5.0SP2",
            "name": "MarginRequirementManagement"
        },
        "added": "FIX.5.0SP2",
        "name": "MarginRequirementInquiry",
        "id": "119",
        "abbrName": "MgnReqmtInq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1635",
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "102",
                    "added": "FIX.5.0SP2",
                    "name": "MarginReqmtInqID",
                    "id": "1635",
                    "abbrName": "ID",
                    "description": "Unique identifier of the MarginRequirementInquiry."
                }
            },
            {
                "id": "2176",
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "presence": "required",
                "data": {
                    "type": "group",
                    "addedEP": "102",
                    "category": "MarginRequirementManagement",
                    "added": "FIX.5.0SP2",
                    "name": "MarginReqmtInqQualGrp",
                    "id": "2176",
                    "abbrName": "MgnReqmtInqQual",
                    "numInGroup": { "id": "1636", "added": "FIX.5.0SP2", "addedEP": "102" },
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The purpose of this message is to initiate a margin requirement inquiry for a margin account. The inquiry may be submitted at the detail level or the summary level. It can also be used to inquire margin excess/deficit or net position information. Margin excess/deficit will provide information about the surplus or shortfall compared to the previous trading day or a more recent margin calculation. An inquiry for net position information will trigger one or more PositionReport messages instead of one or more MarginRequirementReport messages.\n\nIf the inquiry is made at the detail level, an Instrument block must be provided with the desired level of detail. If the inquiry is made at the summary level, the Instrument block is not provided, implying a summary request is being made. For example, if the inquiring firm specifies the Security Type of “FUT” in the Instrument block, then a detail report will be generated containing the margin requirements for all futures positions for the inquiring account. Similarly, if the inquiry is made at the summary level, the report will contain the total margin requirement aggregated to the margin account level."
    },
    "CI": {
        "msgType": "CI",
        "addedEP": "102",
        "category": {
            "FIXMLFileName": "marginrequirement",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "102",
            "section": "PostTrade",
            "added": "FIX.5.0SP2",
            "name": "MarginRequirementManagement"
        },
        "added": "FIX.5.0SP2",
        "name": "MarginRequirementInquiryAck",
        "id": "120",
        "abbrName": "MgnReqmtInqAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1635",
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "102",
                    "added": "FIX.5.0SP2",
                    "name": "MarginReqmtInqID",
                    "id": "1635",
                    "abbrName": "ID",
                    "description": "Unique identifier of the MarginRequirementInquiry."
                }
            },
            {
                "id": "1640",
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "presence": "required",
                "data": {
                    "type": "CollInquiryStatusCodeSet",
                    "addedEP": "102",
                    "added": "FIX.5.0SP2",
                    "name": "MarginReqmtInqStatus",
                    "id": "1640",
                    "abbrName": "Stat",
                    "description": "Status of MarginRequirementInquiry."
                }
            },
            {
                "id": "2176",
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "presence": "required",
                "data": {
                    "type": "group",
                    "addedEP": "102",
                    "category": "MarginRequirementManagement",
                    "added": "FIX.5.0SP2",
                    "name": "MarginReqmtInqQualGrp",
                    "id": "2176",
                    "abbrName": "MgnReqmtInqQual",
                    "numInGroup": { "id": "1636", "added": "FIX.5.0SP2", "addedEP": "102" },
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "Used to respond to a Margin Requirement Inquiry."
    },
    "CJ": {
        "msgType": "CJ",
        "addedEP": "102",
        "category": {
            "FIXMLFileName": "marginrequirement",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "102",
            "section": "PostTrade",
            "added": "FIX.5.0SP2",
            "name": "MarginRequirementManagement"
        },
        "added": "FIX.5.0SP2",
        "name": "MarginRequirementReport",
        "id": "121",
        "abbrName": "MgnReqmtRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1638",
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "presence": "required",
                "data": {
                    "type": "MarginReqmtRptTypeCodeSet",
                    "addedEP": "102",
                    "added": "FIX.5.0SP2",
                    "name": "MarginReqmtRptType",
                    "id": "1638",
                    "abbrName": "RptTyp",
                    "description": "Type of MarginRequirementReport."
                }
            },
            {
                "id": "1642",
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "102",
                    "added": "FIX.5.0SP2",
                    "name": "MarginReqmtRptID",
                    "id": "1642",
                    "abbrName": "RptID",
                    "description": "Identifier for the MarginRequirementReport message."
                }
            },
            {
                "id": "2177",
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "presence": "required",
                "data": {
                    "type": "group",
                    "addedEP": "102",
                    "category": "Common",
                    "added": "FIX.5.0SP2",
                    "name": "MarginAmount",
                    "id": "2177",
                    "abbrName": "MgnAmt",
                    "numInGroup": { "id": "1643", "added": "FIX.5.0SP2", "addedEP": "102" },
                    "description": "\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "102",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The Margin Requirement Report returns information about margin requirement either as on overview across all margin accounts or on a detailed level due to the inquiry making use of the optional Instrument component block. Application sequencing can be used to re-request a range of reports."
    },
    "CF": {
        "msgType": "CF",
        "addedEP": "105",
        "category": {
            "FIXMLFileName": "partiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "section": "PreTrade",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "added": "FIX.5.0SP2",
        "name": "PartyDetailsListRequest",
        "id": "117",
        "abbrName": "PtyDetlListReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1505",
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "name": "PartyDetailsListRequestID",
                    "id": "1505",
                    "abbrName": "ReqID",
                    "description": "Unique identifier for PartyDetailsListRequest."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyDetailsListRequest is used to request party detail information."
    },
    "CG": {
        "updated": "FIX.5.0SP2",
        "msgType": "CG",
        "addedEP": "105",
        "updatedEP": "146",
        "category": {
            "FIXMLFileName": "partiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "section": "PreTrade",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "added": "FIX.5.0SP2",
        "name": "PartyDetailsListReport",
        "id": "118",
        "abbrName": "PtyDetlListRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1510",
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "name": "PartyDetailsListReportID",
                    "id": "1510",
                    "abbrName": "RptID",
                    "description": "Identifier for the PartyDetailsListReport and the PartyDetailsListUpdateReport."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyDetailsListReport message is used to disseminate party details between counterparties. PartyDetailsListReport messages may be sent in response to a PartyDetailsListRequest message or sent unsolicited."
    },
    "CK": {
        "updated": "FIX.5.0SP2",
        "msgType": "CK",
        "addedEP": "105",
        "updatedEP": "195",
        "category": {
            "FIXMLFileName": "partiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "section": "PreTrade",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "added": "FIX.5.0SP2",
        "name": "PartyDetailsListUpdateReport",
        "id": "122",
        "abbrName": "PtyDetlListUpd",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1510",
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "name": "PartyDetailsListReportID",
                    "id": "1510",
                    "abbrName": "RptID",
                    "description": "Identifier for the PartyDetailsListReport and the PartyDetailsListUpdateReport."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyDetailsListUpdateReport(35=CK) is used to disseminate updates to party detail information."
    },
    "CL": {
        "msgType": "CL",
        "addedEP": "105",
        "category": {
            "FIXMLFileName": "partiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "section": "PreTrade",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "added": "FIX.5.0SP2",
        "name": "PartyRiskLimitsRequest",
        "id": "123",
        "abbrName": "PtyRiskLmtReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1666",
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "name": "RiskLimitRequestID",
                    "id": "1666",
                    "abbrName": "ReqID",
                    "description": "Unique identifier for the PartyRiskLimitsRequest"
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyRiskLimitsRequest message is used to request for risk information for specific parties, specific party roles or specific instruments."
    },
    "CM": {
        "msgType": "CM",
        "addedEP": "105",
        "category": {
            "FIXMLFileName": "partiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "section": "PreTrade",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "added": "FIX.5.0SP2",
        "name": "PartyRiskLimitsReport",
        "id": "124",
        "abbrName": "PtyRiskLmtRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1667",
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "name": "RiskLimitReportID",
                    "id": "1667",
                    "abbrName": "RptID",
                    "description": "Identifier for the PartyRiskLimitsReport"
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "105",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyRiskLimitsReport message is used to communicate party risk limits. The message can either be sent as a response to the PartyRiskLimitsRequest message or can be published unsolicited."
    },
    "CN": {
        "msgType": "CN",
        "addedEP": "106",
        "category": {
            "FIXMLFileName": "securitiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "added": "FIX.5.0SP2",
        "name": "SecurityMassStatusRequest",
        "id": "125",
        "abbrName": "SecMassStatReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "106",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "263",
                "added": "FIX.5.0SP2",
                "addedEP": "106",
                "presence": "required",
                "data": {
                    "type": "SubscriptionRequestTypeCodeSet",
                    "abbrName": "SubReqTyp",
                    "added": "FIX.4.2",
                    "name": "SubscriptionRequestType",
                    "id": "263",
                    "description": "Subscription Request Type"
                }
            },
            {
                "id": "324",
                "added": "FIX.5.0SP2",
                "addedEP": "106",
                "presence": "required",
                "data": {
                    "type": "String",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "106",
                    "added": "FIX.4.2",
                    "name": "SecurityStatusReqID",
                    "id": "324",
                    "abbrName": "StatReqID",
                    "description": "Unique ID of a Security Status Request or a Security Mass Status Request message."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "106",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": ""
    },
    "CO": {
        "msgType": "CO",
        "addedEP": "106",
        "category": {
            "FIXMLFileName": "securitiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "added": "FIX.5.0SP2",
        "name": "SecurityMassStatus",
        "id": "126",
        "abbrName": "SecMassStat",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "106",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "106",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": ""
    },
    "CQ": {
        "updated": "FIX.5.0SP2",
        "msgType": "CQ",
        "addedEP": "117",
        "updatedEP": "162",
        "category": {
            "FIXMLFileName": "accountreporting",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "117",
            "section": "PostTrade",
            "added": "FIX.5.0SP2",
            "name": "AccountReporting",
            "description": "Account Reporting"
        },
        "added": "FIX.5.0SP2",
        "name": "AccountSummaryReport",
        "id": "127",
        "abbrName": "AcctSumRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "117",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "715",
                "added": "FIX.5.0SP2",
                "addedEP": "117",
                "presence": "required",
                "data": {
                    "type": "LocalMktDate",
                    "updated": "FIX.5.0SP2",
                    "updatedEP": "150",
                    "added": "FIX.4.4",
                    "name": "ClearingBusinessDate",
                    "id": "715",
                    "abbrName": "BizDt",
                    "description": "The business date for which the trade is expected to be cleared."
                }
            },
            {
                "id": "1012",
                "added": "FIX.5.0SP2",
                "addedEP": "117",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Parties",
                    "id": "1012",
                    "abbrName": "Pty",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "id": "1699",
                "added": "FIX.5.0SP2",
                "addedEP": "117",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "117",
                    "added": "FIX.5.0SP2",
                    "name": "AccountSummaryReportID",
                    "id": "1699",
                    "abbrName": "RptID",
                    "description": "Unique identifier for the AccountSummaryReport(35=CQ)."
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The AccountSummaryReport is provided by the clearinghouse to its clearing members on a daily basis. It contains margin, settlement, collateral and pay/collect data for each clearing member level account type. Clearing member account types will be described through use of the Parties component and PtysSubGrp sub-component.\n\nIn certain usages, the clearing members can send the AccountSummaryReport message to the clearinghouse as needed. For example, clearing members can send this message to the clearinghouse to identify the value of collateral for each customer (to satisfy CFTC Legally Segregated Operationally Commingled (LSOC) regulatory reporting obligations).\n\nClearing organizations can also send the AccountSummaryReport message to regulators to meet regulatory reporting obligations. For example, clearing organizations can use this message to submit daily reports for each clearing member (“CM”) by house origin and by each customer origin for all futures, options, and swaps positions, and all securities positions held in a segregated account or pursuant to a cross margining agreement, to a regulator (e.g. to the CFTC to meet Part 39, Section 39.19 reporting obligations).\n\nThe Parties component and PtysSubGrp sub-component are used to describe the clearing member number and account type for that report. Net settlement amount or amounts are provided using the SettlementAmountGrp component. Margin requirement amounts are provided using the MarginAmountData component.\n\nThe current collateral values for each valid collateral type is provided using the CollateralAmountGrp component. Likewise pay/collect information is provided using the PayCollectGrp component. Margin and pay/collect amounts can optionally be tied to markets and market segments for clearing houses that support multiple markets and market segments."
    },
    "CR": {
        "updated": "FIX.5.0SP2",
        "msgType": "CR",
        "addedEP": "128",
        "updatedEP": "195",
        "category": {
            "FIXMLFileName": "partiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "section": "PreTrade",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "added": "FIX.5.0SP2",
        "name": "PartyRiskLimitsUpdateReport",
        "id": "128",
        "abbrName": "PtyRiskLmtUpd",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "128",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1667",
                "added": "FIX.5.0SP2",
                "addedEP": "128",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "name": "RiskLimitReportID",
                    "id": "1667",
                    "abbrName": "RptID",
                    "description": "Identifier for the PartyRiskLimitsReport"
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "128",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyRiskLimitsUpdateReport(35=CR) is used to convey incremental changes to risk limits. It is similar to the regular report but uses the PartyRiskLimitsUpdateGrp component instead of the PartyRiskLimitsGrp component to include an update action."
    },
    "CS": {
        "msgType": "CS",
        "addedEP": "128",
        "category": {
            "FIXMLFileName": "partiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "section": "PreTrade",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "added": "FIX.5.0SP2",
        "name": "PartyRiskLimitsDefinitionRequest",
        "id": "129",
        "abbrName": "PtyRiskLmtDefReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "128",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1666",
                "added": "FIX.5.0SP2",
                "addedEP": "128",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "name": "RiskLimitRequestID",
                    "id": "1666",
                    "abbrName": "ReqID",
                    "description": "Unique identifier for the PartyRiskLimitsRequest"
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "128",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "PartyRiskLimitDefinitionRequest is used for defining new risk limits."
    },
    "CT": {
        "msgType": "CT",
        "addedEP": "128",
        "category": {
            "FIXMLFileName": "partiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "section": "PreTrade",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "added": "FIX.5.0SP2",
        "name": "PartyRiskLimitsDefinitionRequestAck",
        "id": "130",
        "abbrName": "PtyRiskLmtDefReqAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "128",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1666",
                "added": "FIX.5.0SP2",
                "addedEP": "128",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "name": "RiskLimitRequestID",
                    "id": "1666",
                    "abbrName": "ReqID",
                    "description": "Unique identifier for the PartyRiskLimitsRequest"
                }
            },
            {
                "id": "1762",
                "added": "FIX.5.0SP2",
                "addedEP": "128",
                "presence": "required",
                "data": {
                    "type": "PartyDetailRequestStatusCodeSet",
                    "updated": "FIX.5.0SP2",
                    "addedEP": "128",
                    "updatedEP": "146",
                    "added": "FIX.5.0SP2",
                    "name": "RiskLimitRequestStatus",
                    "id": "1762",
                    "abbrName": "ReqStat",
                    "description": "Status of risk limit definition request."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "128",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "PartyRiskLimitDefinitionRequestAck is used for accepting (with or without changes) or rejecting the definition of risk limits."
    },
    "CU": {
        "msgType": "CU",
        "addedEP": "129",
        "category": {
            "FIXMLFileName": "partiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "section": "PreTrade",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "added": "FIX.5.0SP2",
        "name": "PartyEntitlementsRequest",
        "id": "131",
        "abbrName": "PtyEntlmntReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "129",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "129",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyEntitlementsRequest message is used to request for entitlement information for one or more party(-ies), specific party role(s), or specific instruments(s)."
    },
    "CV": {
        "msgType": "CV",
        "addedEP": "129",
        "category": {
            "FIXMLFileName": "partiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "section": "PreTrade",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "added": "FIX.5.0SP2",
        "name": "PartyEntitlementsReport",
        "id": "132",
        "abbrName": "PtyEntlmntRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "129",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1771",
                "added": "FIX.5.0SP2",
                "addedEP": "129",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "129",
                    "added": "FIX.5.0SP2",
                    "name": "EntitlementReportID",
                    "id": "1771",
                    "abbrName": "RptID",
                    "description": "Identifier for the PartyEntitlementsReport(35=CV)."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "129",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyEntitlementsReport is used to report entitlements for one or more parties, party role(s), or specific instrument(s)."
    },
    "CW": {
        "msgType": "CW",
        "addedEP": "143",
        "category": {
            "FIXMLFileName": "quotation",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "QuotationNegotiation"
        },
        "added": "FIX.5.0SP2",
        "name": "QuoteAck",
        "id": "133",
        "abbrName": "QuotAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "143",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1865",
                "added": "FIX.5.0SP2",
                "addedEP": "143",
                "presence": "required",
                "data": {
                    "type": "QuoteAckStatusCodeSet",
                    "addedEP": "143",
                    "added": "FIX.5.0SP2",
                    "name": "QuoteAckStatus",
                    "id": "1865",
                    "abbrName": "QtAckStat",
                    "description": "Acknowledgement status of a Quote(35=S) or QuoteCancel(35=Z) message submission."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "143",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The QuoteAck(35=CW) message is used to acknowledge a Quote(35=S) submittal or request to cancel an individual quote using the QuoteCancel(35=Z) message during a Quote/Negotiation dialog.\n\nThe QuoteAck(35=CW) is available for optional use to acknowledge the request to cancel an individual quote (QuoteCancel(35=Z) with QuoteCancelType(298) =5(Cancel specified sinqle quote))."
    },
    "CX": {
        "msgType": "CX",
        "addedEP": "146",
        "category": {
            "FIXMLFileName": "partiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "section": "PreTrade",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "added": "FIX.5.0SP2",
        "name": "PartyDetailsDefinitionRequest",
        "id": "134",
        "abbrName": "PtyDetlDefReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1505",
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "name": "PartyDetailsListRequestID",
                    "id": "1505",
                    "abbrName": "ReqID",
                    "description": "Unique identifier for PartyDetailsListRequest."
                }
            },
            {
                "id": "2182",
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "presence": "required",
                "data": {
                    "type": "group",
                    "addedEP": "105",
                    "category": "PartiesReferenceData",
                    "added": "FIX.5.0SP2",
                    "name": "PartyDetailsUpdateGrp",
                    "id": "2182",
                    "abbrName": "PtyDetlUpd",
                    "numInGroup": { "id": "1676", "added": "FIX.5.0SP2", "addedEP": "105" },
                    "description": "Party details component that includes an update action.\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyDetailsDefinitionRequest(35=CX) is used for defining new parties and modifying or deleting existing parties information, including the relationships between parties.\n\nThe recipient of the message responds with a PartyDetailsDefinitionRequestAck(35=CY) to indicate whether the request was accepted or rejected."
    },
    "CY": {
        "msgType": "CY",
        "addedEP": "146",
        "category": {
            "FIXMLFileName": "partiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "section": "PreTrade",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "added": "FIX.5.0SP2",
        "name": "PartyDetailsDefinitionRequestAck",
        "id": "135",
        "abbrName": "PtyDetlDefReqAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1505",
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "name": "PartyDetailsListRequestID",
                    "id": "1505",
                    "abbrName": "ReqID",
                    "description": "Unique identifier for PartyDetailsListRequest."
                }
            },
            {
                "id": "1878",
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "presence": "required",
                "data": {
                    "type": "PartyDetailRequestStatusCodeSet",
                    "addedEP": "146",
                    "added": "FIX.5.0SP2",
                    "name": "PartyDetailRequestStatus",
                    "id": "1878",
                    "abbrName": "ReqStat",
                    "description": "Status of party details definition request."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyDetailsDefinitionRequestAck(35=CY) is used as a response to the PartyDetailsDefinitionRequest(35=CX) message. The request can be accepted (with or without changes) or rejected."
    },
    "CZ": {
        "updated": "FIX.5.0SP2",
        "msgType": "CZ",
        "addedEP": "146",
        "updatedEP": "195",
        "category": {
            "FIXMLFileName": "partiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "section": "PreTrade",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "added": "FIX.5.0SP2",
        "name": "PartyEntitlementsUpdateReport",
        "id": "136",
        "abbrName": "PtyEntlmntUpd",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1771",
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "129",
                    "added": "FIX.5.0SP2",
                    "name": "EntitlementReportID",
                    "id": "1771",
                    "abbrName": "RptID",
                    "description": "Identifier for the PartyEntitlementsReport(35=CV)."
                }
            },
            {
                "id": "2215",
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "presence": "required",
                "data": {
                    "type": "group",
                    "addedEP": "146",
                    "category": "PartiesReferenceData",
                    "added": "FIX.5.0SP2",
                    "name": "PartyEntitlementUpdateGrp",
                    "id": "2215",
                    "abbrName": "PtyEntlmntUpd",
                    "numInGroup": { "id": "1772", "added": "FIX.5.0SP2", "addedEP": "146" },
                    "description": "The PartyEntitlementUpdateGrp component is used to supply incremental entitlement definitions changes for the party(-ies) specified in the PartyDetailGrp component. The update action type is specified using ListUpdateAction(1324).\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyEntitlementsUpdateReport(35=CZ) is used to convey incremental changes to party entitlements. It is similar to the PartyEntitlementsReport(35=CV). This message uses the PartyEntitlementsUpdateGrp component which includes the ability to specify an update action using ListUpdateAction(1324)."
    },
    "DA": {
        "msgType": "DA",
        "addedEP": "146",
        "category": {
            "FIXMLFileName": "partiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "section": "PreTrade",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "added": "FIX.5.0SP2",
        "name": "PartyEntitlementsDefinitionRequest",
        "id": "137",
        "abbrName": "PtyEntlmntDefReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1770",
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "129",
                    "added": "FIX.5.0SP2",
                    "name": "EntitlementRequestID",
                    "id": "1770",
                    "abbrName": "ReqID",
                    "description": "Unique identifier for PartyEntitlementsRequest(35=CU)."
                }
            },
            {
                "id": "2215",
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "presence": "required",
                "data": {
                    "type": "group",
                    "addedEP": "146",
                    "category": "PartiesReferenceData",
                    "added": "FIX.5.0SP2",
                    "name": "PartyEntitlementUpdateGrp",
                    "id": "2215",
                    "abbrName": "PtyEntlmntUpd",
                    "numInGroup": { "id": "1772", "added": "FIX.5.0SP2", "addedEP": "146" },
                    "description": "The PartyEntitlementUpdateGrp component is used to supply incremental entitlement definitions changes for the party(-ies) specified in the PartyDetailGrp component. The update action type is specified using ListUpdateAction(1324).\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyEntitlementsDefinitionRequest(35=DA) is used for defining new entitlements, and modifying or deleting existing entitlements for the specified party(-ies).\n\nThe PartyEntitlementsDefinitionRequestAck(35=DB) is the response message, used to indicate whether the request was accepted or rejected."
    },
    "DB": {
        "msgType": "DB",
        "addedEP": "146",
        "category": {
            "FIXMLFileName": "partiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "section": "PreTrade",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "added": "FIX.5.0SP2",
        "name": "PartyEntitlementsDefinitionRequestAck",
        "id": "138",
        "abbrName": "PtyEntlmntDefReqAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1770",
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "129",
                    "added": "FIX.5.0SP2",
                    "name": "EntitlementRequestID",
                    "id": "1770",
                    "abbrName": "ReqID",
                    "description": "Unique identifier for PartyEntitlementsRequest(35=CU)."
                }
            },
            {
                "id": "1882",
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "presence": "required",
                "data": {
                    "type": "PartyDetailRequestStatusCodeSet",
                    "addedEP": "146",
                    "added": "FIX.5.0SP2",
                    "name": "EntitlementRequestStatus",
                    "id": "1882",
                    "abbrName": "ReqStat",
                    "description": "Status of party entitlements definition request."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "146",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyEntitlementsDefinitionRequestAck(35=DB) is used as a response to the PartyEntitlemensDefinitionRequest(35=DA) to accept (with or without changes) or reject the definition of party entitlements."
    },
    "DC": {
        "msgType": "DC",
        "addedEP": "150",
        "category": {
            "FIXMLFileName": "tradecapture",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "TradeCapture"
        },
        "added": "FIX.5.0SP2",
        "name": "TradeMatchReport",
        "id": "139",
        "abbrName": "TrdMtchRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "150",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "880",
                "added": "FIX.5.0SP2",
                "addedEP": "150",
                "presence": "required",
                "data": {
                    "type": "String",
                    "updated": "FIX.Latest",
                    "updatedEP": "279",
                    "added": "FIX.4.4",
                    "name": "TrdMatchID",
                    "id": "880",
                    "abbrName": "MtchID",
                    "description": "Identifier assigned by a matching system to a match event that results in multiple executions or trades."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "150",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The TradeMatchReport(35=DC) message is used by exchanges and ECN’s to report matched trades to central counterparties (CCPs) as an atomic event. The message is used to express the one-to-one, one-to-many and many-to-many matches as well as implied matches in which more complex instruments can match with simpler instruments."
    },
    "DD": {
        "msgType": "DD",
        "addedEP": "150",
        "category": {
            "FIXMLFileName": "tradecapture",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "TradeCapture"
        },
        "added": "FIX.5.0SP2",
        "name": "TradeMatchReportAck",
        "id": "140",
        "abbrName": "TrdMtchRptAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "150",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "880",
                "added": "FIX.5.0SP2",
                "addedEP": "150",
                "presence": "required",
                "data": {
                    "type": "String",
                    "updated": "FIX.Latest",
                    "updatedEP": "279",
                    "added": "FIX.4.4",
                    "name": "TrdMatchID",
                    "id": "880",
                    "abbrName": "MtchID",
                    "description": "Identifier assigned by a matching system to a match event that results in multiple executions or trades."
                }
            },
            {
                "id": "1896",
                "added": "FIX.5.0SP2",
                "addedEP": "150",
                "presence": "required",
                "data": {
                    "type": "TradeMatchAckStatusCodeSet",
                    "addedEP": "150",
                    "added": "FIX.5.0SP2",
                    "name": "TradeMatchAckStatus",
                    "id": "1896",
                    "abbrName": "MtchAckStat",
                    "description": "Used to indicate the status of the trade match report submission."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "150",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The TradeMatchReportAck(35=DD) is used to respond to theTradeMatchReport(35=DC) message. It may be used to report on the status of the request (e.g. accepting the request or rejecting the request)."
    },
    "DE": {
        "msgType": "DE",
        "addedEP": "171",
        "category": {
            "FIXMLFileName": "partiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "105",
            "section": "PreTrade",
            "added": "FIX.5.0SP2",
            "name": "PartiesReferenceData"
        },
        "added": "FIX.5.0SP2",
        "name": "PartyRiskLimitsReportAck",
        "id": "141",
        "abbrName": "PtyRiskLmtRptAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1667",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "105",
                    "added": "FIX.5.0SP2",
                    "name": "RiskLimitReportID",
                    "id": "1667",
                    "abbrName": "RptID",
                    "description": "Identifier for the PartyRiskLimitsReport"
                }
            },
            {
                "id": "2316",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "RiskLimitReportStatusCodeSet",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "name": "RiskLimitReportStatus",
                    "id": "2316",
                    "abbrName": "RptStat",
                    "description": "Status of risk limit report."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "PartyRiskLimitsReportAck is an optional message used as a response to the PartyRiskLimitReport(35=CM) or PartyRiskLimitUpdateReport(35=CR) messages to acknowledge or reject those messages."
    },
    "DF": {
        "msgType": "DF",
        "addedEP": "171",
        "category": {
            "FIXMLFileName": "partiesaction",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "171",
            "section": "PreTrade",
            "added": "FIX.5.0SP2",
            "name": "PartiesAction",
            "description": "The PartiesAction category of messages is a set of messages that are used to take an action on party information as a result of risk management decisions made during the trading day."
        },
        "added": "FIX.5.0SP2",
        "name": "PartyRiskLimitCheckRequest",
        "id": "142",
        "abbrName": "PtyRiskLmtChkReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "2320",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "RiskLimitCheckTransTypeCodeSet",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "name": "RiskLimitCheckTransType",
                    "id": "2320",
                    "abbrName": "TransTyp",
                    "description": "Specifies the transaction type of the risk limit check request."
                }
            },
            {
                "id": "2321",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "RiskLimitCheckTypeCodeSet",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "name": "RiskLimitCheckType",
                    "id": "2321",
                    "abbrName": "ChkTyp",
                    "description": "Specifies the type of limit check message."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "PartyRiskLimitCheckRequest is used to request for approval of credit or risk limit amount intended to be used by a party in a transaction from another party that holds the information."
    },
    "DG": {
        "msgType": "DG",
        "addedEP": "171",
        "category": {
            "FIXMLFileName": "partiesaction",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "171",
            "section": "PreTrade",
            "added": "FIX.5.0SP2",
            "name": "PartiesAction",
            "description": "The PartiesAction category of messages is a set of messages that are used to take an action on party information as a result of risk management decisions made during the trading day."
        },
        "added": "FIX.5.0SP2",
        "name": "PartyRiskLimitCheckRequestAck",
        "id": "143",
        "abbrName": "PtyRiskLmtChkReqAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "2320",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "RiskLimitCheckTransTypeCodeSet",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "name": "RiskLimitCheckTransType",
                    "id": "2320",
                    "abbrName": "TransTyp",
                    "description": "Specifies the transaction type of the risk limit check request."
                }
            },
            {
                "id": "2321",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "RiskLimitCheckTypeCodeSet",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "name": "RiskLimitCheckType",
                    "id": "2321",
                    "abbrName": "ChkTyp",
                    "description": "Specifies the type of limit check message."
                }
            },
            {
                "id": "2325",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "RiskLimitCheckRequestStatusCodeSet",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "name": "RiskLimitCheckRequestStatus",
                    "id": "2325",
                    "abbrName": "ReqStat",
                    "description": "Indicates the status of the risk limit check request."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "PartyRiskLimitCheckRequestAck is used to acknowledge a PartyRiskLimitCheckRequest(35=DF) message and to respond whether the limit check request was approved or not. When used to accept the PartyRiskLimitCheckRequest(35=DF) message the Respondent may also include the limit amount that was approved."
    },
    "DH": {
        "updated": "FIX.5.0SP2",
        "msgType": "DH",
        "addedEP": "171",
        "updatedEP": "182",
        "category": {
            "FIXMLFileName": "partiesaction",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "171",
            "section": "PreTrade",
            "added": "FIX.5.0SP2",
            "name": "PartiesAction",
            "description": "The PartiesAction category of messages is a set of messages that are used to take an action on party information as a result of risk management decisions made during the trading day."
        },
        "added": "FIX.5.0SP2",
        "name": "PartyActionRequest",
        "id": "144",
        "abbrName": "PtyActReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "addedEP": "171",
                "updatedEP": "182",
                "added": "FIX.5.0SP2",
                "id": "1012",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Parties",
                    "id": "1012",
                    "abbrName": "Pty",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "id": "2328",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "name": "PartyActionRequestID",
                    "id": "2328",
                    "abbrName": "ActnReqID",
                    "description": "The unique identifier of the PartyActionRequest(35=DH) message."
                }
            },
            {
                "id": "2329",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "PartyActionTypeCodeSet",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "name": "PartyActionType",
                    "id": "2329",
                    "abbrName": "ActnTyp",
                    "description": "Specifies the type of action to take or was taken for a given party."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The PartyActionRequest message is used suspend or halt the specified party from further trading activities at the Respondent. The Respondent must respond with a PartyActionReport(35=DI) message."
    },
    "DI": {
        "updated": "FIX.5.0SP2",
        "msgType": "DI",
        "addedEP": "171",
        "updatedEP": "182",
        "category": {
            "FIXMLFileName": "partiesaction",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "171",
            "section": "PreTrade",
            "added": "FIX.5.0SP2",
            "name": "PartiesAction",
            "description": "The PartiesAction category of messages is a set of messages that are used to take an action on party information as a result of risk management decisions made during the trading day."
        },
        "added": "FIX.5.0SP2",
        "name": "PartyActionReport",
        "id": "145",
        "abbrName": "PtyActRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updated": "FIX.5.0SP2",
                "addedEP": "171",
                "updatedEP": "182",
                "added": "FIX.5.0SP2",
                "id": "1012",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Parties",
                    "id": "1012",
                    "abbrName": "Pty",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "id": "2329",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "PartyActionTypeCodeSet",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "name": "PartyActionType",
                    "id": "2329",
                    "abbrName": "ActnTyp",
                    "description": "Specifies the type of action to take or was taken for a given party."
                }
            },
            {
                "id": "2331",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "name": "PartyActionReportID",
                    "id": "2331",
                    "abbrName": "ActnRptID",
                    "description": "The unique identifier of the PartyActionReport(35=DI) message as assigned by the message sender."
                }
            },
            {
                "id": "2332",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "PartyActionResponseCodeSet",
                    "addedEP": "171",
                    "added": "FIX.5.0SP2",
                    "name": "PartyActionResponse",
                    "id": "2332",
                    "abbrName": "ActnRsp",
                    "description": "Specifies the action taken as a result of the PartyActionType(2239) of the PartyActionRequest(35=DH) message."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "171",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "Used to respond to the PartyActionRequest(35=DH) message, indicating whether the request has been received, accepted or rejected. Can also be used in an unsolicited manner to report party actions, e.g. reinstatements after a manual intervention out of band."
    },
    "DJ": {
        "msgType": "DJ",
        "addedEP": "188",
        "category": {
            "FIXMLFileName": "ordermasshandling",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "OrderMassHandling"
        },
        "added": "FIX.5.0SP2",
        "name": "MassOrder",
        "id": "146",
        "abbrName": "MassOrder",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "188",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "2245",
                "added": "FIX.5.0SP2",
                "addedEP": "188",
                "presence": "required",
                "data": {
                    "type": "group",
                    "addedEP": "188",
                    "category": "OrderMassHandling",
                    "added": "FIX.5.0SP2",
                    "name": "OrderEntryGrp",
                    "id": "2245",
                    "abbrName": "OrderEntry",
                    "numInGroup": { "id": "2428", "added": "FIX.5.0SP2", "addedEP": "188" },
                    "description": "Group of order transactions across one or more instruments.\n\n"
                }
            },
            {
                "updated": "FIX.Latest",
                "addedEP": "188",
                "updatedEP": "271",
                "added": "FIX.5.0SP2",
                "id": "2423",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "188",
                    "added": "FIX.5.0SP2",
                    "name": "MassOrderRequestID",
                    "id": "2423",
                    "abbrName": "MassOrdReqID",
                    "description": "Unique message identifier for a mass order request as assigned by the submitter of the orders."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "188",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The MassOrder(35=DJ) message can be used to add, modify or delete multiple unrelated orders with a single message. Apart from clearing related attributes, only the key order attributes for high performance trading are available.\n\nThe behavior of individual orders within a MassOrder(35=DJ) may vary depending upon its attributes, e.g. OrdType(40) and TimeInForce(59). Individual orders may be modified or deleted/cancelled with single order messages such as OrderCancelReplaceRequest (35=G) and OrderCancelRequest(35=F). Each of the orders in the MassOrder(35=DJ) are to be treated as stand-alone individual orders."
    },
    "DK": {
        "msgType": "DK",
        "addedEP": "188",
        "category": {
            "FIXMLFileName": "ordermasshandling",
            "section": "Trade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "OrderMassHandling"
        },
        "added": "FIX.5.0SP2",
        "name": "MassOrderAck",
        "id": "147",
        "abbrName": "MassOrderAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "188",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1815",
                "added": "FIX.5.0SP2",
                "addedEP": "188",
                "presence": "required",
                "data": {
                    "type": "TradingCapacityCodeSet",
                    "addedEP": "131",
                    "added": "FIX.5.0SP2",
                    "name": "TradingCapacity",
                    "id": "1815",
                    "abbrName": "TrdgCpcty",
                    "description": "Designates the capacity in which the order is submitted for trading by the market participant."
                }
            },
            {
                "id": "2425",
                "added": "FIX.5.0SP2",
                "addedEP": "188",
                "presence": "required",
                "data": {
                    "type": "MassOrderRequestStatusCodeSet",
                    "addedEP": "188",
                    "added": "FIX.5.0SP2",
                    "name": "MassOrderRequestStatus",
                    "id": "2425",
                    "abbrName": "ReqStat",
                    "description": "Status of mass order request."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "188",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "Trade",
            "FIXMLFileName": "trade",
            "displayOrder": "2",
            "description": "Order handling and execution messages"
        },
        "description": "The mass order acknowledgement message is used to acknowledge the receipt of and the status for a MassOrder(35=DJ) message.\n\nThe content of the acknowledgement depends on the setting of the field OrderResponseLevel(2427) in the MassOrder(35=DJ) message. Only the order status is provided and not the immediate executions which would lead to ExecutionReport messages."
    },
    "DL": {
        "msgType": "DL",
        "addedEP": "189",
        "category": {
            "FIXMLFileName": "positions",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "PositionMaintenance"
        },
        "added": "FIX.5.0SP2",
        "name": "PositionTransferInstruction",
        "id": "148",
        "abbrName": "PosXferInstrctn",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "updated": "FIX.Latest",
                "addedEP": "189",
                "updatedEP": "271",
                "added": "FIX.5.0SP2",
                "id": "1012",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Parties",
                    "id": "1012",
                    "abbrName": "Pty",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "id": "1063",
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "presence": "required",
                "data": {
                    "type": "group",
                    "addedEP": "85",
                    "category": "Common",
                    "added": "FIX.5.0SP1",
                    "name": "TargetParties",
                    "id": "1063",
                    "abbrName": "TgtPty",
                    "numInGroup": { "id": "1461", "added": "FIX.5.0SP1", "addedEP": "85" },
                    "description": "\n\n"
                }
            },
            {
                "id": "2436",
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "189",
                    "added": "FIX.5.0SP2",
                    "name": "TransferInstructionID",
                    "id": "2436",
                    "abbrName": "InstID",
                    "description": "Unique identifier for the transfer instruction assigned by the submitter."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The PositionTransferInstruction(35=DL) is sent by clearing firms to CCPs to initiate position transfers, or to accept or decline position transfers."
    },
    "DM": {
        "msgType": "DM",
        "addedEP": "189",
        "category": {
            "FIXMLFileName": "positions",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "PositionMaintenance"
        },
        "added": "FIX.5.0SP2",
        "name": "PositionTransferInstructionAck",
        "id": "149",
        "abbrName": "PosXferInstrctnAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "2436",
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "189",
                    "added": "FIX.5.0SP2",
                    "name": "TransferInstructionID",
                    "id": "2436",
                    "abbrName": "InstID",
                    "description": "Unique identifier for the transfer instruction assigned by the submitter."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The PositionTransferInstructionAck(35=DM) is sent by CCPs to clearing firms to acknowledge position transfer instructions, and to report errors processing position transfer instructions.\n\nThe PositionTransferInstructionAck(35=DM) is intended to be a technical acknowledgment, not a business level acknowledgment which would instead be provided by the PositionTransferReport(35=DN) message. As such, TransferID(2437), a business level ID assigned by the CCP, need not be assigned when providing a technical acknowledgment to a new or rejected position transfer request."
    },
    "DN": {
        "msgType": "DN",
        "addedEP": "189",
        "category": {
            "FIXMLFileName": "positions",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "PositionMaintenance"
        },
        "added": "FIX.5.0SP2",
        "name": "PositionTransferReport",
        "id": "150",
        "abbrName": "PosXferRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1012",
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Parties",
                    "id": "1012",
                    "abbrName": "Pty",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "updated": "FIX.Latest",
                "addedEP": "189",
                "updatedEP": "271",
                "added": "FIX.5.0SP2",
                "id": "1063",
                "presence": "required",
                "data": {
                    "type": "group",
                    "addedEP": "85",
                    "category": "Common",
                    "added": "FIX.5.0SP1",
                    "name": "TargetParties",
                    "id": "1063",
                    "abbrName": "TgtPty",
                    "numInGroup": { "id": "1461", "added": "FIX.5.0SP1", "addedEP": "85" },
                    "description": "\n\n"
                }
            },
            {
                "id": "2437",
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "189",
                    "added": "FIX.5.0SP2",
                    "name": "TransferID",
                    "id": "2437",
                    "abbrName": "XferID",
                    "description": "The unique identifier assigned to the transfer entity once it is received, for example, by the CCP or the party governing the transfer process. Generally this same identifier for the transfer is used by all parties involved."
                }
            },
            {
                "id": "2438",
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "189",
                    "added": "FIX.5.0SP2",
                    "name": "TransferReportID",
                    "id": "2438",
                    "abbrName": "RptID",
                    "description": "Unique identifier for the transfer report message."
                }
            },
            {
                "id": "2439",
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "presence": "required",
                "data": {
                    "type": "TransferTransTypeCodeSet",
                    "addedEP": "189",
                    "added": "FIX.5.0SP2",
                    "name": "TransferTransType",
                    "id": "2439",
                    "abbrName": "TransTyp",
                    "description": "Indicates the type of transfer transaction."
                }
            },
            {
                "id": "2442",
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "presence": "required",
                "data": {
                    "type": "TransferStatusCodeSet",
                    "addedEP": "189",
                    "added": "FIX.5.0SP2",
                    "name": "TransferStatus",
                    "id": "2442",
                    "abbrName": "XferStat",
                    "description": "Status of the transfer."
                }
            },
            {
                "id": "2444",
                "added": "FIX.5.0SP2",
                "addedEP": "189",
                "presence": "required",
                "data": {
                    "type": "TransferReportTypeCodeSet",
                    "addedEP": "189",
                    "added": "FIX.5.0SP2",
                    "name": "TransferReportType",
                    "id": "2444",
                    "abbrName": "RptTyp",
                    "description": "Indicates the type of transfer report."
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "The PositionTransferReport(35=DN) is sent by CCPs to clearing firms indicating of positions that are to be transferred to the clearing firm, or to report on status of the transfer to the clearing firms involved in the transfer process."
    },
    "DO": {
        "msgType": "DO",
        "addedEP": "191",
        "category": {
            "FIXMLFileName": "marketdata",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "MarketData"
        },
        "added": "FIX.5.0SP2",
        "name": "MarketDataStatisticsRequest",
        "id": "151",
        "abbrName": "MDStatsReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "191",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "263",
                "added": "FIX.5.0SP2",
                "addedEP": "191",
                "presence": "required",
                "data": {
                    "type": "SubscriptionRequestTypeCodeSet",
                    "abbrName": "SubReqTyp",
                    "added": "FIX.4.2",
                    "name": "SubscriptionRequestType",
                    "id": "263",
                    "description": "Subscription Request Type"
                }
            },
            {
                "updated": "FIX.Latest",
                "addedEP": "191",
                "updatedEP": "271",
                "added": "FIX.5.0SP2",
                "id": "2248",
                "presence": "required",
                "data": {
                    "type": "group",
                    "addedEP": "191",
                    "category": "MarketData",
                    "added": "FIX.5.0SP2",
                    "name": "MDStatisticReqGrp",
                    "id": "2248",
                    "abbrName": "StatsReq",
                    "numInGroup": { "id": "2474", "added": "FIX.5.0SP2", "addedEP": "191" },
                    "description": "This component block is used within the MarketDataStatisticsRequest(35=DO) message to define a set of parameters describing the desired statistics.\n\n"
                }
            },
            {
                "id": "2452",
                "added": "FIX.5.0SP2",
                "addedEP": "191",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "191",
                    "added": "FIX.5.0SP2",
                    "name": "MDStatisticReqID",
                    "id": "2452",
                    "abbrName": "ReqID",
                    "description": "Message identifier for a statistics request."
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The MarketDataStatisticsRequest(35=DO) is used to request for statistical data. The simple form is to use an identifier (MDStatisticID(2475)) assigned by the market place which would denote a pre-defined statistical report. Alternatively, or also in addition, the request can define a number of parameters for the desired statistical information.\n\nThe resulting data set can be restricted to a specific market, market segment or pre-defined security list for which a single set of statistics will be returned. It is also possible to specify individual instruments or group of instruments by means of the component blocks Instrument, UndInstrmtGrp and InstrmtLegGrp.\n\nFields specified in the request are used as filter criteria to restrict the resulting data returned."
    },
    "DP": {
        "msgType": "DP",
        "addedEP": "191",
        "category": {
            "FIXMLFileName": "marketdata",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "MarketData"
        },
        "added": "FIX.5.0SP2",
        "name": "MarketDataStatisticsReport",
        "id": "152",
        "abbrName": "MDStatsRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "191",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "2249",
                "added": "FIX.5.0SP2",
                "addedEP": "191",
                "presence": "required",
                "data": {
                    "type": "group",
                    "addedEP": "191",
                    "category": "MarketData",
                    "added": "FIX.5.0SP2",
                    "name": "MDStatisticRptGrp",
                    "id": "2249",
                    "abbrName": "StatsRpt",
                    "numInGroup": { "id": "2474", "added": "FIX.5.0SP2", "addedEP": "191" },
                    "description": "This component block is used within the MarketDataStatisticsReport(35=DP) message to provide results together with the related set of parameters.\n\n"
                }
            },
            {
                "id": "2453",
                "added": "FIX.5.0SP2",
                "addedEP": "191",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "191",
                    "added": "FIX.5.0SP2",
                    "name": "MDStatisticRptID",
                    "id": "2453",
                    "abbrName": "RptID",
                    "description": "Message identifier for a statistics report."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "191",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The MarketDataStatisticsReport(35=DP) is used to provide unsolicited statistical information or in response to a specific request. Each report contains a set of statistics for a single entity which could be a market, a market segment, a security list or an instrument.\n\n"
    },
    "DQ": {
        "msgType": "DQ",
        "addedEP": "192",
        "category": {
            "FIXMLFileName": "collateral",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "CollateralManagement"
        },
        "added": "FIX.5.0SP2",
        "name": "CollateralReportAck",
        "id": "153",
        "abbrName": "CollRptAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "192",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "908",
                "added": "FIX.5.0SP2",
                "addedEP": "192",
                "presence": "required",
                "data": {
                    "type": "String",
                    "abbrName": "RptID",
                    "added": "FIX.4.4",
                    "name": "CollRptID",
                    "id": "908",
                    "description": "Collateral Report Identifier"
                }
            },
            {
                "id": "2488",
                "added": "FIX.5.0SP2",
                "addedEP": "192",
                "presence": "required",
                "data": {
                    "type": "CollRptStatusCodeSet",
                    "addedEP": "192",
                    "added": "FIX.5.0SP2",
                    "name": "CollRptStatus",
                    "id": "2488",
                    "abbrName": "RptStat",
                    "description": "The status of the collateral report."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "192",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "CollateralReportAck(35=DQ) is used as a response to the CollateralReport(35=BA). It can be used to reject a CollateralReport(35=BA) when the content of the report is invalid based on the business rules of the receiver. The message may also be used to acknowledge receipt of a valid CollateralReport(35=BA)."
    },
    "DR": {
        "msgType": "DR",
        "addedEP": "195",
        "category": {
            "FIXMLFileName": "marketdata",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "MarketData"
        },
        "added": "FIX.5.0SP2",
        "name": "MarketDataReport",
        "id": "154",
        "abbrName": "MktDataRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "195",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "2535",
                "added": "FIX.5.0SP2",
                "addedEP": "195",
                "presence": "required",
                "data": {
                    "type": "MDReportEventCodeSet",
                    "addedEP": "195",
                    "added": "FIX.5.0SP2",
                    "name": "MDReportEvent",
                    "id": "2535",
                    "abbrName": "MDRptEvent",
                    "description": "Technical event within market data feed."
                }
            },
            {
                "id": "2536",
                "added": "FIX.5.0SP2",
                "addedEP": "195",
                "presence": "required",
                "data": {
                    "type": "int",
                    "addedEP": "195",
                    "added": "FIX.5.0SP2",
                    "name": "MDReportCount",
                    "id": "2536",
                    "abbrName": "MDRptCnt",
                    "description": "Number of reference and market data messages in-between two MarketDataReport(35=DR) messages."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "195",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The MarketDataReport(35=DR) message is used to provide delimiting references (e.g. start and end markers in a continuous broadcast) and details about the number of market data messages sent in a given distribution cycle.\n\nThe message can be used when distributing reference and market data on an ongoing basis to convey start and end points for synchronization. The report contains multiple message counters that are provided at the beginning or end of a cycle."
    },
    "DS": {
        "msgType": "DS",
        "addedEP": "223",
        "category": {
            "FIXMLFileName": "indications",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "Indication"
        },
        "added": "FIX.5.0SP2",
        "name": "CrossRequest",
        "id": "155",
        "abbrName": "CrssReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "223",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "2672",
                "added": "FIX.5.0SP2",
                "addedEP": "223",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "223",
                    "added": "FIX.5.0SP2",
                    "name": "CrossRequestID",
                    "id": "2672",
                    "abbrName": "CrssReqID",
                    "description": "Unique message identifier for a cross request as assigned by the submitter of the request."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "223",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.5.0SP2",
                "addedEP": "223",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The CrossRequest(35=DS) message is used to indicate the submission of orders or quotes that may result in a crossed trade.\n\nRegulatory requirements can allow exchanges to match orders belonging to the same account, firm or other common attribute. This can include the requirement to first announce the intention to cross orders. The time permitted between the announcement and the actual cross is typically well defined and may depend on the maximum quantity announced."
    },
    "DT": {
        "msgType": "DT",
        "addedEP": "223",
        "category": {
            "FIXMLFileName": "indications",
            "section": "PreTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "Indication"
        },
        "added": "FIX.5.0SP2",
        "name": "CrossRequestAck",
        "id": "156",
        "abbrName": "CrssReqAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "223",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "2672",
                "added": "FIX.5.0SP2",
                "addedEP": "223",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "223",
                    "added": "FIX.5.0SP2",
                    "name": "CrossRequestID",
                    "id": "2672",
                    "abbrName": "CrssReqID",
                    "description": "Unique message identifier for a cross request as assigned by the submitter of the request."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "223",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.5.0SP2",
                "addedEP": "223",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "The CrossRequestAck(35=DT) message is used to confirm the receipt of a CrossRequest(35=DS) message."
    },
    "DU": {
        "msgType": "DU",
        "addedEP": "239",
        "category": {
            "FIXMLFileName": "allocation",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "Allocation"
        },
        "added": "FIX.5.0SP2",
        "name": "AllocationInstructionAlertRequest",
        "id": "157",
        "abbrName": "AllocInstrAlertReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "239",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "239",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "This message is used in a clearinghouse 3-party allocation model to request for AllocationInstructionAlert(35=BM) from the clearinghouse. The request may be used to obtain a one-time notification of the status of an allocation group."
    },
    "DV": {
        "msgType": "DV",
        "addedEP": "241",
        "category": {
            "FIXMLFileName": "allocation",
            "section": "PostTrade",
            "includeFile": "components",
            "componentType": "Message",
            "name": "Allocation"
        },
        "added": "FIX.5.0SP2",
        "name": "AllocationInstructionAlertRequestAck",
        "id": "158",
        "abbrName": "AllocInstrctnAlertReqAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "241",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "2758",
                "added": "FIX.5.0SP2",
                "addedEP": "241",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "239",
                    "added": "FIX.5.0SP2",
                    "name": "AllocRequestID",
                    "id": "2758",
                    "abbrName": "ReqID",
                    "description": "Unique identifier for the request message."
                }
            },
            {
                "id": "2768",
                "added": "FIX.5.0SP2",
                "addedEP": "241",
                "presence": "required",
                "data": {
                    "type": "AllocRequestStatusCodeSet",
                    "addedEP": "241",
                    "added": "FIX.5.0SP2",
                    "name": "AllocRequestStatus",
                    "id": "2768",
                    "abbrName": "ReqStat",
                    "description": "Status of the AllocationInstructionAlertRequest(35=DU)."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "241",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "This message is used in a clearinghouse 3-party allocation model to acknowledge a AllocationInstructionAlertRequest(35=DU) message for an AllocationInstructionAlert(35=BM) message from the clearinghouse."
    },
    "DW": {
        "msgType": "DW",
        "addedEP": "247",
        "category": {
            "FIXMLFileName": "trademanagement",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "247",
            "section": "PostTrade",
            "added": "FIX.5.0SP2",
            "name": "TradeManagement"
        },
        "added": "FIX.5.0SP2",
        "name": "TradeAggregationRequest",
        "id": "159",
        "abbrName": "TrdAggrtnReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "247",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "54",
                "added": "FIX.5.0SP2",
                "addedEP": "247",
                "presence": "required",
                "data": {
                    "type": "SideCodeSet",
                    "abbrName": "Side",
                    "added": "FIX.2.7",
                    "name": "Side",
                    "id": "54",
                    "description": "Side of order (see Volume : \"Glossary\" for value definitions)"
                }
            },
            {
                "id": "2786",
                "added": "FIX.5.0SP2",
                "addedEP": "247",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "247",
                    "added": "FIX.5.0SP2",
                    "name": "TradeAggregationRequestID",
                    "id": "2786",
                    "abbrName": "ReqID",
                    "description": "The message identifier for the trade aggregation request."
                }
            },
            {
                "id": "2788",
                "added": "FIX.5.0SP2",
                "addedEP": "247",
                "presence": "required",
                "data": {
                    "type": "TradeAggregationTransTypeCodeSet",
                    "addedEP": "247",
                    "added": "FIX.5.0SP2",
                    "name": "TradeAggregationTransType",
                    "id": "2788",
                    "abbrName": "TransTyp",
                    "description": "Identifies the trade aggregation transaction type."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "247",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "1003",
                "added": "FIX.5.0SP2",
                "addedEP": "247",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Instrument",
                    "id": "1003",
                    "abbrName": "Instrmt",
                    "description": "The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "TradeAggregationRequest(35=DW) is used to request that the identified trades between the initiator and respondent be aggregated together for further processing."
    },
    "DX": {
        "msgType": "DX",
        "addedEP": "247",
        "category": {
            "FIXMLFileName": "trademanagement",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "247",
            "section": "PostTrade",
            "added": "FIX.5.0SP2",
            "name": "TradeManagement"
        },
        "added": "FIX.5.0SP2",
        "name": "TradeAggregationReport",
        "id": "160",
        "abbrName": "TrdAggrtnRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "247",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "2790",
                "added": "FIX.5.0SP2",
                "addedEP": "247",
                "presence": "required",
                "data": {
                    "type": "TradeAggregationRequestStatusCodeSet",
                    "addedEP": "247",
                    "added": "FIX.5.0SP2",
                    "name": "TradeAggregationRequestStatus",
                    "id": "2790",
                    "abbrName": "ReqStat",
                    "description": "Status of the trade aggregation request."
                }
            },
            {
                "id": "2792",
                "added": "FIX.5.0SP2",
                "addedEP": "247",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "247",
                    "added": "FIX.5.0SP2",
                    "name": "TradeAggregationReportID",
                    "id": "2792",
                    "abbrName": "RptID",
                    "description": "Unique identifier for the TradeAggregationReport(35=DX)."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "247",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "TradeAggregationReport(35=DX) is used to respond to the TradeAggregationRequest(35=DW) message. It provides the status of the request (e.g. accepted or rejected) and may also provide additional information supplied by the respondent."
    },
    "EA": {
        "msgType": "EA",
        "addedEP": "249",
        "category": {
            "FIXMLFileName": "paymgt",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "249",
            "section": "PostTrade",
            "added": "FIX.5.0SP2",
            "name": "PayManagement",
            "description": "Messages used to initiate and confirm expected or future payments to be made or received related to servicing of contracts or transactions after trade settlement. These messages are not intended to instruct or initiate remittance of funds transfers with banks."
        },
        "added": "FIX.5.0SP2",
        "name": "PayManagementReport",
        "id": "161",
        "abbrName": "PayMgmtRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "60",
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "2799",
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "249",
                    "added": "FIX.5.0SP2",
                    "name": "PayReportID",
                    "id": "2799",
                    "abbrName": "RptID",
                    "description": "Unique ID of the PayManagementReport(35=EA) message."
                }
            },
            {
                "id": "2804",
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "presence": "required",
                "data": {
                    "type": "PayReportTransTypeCodeSet",
                    "addedEP": "249",
                    "added": "FIX.5.0SP2",
                    "name": "PayReportTransType",
                    "id": "2804",
                    "abbrName": "TxnTyp",
                    "description": "Identifies the message transaction type."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "2265",
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "presence": "required",
                "data": {
                    "type": "component",
                    "addedEP": "249",
                    "category": "PayManagement",
                    "added": "FIX.5.0SP2",
                    "name": "PostTradePayment",
                    "id": "2265",
                    "abbrName": "PostTrdPmt",
                    "fieldRef": [
                        {
                            "id": "2824",
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "presence": "required",
                            "description": "",
                            "name": "PostTradePaymentType"
                        },
                        {
                            "id": "2817",
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "presence": "required",
                            "description": "",
                            "name": "PostTradePaymentAmount"
                        },
                        {
                            "id": "2825",
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "presence": "required",
                            "description": "The date payment calculations are made. This may be earlier than the date in ClearingBusinessDate(715).\n\nWhen the report is sent unsolicited, this is the payment calculation date as determined by report sender.",
                            "name": "PostTradePaymentCalculationDate"
                        },
                        {
                            "id": "2826",
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "presence": "required",
                            "description": "The date the payment is legally confirmed to settle.",
                            "name": "PostTradePaymentValueDate"
                        },
                        {
                            "id": "2819",
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "presence": "required",
                            "description": "",
                            "name": "PostTradePaymentDebitOrCredit"
                        },
                        {
                            "id": "2816",
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "presence": "required",
                            "description": "",
                            "name": "PostTradePaymentAccount"
                        }
                    ],
                    "description": "This component specifies the details of a payment between the parties involved.\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "PayManagementReport(35=EA) may be used to respond to the PayManagementRequest(35=DY) message. It provides the status of the request (e.g. accepted, disputed) and may provide additional information related to the request.\n\nPayManagementReport(35=EA) may also be sent unsolicited by the broker to a client. In which case the client may acknowledge and resolve disputes out-of-band or with a simple PayManagementReportAck(35=EB).\n\nPayManagementReport(35=EA) may also be sent unsolicited to report the progress status of the payment itself with PayReportTransType(2804)=2 (Status).\n\nIt should be noted that this message, in the context of operational communication between investment managers and their brokers, is intended to agree and confirm on payment(s) to be made or received during the life of a contract."
    },
    "EB": {
        "msgType": "EB",
        "addedEP": "249",
        "category": {
            "FIXMLFileName": "paymgt",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "249",
            "section": "PostTrade",
            "added": "FIX.5.0SP2",
            "name": "PayManagement",
            "description": "Messages used to initiate and confirm expected or future payments to be made or received related to servicing of contracts or transactions after trade settlement. These messages are not intended to instruct or initiate remittance of funds transfers with banks."
        },
        "added": "FIX.5.0SP2",
        "name": "PayManagementReportAck",
        "id": "162",
        "abbrName": "PayMgmtRptAck",
        "structure": [
            {
                "id": "2799",
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "249",
                    "added": "FIX.5.0SP2",
                    "name": "PayReportID",
                    "id": "2799",
                    "abbrName": "RptID",
                    "description": "Unique ID of the PayManagementReport(35=EA) message."
                }
            },
            {
                "id": "2806",
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "presence": "required",
                "data": {
                    "type": "PayReportStatusCodeSet",
                    "addedEP": "249",
                    "added": "FIX.5.0SP2",
                    "name": "PayReportStatus",
                    "id": "2806",
                    "abbrName": "RptStat",
                    "description": "Identifies status of the payment report."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "PayManagementReportAck(35=EB) is used as a response to the PayManagementReport(35=EA) message. It may be used to accept, reject or dispute the details of the PayManagementReport(35=EA) depending on the business rules of the receiver. This message may also be used to acknowledge the receipt of a PayManagementReport(35=EA) message."
    },
    "DY": {
        "msgType": "DY",
        "addedEP": "249",
        "category": {
            "FIXMLFileName": "paymgt",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "249",
            "section": "PostTrade",
            "added": "FIX.5.0SP2",
            "name": "PayManagement",
            "description": "Messages used to initiate and confirm expected or future payments to be made or received related to servicing of contracts or transactions after trade settlement. These messages are not intended to instruct or initiate remittance of funds transfers with banks."
        },
        "added": "FIX.5.0SP2",
        "name": "PayManagementRequest",
        "id": "163",
        "abbrName": "PayMgmtReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "60",
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "2811",
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "presence": "required",
                "data": {
                    "type": "PayRequestTransTypeCodeSet",
                    "addedEP": "249",
                    "added": "FIX.5.0SP2",
                    "name": "PayRequestTransType",
                    "id": "2811",
                    "abbrName": "TxnTyp",
                    "description": "Identifies the message transaction type."
                }
            },
            {
                "id": "2812",
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "249",
                    "added": "FIX.5.0SP2",
                    "name": "PayRequestID",
                    "id": "2812",
                    "abbrName": "ReqID",
                    "description": "Unique ID of the PayManagementRequest(35=DY) message."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            },
            {
                "id": "2265",
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "presence": "required",
                "data": {
                    "type": "component",
                    "addedEP": "249",
                    "category": "PayManagement",
                    "added": "FIX.5.0SP2",
                    "name": "PostTradePayment",
                    "id": "2265",
                    "abbrName": "PostTrdPmt",
                    "fieldRef": [
                        {
                            "id": "2824",
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "presence": "required",
                            "description": "",
                            "name": "PostTradePaymentType"
                        },
                        {
                            "id": "2817",
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "presence": "required",
                            "description": "",
                            "name": "PostTradePaymentAmount"
                        },
                        {
                            "id": "2825",
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "presence": "required",
                            "description": "The date payment calculations are made. This may be earlier than the date in ClearingBusinessDate(715).\n\nWhen the report is sent unsolicited, this is the payment calculation date as determined by report sender.",
                            "name": "PostTradePaymentCalculationDate"
                        },
                        {
                            "id": "2826",
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "presence": "required",
                            "description": "The date the payment is legally confirmed to settle.",
                            "name": "PostTradePaymentValueDate"
                        },
                        {
                            "id": "2819",
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "presence": "required",
                            "description": "",
                            "name": "PostTradePaymentDebitOrCredit"
                        },
                        {
                            "id": "2816",
                            "added": "FIX.5.0SP2",
                            "addedEP": "249",
                            "presence": "required",
                            "description": "",
                            "name": "PostTradePaymentAccount"
                        }
                    ],
                    "description": "This component specifies the details of a payment between the parties involved.\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "PayManagementRequest(35=DY) message is used to communicate a future or expected payment to be made or received related to a trade or contract after its settlement.\n\nIt should be noted that this message, in the context of operational communication between investment managers and their brokers, is intended to agree and confirm on payment(s) to be made or received during the life of a contract."
    },
    "DZ": {
        "msgType": "DZ",
        "addedEP": "249",
        "category": {
            "FIXMLFileName": "paymgt",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "249",
            "section": "PostTrade",
            "added": "FIX.5.0SP2",
            "name": "PayManagement",
            "description": "Messages used to initiate and confirm expected or future payments to be made or received related to servicing of contracts or transactions after trade settlement. These messages are not intended to instruct or initiate remittance of funds transfers with banks."
        },
        "added": "FIX.5.0SP2",
        "name": "PayManagementRequestAck",
        "id": "164",
        "abbrName": "PayMgmtReqAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "2812",
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "249",
                    "added": "FIX.5.0SP2",
                    "name": "PayRequestID",
                    "id": "2812",
                    "abbrName": "ReqID",
                    "description": "Unique ID of the PayManagementRequest(35=DY) message."
                }
            },
            {
                "updated": "FIX.Latest",
                "addedEP": "249",
                "updatedEP": "282",
                "added": "FIX.5.0SP2",
                "id": "2813",
                "presence": "required",
                "data": {
                    "type": "PayRequestStatusCodeSet",
                    "addedEP": "249",
                    "added": "FIX.5.0SP2",
                    "name": "PayRequestStatus",
                    "id": "2813",
                    "abbrName": "ReqStat",
                    "description": "Identifies status of the request being responded to."
                }
            },
            {
                "id": "1025",
                "added": "FIX.5.0SP2",
                "addedEP": "249",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "PayManagementRequestAck(35=DZ) is used to acknowledge the receipt of the PayManagementRequest(35=DY) message (i.e. a technical acknowledgement of receipt). Acceptance or rejection of the request is reported in the corresponding PayManagementReport(35=EA)."
    },
    "EC": {
        "msgType": "EC",
        "addedEP": "281",
        "category": {
            "FIXMLFileName": "settlstatmgmt",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "281",
            "section": "PostTrade",
            "added": "FIX.Latest",
            "name": "SettlementStatusManagement",
            "description": "Messages used to request for or communicate securities settlement status once the settlement process has been initiated via existing industry norms. These messages are not intended to instruct or initiate securities settlement process."
        },
        "added": "FIX.Latest",
        "name": "SettlementStatusRequest",
        "id": "165",
        "abbrName": "SettlStatReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.Latest",
                "addedEP": "281",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "60",
                "added": "FIX.Latest",
                "addedEP": "281",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "263",
                "added": "FIX.Latest",
                "addedEP": "281",
                "presence": "required",
                "data": {
                    "type": "SubscriptionRequestTypeCodeSet",
                    "abbrName": "SubReqTyp",
                    "added": "FIX.4.2",
                    "name": "SubscriptionRequestType",
                    "id": "263",
                    "description": "Subscription Request Type"
                }
            },
            {
                "id": "2965",
                "added": "FIX.Latest",
                "addedEP": "281",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "281",
                    "added": "FIX.Latest",
                    "name": "SettlStatusRequestID",
                    "id": "2965",
                    "abbrName": "ReqID",
                    "description": "Unique identifier of the SettlementStatusRequest(35=EC)."
                }
            },
            {
                "id": "1025",
                "added": "FIX.Latest",
                "addedEP": "281",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "SettlementStatusRequest(35=EC) is used to request for the settlement status of a trade.\n\nWhere possible a trade reference or identifier should be provided, and if it is not possible it is recommended that as much of the trade details are provided in the request as possible. The trade details provided are not intended to serve as filter criteria but look-up criteria."
    },
    "ED": {
        "msgType": "ED",
        "addedEP": "281",
        "category": {
            "FIXMLFileName": "settlstatmgmt",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "281",
            "section": "PostTrade",
            "added": "FIX.Latest",
            "name": "SettlementStatusManagement",
            "description": "Messages used to request for or communicate securities settlement status once the settlement process has been initiated via existing industry norms. These messages are not intended to instruct or initiate securities settlement process."
        },
        "added": "FIX.Latest",
        "name": "SettlementStatusRequestAck",
        "id": "166",
        "abbrName": "SettlStatReqAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.Latest",
                "addedEP": "281",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "2965",
                "added": "FIX.Latest",
                "addedEP": "281",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "281",
                    "added": "FIX.Latest",
                    "name": "SettlStatusRequestID",
                    "id": "2965",
                    "abbrName": "ReqID",
                    "description": "Unique identifier of the SettlementStatusRequest(35=EC)."
                }
            },
            {
                "id": "2966",
                "added": "FIX.Latest",
                "addedEP": "281",
                "presence": "required",
                "data": {
                    "type": "SettlStatusRequestStatusCodeSet",
                    "addedEP": "281",
                    "added": "FIX.Latest",
                    "name": "SettlStatusRequestStatus",
                    "id": "2966",
                    "abbrName": "ReqStat",
                    "description": "Status of the SettlementStatusRequest(35=EC) message being responded to."
                }
            },
            {
                "id": "1025",
                "added": "FIX.Latest",
                "addedEP": "281",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "SettlementStatusRequestAck(35=ED) is used to respond to the SettlementStatusRequest(35=EC) to acknowledge the request and provide status for the request message.\n\nThis message is not used for communicating settlement status of a trade (see SettlementStatusReport(35=EE)); simply a status of the request message itself."
    },
    "EE": {
        "msgType": "EE",
        "addedEP": "281",
        "category": {
            "FIXMLFileName": "settlstatmgmt",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "281",
            "section": "PostTrade",
            "added": "FIX.Latest",
            "name": "SettlementStatusManagement",
            "description": "Messages used to request for or communicate securities settlement status once the settlement process has been initiated via existing industry norms. These messages are not intended to instruct or initiate securities settlement process."
        },
        "added": "FIX.Latest",
        "name": "SettlementStatusReport",
        "id": "167",
        "abbrName": "SettlStatRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.Latest",
                "addedEP": "281",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "60",
                "added": "FIX.Latest",
                "addedEP": "281",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "2967",
                "added": "FIX.Latest",
                "addedEP": "281",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "281",
                    "added": "FIX.Latest",
                    "name": "SettlStatusReportID",
                    "id": "2967",
                    "abbrName": "RptID",
                    "description": "Unique identifier of the SettlementStatusReport(35=EE)."
                }
            },
            {
                "id": "2968",
                "added": "FIX.Latest",
                "addedEP": "281",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "281",
                    "added": "FIX.Latest",
                    "name": "SettlStatus",
                    "id": "2968",
                    "abbrName": "SettlStat",
                    "description": "The settlement status of the identified trade.\n\nThis field mirrors MT548 subsequence A2 field 25D Status Code. See https://www.iso20022.org/15022/uhb/mt548-10-field-25d.htm for MT548 code values."
                }
            },
            {
                "id": "1025",
                "added": "FIX.Latest",
                "addedEP": "281",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "SettlementStatusReport(35=EE) is a response to the SettlementStatusRequest(35=EC) to provide settlement status for the requested trade. It may also be sent unsolicited without an explicit request message by the party able to provide the settlement status for the trade identified in the report message."
    },
    "EF": {
        "msgType": "EF",
        "addedEP": "281",
        "category": {
            "FIXMLFileName": "settlstatmgmt",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "281",
            "section": "PostTrade",
            "added": "FIX.Latest",
            "name": "SettlementStatusManagement",
            "description": "Messages used to request for or communicate securities settlement status once the settlement process has been initiated via existing industry norms. These messages are not intended to instruct or initiate securities settlement process."
        },
        "added": "FIX.Latest",
        "name": "SettlementStatusReportAck",
        "id": "168",
        "abbrName": "SettlStatRptAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.Latest",
                "addedEP": "281",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "2967",
                "added": "FIX.Latest",
                "addedEP": "281",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "281",
                    "added": "FIX.Latest",
                    "name": "SettlStatusReportID",
                    "id": "2967",
                    "abbrName": "RptID",
                    "description": "Unique identifier of the SettlementStatusReport(35=EE)."
                }
            },
            {
                "id": "2973",
                "added": "FIX.Latest",
                "addedEP": "281",
                "presence": "required",
                "data": {
                    "type": "SettlStatusReportStatusCodeSet",
                    "addedEP": "281",
                    "added": "FIX.Latest",
                    "name": "SettlStatusReportStatus",
                    "id": "2973",
                    "abbrName": "Stat",
                    "description": "Status of the report being responded to."
                }
            }
        ],
        "section": {
            "name": "PostTrade",
            "FIXMLFileName": "posttrade",
            "displayOrder": "3",
            "description": "Post trade messages including trade reporting, allocation, collateral, confirmation, position mantemenance, registration instruction, and settlement instructions"
        },
        "description": "SettlementStatusReportAck(35=EF) is used to respond to the SettlementStatusReport(35=EE) to acknowledge or reject the report."
    },
    "EG": {
        "msgType": "EG",
        "addedEP": "288",
        "category": {
            "FIXMLFileName": "securitiesreference",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "97",
            "section": "PreTrade",
            "added": "FIX.5.0SP1",
            "name": "SecuritiesReferenceData"
        },
        "added": "FIX.Latest",
        "name": "SecurityRiskMetricsReport",
        "id": "169",
        "abbrName": "SecRiskMtrcsRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.Latest",
                "addedEP": "288",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "2988",
                "added": "FIX.Latest",
                "addedEP": "288",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "288",
                    "added": "FIX.Latest",
                    "name": "SecurityRiskMetricsReportID",
                    "id": "2988",
                    "abbrName": "RptID",
                    "description": "Unique identifier for the SecurityRiskMetricsReport(35=EG) message."
                }
            },
            {
                "id": "1025",
                "added": "FIX.Latest",
                "addedEP": "288",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "SecurityRiskMetricsReport(35=EG) is used for publishing the risk metrics, valuation metrics or analytics of one or more securities, or for an option series."
    },
    "EH": {
        "msgType": "EH",
        "addedEP": "292",
        "category": {
            "FIXMLFileName": "testing",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "292",
            "section": "PreTrade",
            "added": "FIX.Latest",
            "name": "Testing",
            "description": "Messages used to request for or communicate information related to testing, e.g. algorithmic trading and related testing."
        },
        "added": "FIX.Latest",
        "name": "AlgoCertificateRequest",
        "id": "170",
        "abbrName": "AlgoCertReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "60",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "3014",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "AlgoCertificateRequestID",
                    "id": "3014",
                    "abbrName": "CertReqID",
                    "description": "Unique identifier of the AlgoCertificateRequest(35=EH)."
                }
            },
            {
                "id": "3016",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "AlgoCertificateRequestTransTypeCodeSet",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "AlgoCertificateRequestTransType",
                    "id": "3016",
                    "abbrName": "TxnTyp",
                    "description": "Identifies the message transaction type."
                }
            },
            {
                "id": "1025",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "AlgoCertificateRequest(35=EH) is used to request for algo testing certificate information for one or more algorithms.\n\nThis message may be used by venues to request algo test certificates from their participants using participant and algo identifiers as the request key. Absence of an identifier for an algorithm represents a request to obtain all active certificates for all algorithms from the participant."
    },
    "EI": {
        "msgType": "EI",
        "addedEP": "292",
        "category": {
            "FIXMLFileName": "testing",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "292",
            "section": "PreTrade",
            "added": "FIX.Latest",
            "name": "Testing",
            "description": "Messages used to request for or communicate information related to testing, e.g. algorithmic trading and related testing."
        },
        "added": "FIX.Latest",
        "name": "AlgoCertificateRequestAck",
        "id": "171",
        "abbrName": "AlgoCertReqAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "3014",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "AlgoCertificateRequestID",
                    "id": "3014",
                    "abbrName": "CertReqID",
                    "description": "Unique identifier of the AlgoCertificateRequest(35=EH)."
                }
            },
            {
                "id": "3017",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "AlgoCertificateRequestStatusCodeSet",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "AlgoCertificateRequestStatus",
                    "id": "3017",
                    "abbrName": "ReqStat",
                    "description": "Status of the AlgoCertificateRequest(35=EH) message being responded to."
                }
            },
            {
                "id": "1025",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "AlgoCertificateRequestAck(35=EI) is used to respond to the AlgoCertificateRequest(35=EH) to acknowledge the request and provide status for the request message.\n\nThis message is not used for communicating test certificates of algorithms (see AlgoCertificateReport(35=EJ)); simply a status of the request message itself."
    },
    "EJ": {
        "msgType": "EJ",
        "addedEP": "292",
        "category": {
            "FIXMLFileName": "testing",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "292",
            "section": "PreTrade",
            "added": "FIX.Latest",
            "name": "Testing",
            "description": "Messages used to request for or communicate information related to testing, e.g. algorithmic trading and related testing."
        },
        "added": "FIX.Latest",
        "name": "AlgoCertificateReport",
        "id": "172",
        "abbrName": "AlgoCertRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "779",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "abbrName": "LastUpdateTm",
                    "added": "FIX.4.4",
                    "name": "LastUpdateTime",
                    "id": "779",
                    "description": "Timestamp of last update to data item (or creation if no updates made since creation)."
                }
            },
            {
                "id": "1012",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "group",
                    "category": "Common",
                    "added": "FIX.4.3",
                    "name": "Parties",
                    "id": "1012",
                    "abbrName": "Pty",
                    "numInGroup": { "id": "453", "added": "FIX.4.3" },
                    "description": "The Parties component block is used to identify and convey information on the entities both central and peripheral to the financial transaction represented by the FIX message containing the Parties Block. The Parties block allows many different types of entites to be expressed through use of the PartyRole field and identifies the source of the PartyID through the the PartyIDSource.\n\n"
                }
            },
            {
                "id": "3012",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "AlgoCertificateID",
                    "id": "3012",
                    "abbrName": "CertID",
                    "description": "Unique identifier for a certificate issued by an algorithmic trading firm."
                }
            },
            {
                "id": "3018",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "AlgoCertificateReportID",
                    "id": "3018",
                    "abbrName": "CertRptID",
                    "description": "Unique identifier of the AlgoCertificateReport(35=EJ)."
                }
            },
            {
                "id": "3020",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "AlgoCertificateReportTransTypeCodeSet",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "AlgoCertificateReportTransType",
                    "id": "3020",
                    "abbrName": "TxnTyp",
                    "description": "Identifies the message transaction type."
                }
            },
            {
                "id": "3022",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "AlgoCertificateStatusCodeSet",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "AlgoCertificateStatus",
                    "id": "3022",
                    "abbrName": "CertStat",
                    "description": "Status of the certification as provided by the regulatory authority."
                }
            },
            {
                "id": "1025",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "AlgoCertificateReport(35=EJ) is a response to the AlgoCertificateRequest(35=EH) to certify an algo. It may also be sent unsolicited without an explicit request message by the party able to provide certificate information for the algo identified in the report message.\n\nAlgoCertificateReport(35=EJ) is for a single algorithm. A new certificate is created by the trading firm in a draft status and requires approval from a natural person who is authorized to approve certification. The final state is reached when the certificate has been successfully submitted to the venue. Timestamps may be associated with the state changes, specifically date and time of the latest change, the approval and when the certificate is to become effective."
    },
    "EK": {
        "msgType": "EK",
        "addedEP": "292",
        "category": {
            "FIXMLFileName": "testing",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "292",
            "section": "PreTrade",
            "added": "FIX.Latest",
            "name": "Testing",
            "description": "Messages used to request for or communicate information related to testing, e.g. algorithmic trading and related testing."
        },
        "added": "FIX.Latest",
        "name": "AlgoCertificateReportAck",
        "id": "173",
        "abbrName": "AlgoCertRptAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "3018",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "AlgoCertificateReportID",
                    "id": "3018",
                    "abbrName": "CertRptID",
                    "description": "Unique identifier of the AlgoCertificateReport(35=EJ)."
                }
            },
            {
                "id": "3021",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "AlgoCertificateReportStatusCodeSet",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "AlgoCertificateReportStatus",
                    "id": "3021",
                    "abbrName": "RptStat",
                    "description": "Status of the report being responded to."
                }
            },
            {
                "id": "1025",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "AlgoCertificateReportAck(35=EK) is used to respond to the AlgoCertificateReport(35=EJ) to acknowledge or reject the report message.\n\nAcknowledgement messages can also be used in response to unsolicited reports."
    },
    "EL": {
        "msgType": "EL",
        "addedEP": "292",
        "category": {
            "FIXMLFileName": "testing",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "292",
            "section": "PreTrade",
            "added": "FIX.Latest",
            "name": "Testing",
            "description": "Messages used to request for or communicate information related to testing, e.g. algorithmic trading and related testing."
        },
        "added": "FIX.Latest",
        "name": "TestSuiteDefinitionRequest",
        "id": "174",
        "abbrName": "TstSteDefReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "60",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "3062",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "TestSuiteRequestID",
                    "id": "3062",
                    "abbrName": "TstSteReqID",
                    "description": "Unique identifier of the TestSuiteDefinitionRequest(35=EL)."
                }
            },
            {
                "id": "3064",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "TestSuiteRequestTransTypeCodeSet",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "TestSuiteRequestTransType",
                    "id": "3064",
                    "abbrName": "TxnTyp",
                    "description": "Identifies the message transaction type."
                }
            },
            {
                "id": "1025",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "TestSuiteDefinitionRequest(35=EL) is used to convey to the test system the suite of test scenarios to perform.\n\nThis message stages on the test system the details of a test suite to run to test the algo. The test suite contains one or more test scenarios (i.e. test cases) along with the details for each test scenario."
    },
    "EM": {
        "msgType": "EM",
        "addedEP": "292",
        "category": {
            "FIXMLFileName": "testing",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "292",
            "section": "PreTrade",
            "added": "FIX.Latest",
            "name": "Testing",
            "description": "Messages used to request for or communicate information related to testing, e.g. algorithmic trading and related testing."
        },
        "added": "FIX.Latest",
        "name": "TestSuiteDefinitionRequestAck",
        "id": "175",
        "abbrName": "TstSteDefReqAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "3062",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "TestSuiteRequestID",
                    "id": "3062",
                    "abbrName": "TstSteReqID",
                    "description": "Unique identifier of the TestSuiteDefinitionRequest(35=EL)."
                }
            },
            {
                "id": "1025",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "TestSuiteDefinitionRequestAck(35=EM) is used to respond to the TestSuiteDefinitionRequest(35= EL) to acknowledge the request and provide status for the request message."
    },
    "EN": {
        "msgType": "EN",
        "addedEP": "292",
        "category": {
            "FIXMLFileName": "testing",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "292",
            "section": "PreTrade",
            "added": "FIX.Latest",
            "name": "Testing",
            "description": "Messages used to request for or communicate information related to testing, e.g. algorithmic trading and related testing."
        },
        "added": "FIX.Latest",
        "name": "TestActionRequest",
        "id": "176",
        "abbrName": "TstActnReq",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "60",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "UTCTimestamp",
                    "updated": "FIX.5.0SP1",
                    "updatedEP": "94",
                    "added": "FIX.2.7",
                    "name": "TransactTime",
                    "id": "60",
                    "abbrName": "TxnTm",
                    "description": "Timestamp when the business transaction represented by the message occurred."
                }
            },
            {
                "id": "3062",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "TestSuiteRequestID",
                    "id": "3062",
                    "abbrName": "TstSteReqID",
                    "description": "Unique identifier of the TestSuiteDefinitionRequest(35=EL)."
                }
            },
            {
                "id": "3066",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "TestActionRequestID",
                    "id": "3066",
                    "abbrName": "ReqID",
                    "description": "Unique identifier of the TestActionRequest(35=EN)."
                }
            },
            {
                "id": "3067",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "TestActionTypeCodeSet",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "TestActionType",
                    "id": "3067",
                    "abbrName": "ActnTyp",
                    "description": "Specifies the type of action to take or that was taken for a given test suite."
                }
            },
            {
                "id": "1025",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "TestActionRequest(35=EN) is used to manage test executions or request for testing activity state of the identified test suite.\n\nThis message is used to trigger the test system to start/stop the test suite staged on the test system via the TestSuiteDefinitionRequest(35=EL)."
    },
    "EO": {
        "msgType": "EO",
        "addedEP": "292",
        "category": {
            "FIXMLFileName": "testing",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "292",
            "section": "PreTrade",
            "added": "FIX.Latest",
            "name": "Testing",
            "description": "Messages used to request for or communicate information related to testing, e.g. algorithmic trading and related testing."
        },
        "added": "FIX.Latest",
        "name": "TestActionRequestAck",
        "id": "177",
        "abbrName": "TstActnReqAck",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "3062",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "TestSuiteRequestID",
                    "id": "3062",
                    "abbrName": "TstSteReqID",
                    "description": "Unique identifier of the TestSuiteDefinitionRequest(35=EL)."
                }
            },
            {
                "id": "3066",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "TestActionRequestID",
                    "id": "3066",
                    "abbrName": "ReqID",
                    "description": "Unique identifier of the TestActionRequest(35=EN)."
                }
            },
            {
                "id": "3068",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "TestActionRequestStatusCodeSet",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "TestActionRequestStatus",
                    "id": "3068",
                    "abbrName": "ReqStat",
                    "description": "Status of the TestActionRequest(35=EN) message being responded to."
                }
            },
            {
                "id": "3069",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "TestSuiteActivityStateCodeSet",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "TestSuiteActivityState",
                    "id": "3069",
                    "abbrName": "TstSteActvtySt",
                    "description": "Specifies the activity state the test suite is in."
                }
            },
            {
                "id": "1025",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "TestActionRequestAck(35=EO) is used to respond to the TestActionRequest(35=EN) to acknowledge the request and provide status for the request message."
    },
    "EP": {
        "msgType": "EP",
        "addedEP": "292",
        "category": {
            "FIXMLFileName": "testing",
            "includeFile": "components",
            "componentType": "Message",
            "addedEP": "292",
            "section": "PreTrade",
            "added": "FIX.Latest",
            "name": "Testing",
            "description": "Messages used to request for or communicate information related to testing, e.g. algorithmic trading and related testing."
        },
        "added": "FIX.Latest",
        "name": "TestActionReport",
        "id": "178",
        "abbrName": "TstActnRpt",
        "structure": [
            {
                "id": "1024",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "component",
                    "updated": "FIX.Latest",
                    "updatedEP": "271",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardHeader",
                    "id": "1024",
                    "abbrName": "Hdr",
                    "fieldRef": [
                        {
                            "id": "8",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "FIXT.1.1 (Always unencrypted, must be first field in message)",
                            "name": "BeginString"
                        },
                        {
                            "id": "9",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be second field in message)",
                            "name": "BodyLength"
                        },
                        {
                            "id": "35",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, must be third field in message)",
                            "name": "MsgType"
                        },
                        {
                            "id": "49",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "SenderCompID"
                        },
                        {
                            "id": "56",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted)",
                            "name": "TargetCompID"
                        },
                        {
                            "id": "34",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "MsgSeqNum"
                        },
                        {
                            "id": "52",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Can be embedded within encrypted data section.)",
                            "name": "SendingTime"
                        }
                    ],
                    "description": "The standard FIX message header\n\n"
                }
            },
            {
                "id": "3062",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "TestSuiteRequestID",
                    "id": "3062",
                    "abbrName": "TstSteReqID",
                    "description": "Unique identifier of the TestSuiteDefinitionRequest(35=EL)."
                }
            },
            {
                "id": "3071",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "String",
                    "addedEP": "292",
                    "added": "FIX.Latest",
                    "name": "TestActionReportID",
                    "id": "3071",
                    "abbrName": "RptID",
                    "description": "Identifier of the test action report."
                }
            },
            {
                "id": "1025",
                "added": "FIX.Latest",
                "addedEP": "292",
                "presence": "required",
                "data": {
                    "type": "component",
                    "category": "Session",
                    "added": "FIX.4.0",
                    "name": "StandardTrailer",
                    "id": "1025",
                    "abbrName": "Trlr",
                    "fieldRef": [
                        {
                            "id": "10",
                            "added": "FIX.4.0",
                            "presence": "required",
                            "description": "(Always unencrypted, always last field in message)",
                            "name": "CheckSum"
                        }
                    ],
                    "description": "The standard FIX message trailer\n\n"
                }
            }
        ],
        "section": {
            "updated": "FIX.Latest",
            "FIXMLFileName": "pretrade",
            "updatedEP": "271",
            "name": "PreTrade",
            "displayOrder": "1",
            "description": "Pre trade messages including reference data, market data, quoting, news and email, indication of interest."
        },
        "description": "TestActionReport(35=EP) is used to report the testing results of the identified test suite that has been executed with TestActionRequest(35=EN). In the context of algorithmic trading, the results may be used to create a certificate for the algorithm upon meeting the success criteria.\n\nTestActionReport(35=EP) may be sent in an unsolicited manner when the execution of a test suite successfully completes or abnormally terminates."
    }
}
